webpackJsonp([2],{

/***/ 1000:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1001:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1002:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1003:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1004:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1005:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1016:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1019:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1020:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1022:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1023:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1026:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1027:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1047:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1022)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(571),
  /* template */
  __webpack_require__(1079),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1048:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1026)
  __webpack_require__(1027)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(572),
  /* template */
  __webpack_require__(1083),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-eafbe53a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1049:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1020)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(573),
  /* template */
  __webpack_require__(1077),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a8adb366",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1050:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(574),
  /* template */
  __webpack_require__(1076),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1051:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(575),
  /* template */
  __webpack_require__(1084),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1052:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(576),
  /* template */
  __webpack_require__(1070),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1053:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(577),
  /* template */
  __webpack_require__(1082),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1054:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1016)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(578),
  /* template */
  __webpack_require__(1072),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-67adbd06",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1055:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1019)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(579),
  /* template */
  __webpack_require__(1075),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-79e3792d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1056:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1023)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(580),
  /* template */
  __webpack_require__(1080),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c098cfa6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 107:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__features_json__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__features_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__features_json__);



var CURRENT_TARGET = "deutscheBahn" || ["dev"];

var feature = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  computed: {
    currentTarget: function currentTarget() {
      return CURRENT_TARGET;
    },
    isTesting: function isTesting() {
      return CURRENT_TARGET.includes("test");
    },
    isAudiTarget: function isAudiTarget() {
      return CURRENT_TARGET.includes("audi");
    },
    isDBTarget: function isDBTarget() {
      return CURRENT_TARGET.includes("deutscheBahn");
    },
    isPorscheTarget: function isPorscheTarget() {
      return CURRENT_TARGET.includes("porsche");
    }
  },
  methods: {
    isEnabled: function isEnabled(name) {
      if (!__WEBPACK_IMPORTED_MODULE_1__features_json___default.a[name] || !__WEBPACK_IMPORTED_MODULE_1__features_json___default.a[name].target) {
        console.error("Unknown feature: " + name);
        return false;
      }

      var targets = __WEBPACK_IMPORTED_MODULE_1__features_json___default.a[name].target.split(" ");
      return targets.includes(CURRENT_TARGET);
    },
    isDisabled: function isDisabled(name) {
      return !this.isEnabled(name);
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (feature);

/***/ }),

/***/ 1070:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    class: {
      'text-red': _vm.Recommended && !_vm.value
    },
    attrs: {
      "for": ("input-shopper-custprop-" + _vm.Guid + "-" + _vm._uid)
    }
  }, [_vm._v("\n    " + _vm._s(_vm.Title) + "\n    "), (_vm.Recommended) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('Select2', {
    staticClass: "form-control",
    attrs: {
      "id": ("input-shopper-custprop-" + _vm.Guid + "-" + _vm._uid),
      "allowClear": true,
      "placeholder": ' ',
      "tags": _vm.AllowCustomValues,
      "value": _vm.value
    },
    on: {
      "change": _vm.updateValue,
      "beforeOpen": _vm.scrollIntoViewMobile,
      "close": function($event) {
        return _vm.selectClosed()
      }
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.ListValues), function(element) {
    return _c('option', {
      key: element.ValueGuid,
      domProps: {
        "value": element.ValueGuid
      }
    }, [_vm._v("\n        " + _vm._s(element.Value) + "\n      ")])
  })], 2)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1072:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "shopperProfileModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "id": "shopperProfileForm"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.SP1001))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "accordion",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingGeneral",
      "data-toggle": !_vm.globals.isMobileBrowser ? 'collapse' : '',
      "data-parent": "#accordion",
      "href": "#collapseGeneral",
      "aria-expanded": "true",
      "aria-controls": "collapseGeneral"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.SP1002))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "collapseGeneral",
      "role": "tabpanel",
      "aria-labelledby": "headingGeneral"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-xs-8 col-md-3 col-xs-push-2 col-md-push-9",
    attrs: {
      "id": "profilePictureContainer"
    },
    on: {
      "click": function($event) {
        return _vm.openFileSelector()
      }
    }
  }, [(_vm.shopperProfileData.ProfilePictureGuid) ? _c('img', {
    attrs: {
      "src": '/api/download/' +
        _vm.shopperProfileData.ProfilePictureGuid
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/avatar.png"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "form-control hidden",
    attrs: {
      "id": "inputShopperProfilePictureFile",
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onShopperProfilePictureFileChange,
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shopperProfileData.ProfilePictureGuid),
      expression: "shopperProfileData.ProfilePictureGuid"
    }],
    attrs: {
      "role": "button",
      "id": "removeProfilePictureButton"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.removeShopperProfilePictureFile()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("clear")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-md-9 col-md-pull-3"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputShopperSalutation"
    }
  }, [_vm._v(_vm._s(_vm.lang.SP1003))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shopperProfileData.Salutation),
      expression: "shopperProfileData.Salutation"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "inputShopperSalutation"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.shopperProfileData, "Salutation", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.SP1004) + "\n                        ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "F"
    }
  }, [_vm._v(_vm._s(_vm.lang.SP1005))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "M"
    }
  }, [_vm._v(_vm._s(_vm.lang.SP1006))])])])]), _vm._v(" "), _c('div', {
    staticClass: "\n                      form-group\n                      col-xs-12 col-md-9 col-md-pull-3\n                      noclearfix\n                    "
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputShopperFirstName"
    }
  }, [_vm._v(_vm._s(_vm.lang.SP1010) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shopperProfileData.FirstName),
      expression: "shopperProfileData.FirstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperFirstName",
      "required": ""
    },
    domProps: {
      "value": (_vm.shopperProfileData.FirstName)
    },
    on: {
      "change": function($event) {
        return _vm.validateInput('inputShopperFirstName')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shopperProfileData, "FirstName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperFirstName')),
      expression: "inputHasError('inputShopperFirstName')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SP1009))])])]), _vm._v(" "), _c('div', {
    staticClass: "\n                      form-group\n                      col-xs-12 col-md-9 col-md-pull-3\n                      noclearfix\n                    "
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputShopperLastName"
    }
  }, [_vm._v(_vm._s(_vm.lang.SP1011) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shopperProfileData.LastName),
      expression: "shopperProfileData.LastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperLastName",
      "required": ""
    },
    domProps: {
      "value": (_vm.shopperProfileData.LastName)
    },
    on: {
      "change": function($event) {
        return _vm.validateInput('inputShopperLastName')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shopperProfileData, "LastName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperLastName')),
      expression: "inputHasError('inputShopperLastName')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SP1009))])])]), _vm._v(" "), _c('div', {
    staticClass: "\n                      form-group\n                      col-xs-12 col-md-9 col-md-pull-3\n                      noclearfix\n                    "
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputShopperGender"
    }
  }, [_vm._v(_vm._s(_vm.lang.SP1029) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shopperProfileData.Gender),
      expression: "shopperProfileData.Gender"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "inputShopperGender",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.shopperProfileData, "Gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.validateInput('inputShopperGender')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.SP1004) + "\n                        ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "F"
    }
  }, [_vm._v(_vm._s(_vm.lang.SP1031))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "M"
    }
  }, [_vm._v(_vm._s(_vm.lang.SP1030))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "D"
    }
  }, [_vm._v(_vm._s(_vm.lang.SP1033))])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperGender')),
      expression: "inputHasError('inputShopperGender')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SP1009))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group clearfix"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperAddress1"
    }
  }, [_vm._v(_vm._s(_vm.lang.SP1012) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shopperProfileData.Address1),
      expression: "shopperProfileData.Address1"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperAddress1",
      "required": ""
    },
    domProps: {
      "value": (_vm.shopperProfileData.Address1)
    },
    on: {
      "change": function($event) {
        return _vm.validateInput('inputShopperAddress1')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shopperProfileData, "Address1", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperAddress1')),
      expression: "inputHasError('inputShopperAddress1')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SP1009))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperPostalCode"
    }
  }, [_vm._v(_vm._s(_vm.lang.SP1013) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shopperProfileData.PostalCode),
      expression: "shopperProfileData.PostalCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperPostalCode",
      "required": ""
    },
    domProps: {
      "value": (_vm.shopperProfileData.PostalCode)
    },
    on: {
      "change": function($event) {
        return _vm.validateInput('inputShopperPostalCode')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shopperProfileData, "PostalCode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperPostalCode')),
      expression: "inputHasError('inputShopperPostalCode')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SP1009))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperCity"
    }
  }, [_vm._v(_vm._s(_vm.lang.SP1014) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shopperProfileData.City),
      expression: "shopperProfileData.City"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperCity",
      "required": ""
    },
    domProps: {
      "value": (_vm.shopperProfileData.City)
    },
    on: {
      "change": function($event) {
        return _vm.validateInput('inputShopperCity')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shopperProfileData, "City", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperCity')),
      expression: "inputHasError('inputShopperCity')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SP1009))])])]), _vm._v(" "), (Object.keys(_vm.globals.countryList).length > 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperCountryCode"
    }
  }, [_vm._v(_vm._s(_vm.lang.SP1015) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [(!_vm.globals.isMobileBrowser) ? _c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "inputShopperCountryCode",
      "placeholder": _vm.lang.SP1004,
      "required": ""
    },
    on: {
      "change": function($event) {
        _vm.validateInput('inputShopperCountryCode'),
          delete _vm.shopperProfileData.SocialSecurityNumber
      }
    },
    model: {
      value: (_vm.shopperProfileData.CountryCode),
      callback: function($$v) {
        _vm.$set(_vm.shopperProfileData, "CountryCode", $$v)
      },
      expression: "shopperProfileData.CountryCode"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.globals.countryList), function(country, ISOCode) {
    return _c('option', {
      key: ISOCode,
      domProps: {
        "value": ISOCode
      }
    }, [_vm._v("\n                          " + _vm._s(country) + "\n                        ")])
  })], 2) : _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shopperProfileData.CountryCode),
      expression: "shopperProfileData.CountryCode"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "inputShopperCountryCode",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.shopperProfileData, "CountryCode", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.validateInput('inputShopperCountryCode'),
          delete _vm.shopperProfileData.SocialSecurityNumber
      }]
    }
  }, _vm._l((_vm.globals.countryList), function(country, ISOCode) {
    return _c('option', {
      key: ISOCode,
      domProps: {
        "value": ISOCode
      }
    }, [_vm._v("\n                          " + _vm._s(country) + "\n                        ")])
  }), 0)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperCountryCode')),
      expression: "inputHasError('inputShopperCountryCode')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SP1009))])]) : _vm._e(), _vm._v(" "), (_vm.regionsOfSelectedCountry.length > 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperRegionGuid"
    }
  }, [_vm._v(_vm._s(_vm.lang.SP1049) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [(!_vm.globals.isMobileBrowser) ? _c('select2', {
    ref: "inputShopperRegionGuid",
    staticClass: "form-control",
    attrs: {
      "id": "inputShopperRegionGuid",
      "placeholder": _vm.lang.SP1004,
      "required": "",
      "disabled": !_vm.shopperProfileData.CountryCode
    },
    on: {
      "change": function($event) {
        return _vm.validateInput('inputShopperRegionGuid')
      }
    },
    model: {
      value: (_vm.shopperProfileData.RegionGuid),
      callback: function($$v) {
        _vm.$set(_vm.shopperProfileData, "RegionGuid", $$v)
      },
      expression: "shopperProfileData.RegionGuid"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.regionsOfSelectedCountry), function(region) {
    return _c('option', {
      key: region.RegionGuid,
      domProps: {
        "value": region.RegionGuid
      }
    }, [_vm._v("\n                          " + _vm._s(region.RegionName) + "\n                        ")])
  })], 2) : _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shopperProfileData.RegionGuid),
      expression: "shopperProfileData.RegionGuid"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "inputShopperRegionGuid",
      "required": "",
      "disabled": !_vm.shopperProfileData.CountryCode
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.shopperProfileData, "RegionGuid", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.validateInput('inputShopperRegionGuid')
      }]
    }
  }, _vm._l((_vm.regionsOfSelectedCountry), function(region) {
    return _c('option', {
      key: region.RegionGuid,
      domProps: {
        "value": region.RegionGuid
      }
    }, [_vm._v("\n                          " + _vm._s(region.RegionName) + "\n                        ")])
  }), 0)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperRegionGuid')),
      expression: "inputHasError('inputShopperRegionGuid')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SP1009))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperBirthdate"
    }
  }, [_vm._v(_vm._s(_vm.lang.SP1016) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputShopperBirthdate')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shopperProfileData.Birthdate),
      expression: "shopperProfileData.Birthdate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperBirthdate",
      "required": ""
    },
    domProps: {
      "value": (_vm.shopperProfileData.Birthdate)
    },
    on: {
      "change": function($event) {
        return _vm.validateInput('inputShopperBirthdate')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shopperProfileData, "Birthdate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperBirthdate')),
      expression: "inputHasError('inputShopperBirthdate')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SP1009))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperEmail"
    }
  }, [_vm._v(_vm._s(_vm.lang.SP1017) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shopperProfileData.Email),
      expression: "shopperProfileData.Email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperEmail",
      "required": ""
    },
    domProps: {
      "value": (_vm.shopperProfileData.Email)
    },
    on: {
      "change": function($event) {
        return _vm.validateInput('inputShopperEmail')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shopperProfileData, "Email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperEmail')),
      expression: "inputHasError('inputShopperEmail')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SP1009))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperPhone1"
    }
  }, [_vm._v(_vm._s(_vm.lang.SP1018) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shopperProfileData.Phone1),
      expression: "shopperProfileData.Phone1"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperPhone1",
      "required": ""
    },
    domProps: {
      "value": (_vm.shopperProfileData.Phone1)
    },
    on: {
      "change": function($event) {
        return _vm.validateInput('inputShopperPhone1')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shopperProfileData, "Phone1", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperPhone1')),
      expression: "inputHasError('inputShopperPhone1')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SP1009))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperPhone2"
    }
  }, [_vm._v(_vm._s(_vm.lang.SP1019))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shopperProfileData.Phone2),
      expression: "shopperProfileData.Phone2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperPhone2"
    },
    domProps: {
      "value": (_vm.shopperProfileData.Phone2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shopperProfileData, "Phone2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (
    Object.keys(_vm.globals.occupationalGroupList).length > 0
  ) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperOccupationGroup"
    }
  }, [_vm._v(_vm._s(_vm.lang.SP1020) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [(!_vm.globals.isMobileBrowser) ? _c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "inputShopperOccupationGroup",
      "placeholder": _vm.lang.SP1004,
      "required": ""
    },
    on: {
      "change": function($event) {
        return _vm.validateInput('inputShopperOccupationGroup')
      }
    },
    model: {
      value: (_vm.shopperProfileData.OccupationalGroupGuid),
      callback: function($$v) {
        _vm.$set(_vm.shopperProfileData, "OccupationalGroupGuid", $$v)
      },
      expression: "shopperProfileData.OccupationalGroupGuid"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.occupationalGroupList), function(occupationGroup, occupationGroupGuid) {
    return _c('option', {
      key: occupationGroupGuid,
      domProps: {
        "value": occupationGroupGuid
      }
    }, [_vm._v("\n                          " + _vm._s(occupationGroup) + "\n                        ")])
  })], 2) : _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shopperProfileData.OccupationalGroupGuid),
      expression: "shopperProfileData.OccupationalGroupGuid"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "inputShopperOccupationGroup",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.shopperProfileData, "OccupationalGroupGuid", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.validateInput('inputShopperOccupationGroup')
      }]
    }
  }, _vm._l((_vm.occupationalGroupList), function(occupationGroup, occupationGroupGuid) {
    return _c('option', {
      key: occupationGroupGuid,
      domProps: {
        "value": occupationGroupGuid
      }
    }, [_vm._v("\n                          " + _vm._s(occupationGroup) + "\n                        ")])
  }), 0)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperOccupationGroup')),
      expression: "inputHasError('inputShopperOccupationGroup')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SP1009))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperOccupation"
    }
  }, [_vm._v(_vm._s(_vm.lang.SP1021))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shopperProfileData.Occupation),
      expression: "shopperProfileData.Occupation"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperOccupation"
    },
    domProps: {
      "value": (_vm.shopperProfileData.Occupation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shopperProfileData, "Occupation", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperEmployer"
    }
  }, [_vm._v(_vm._s(_vm.lang.SP1022))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shopperProfileData.Employer),
      expression: "shopperProfileData.Employer"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperEmployer"
    },
    domProps: {
      "value": (_vm.shopperProfileData.Employer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shopperProfileData, "Employer", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperVatNo"
    }
  }, [_vm._v(_vm._s(_vm.lang.SP1032) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shopperProfileData.VatNo),
      expression: "shopperProfileData.VatNo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperVatNo",
      "disabled": _vm.shopperProfileData.VatNotMandatory,
      "required": !_vm.shopperProfileData.VatNotMandatory
    },
    domProps: {
      "value": (_vm.shopperProfileData.VatNo)
    },
    on: {
      "change": function($event) {
        return _vm.validateInput('inputShopperVatNo')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shopperProfileData, "VatNo", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperVatNo')),
      expression: "inputHasError('inputShopperVatNo')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SP1009))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shopperProfileData.VatNotMandatory),
      expression: "shopperProfileData.VatNotMandatory"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.shopperProfileData.VatNotMandatory) ? _vm._i(_vm.shopperProfileData.VatNotMandatory, null) > -1 : (_vm.shopperProfileData.VatNotMandatory)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.shopperProfileData.VatNotMandatory,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.shopperProfileData, "VatNotMandatory", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.shopperProfileData, "VatNotMandatory", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.shopperProfileData, "VatNotMandatory", $$c)
        }
      }, function($event) {
        return _vm.vatNotMandatoryChanged()
      }]
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "text text-black"
  }, [_vm._v(_vm._s(_vm.lang.SP1045))])])])])]), _vm._v(" "), (_vm.shopperProfileData.CountryCode === 'AT') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperSocialSecurityNumber"
    }
  }, [_vm._v(_vm._s(_vm.lang.SP1046) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shopperProfileData.SocialSecurityNumber),
      expression: "shopperProfileData.SocialSecurityNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperSocialSecurityNumber",
      "required": ""
    },
    domProps: {
      "value": (_vm.shopperProfileData.SocialSecurityNumber)
    },
    on: {
      "change": function($event) {
        return _vm.validateInput('inputShopperSocialSecurityNumber')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shopperProfileData, "SocialSecurityNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        _vm.inputHasError('inputShopperSocialSecurityNumber')
      ),
      expression: "\n                          inputHasError('inputShopperSocialSecurityNumber')\n                        "
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SP1009))])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingBankDetails",
      "data-toggle": !_vm.globals.isMobileBrowser ? 'collapse' : '',
      "data-parent": "#accordion",
      "href": "#collapseBankDetails",
      "aria-expanded": "true",
      "aria-controls": "collapseBankDetails"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.SP1000))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    class: {
      in: _vm.globals.isMobileBrowser
    },
    attrs: {
      "id": "collapseBankDetails",
      "role": "tabpanel",
      "aria-labelledby": "headingBankDetails"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputBankDetailsBankName"
    }
  }, [_vm._v(_vm._s(_vm.lang.SP1023))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankDetailsData.BankName),
      expression: "bankDetailsData.BankName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputBankDetailsBankName"
    },
    domProps: {
      "value": (_vm.bankDetailsData.BankName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bankDetailsData, "BankName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputBankDetailsSwiftCode"
    }
  }, [_vm._v(_vm._s(_vm.lang.SP1034))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankDetailsData.SwiftCode),
      expression: "bankDetailsData.SwiftCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputBankDetailsSwiftCode"
    },
    domProps: {
      "value": (_vm.bankDetailsData.SwiftCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bankDetailsData, "SwiftCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputBankDetailsAccountNumber"
    }
  }, [_vm._v(_vm._s(_vm.lang.SP1035))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankDetailsData.AccountNumber),
      expression: "bankDetailsData.AccountNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputBankDetailsAccountNumber"
    },
    domProps: {
      "value": (_vm.bankDetailsData.AccountNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bankDetailsData, "AccountNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputBankDetailsAccountName"
    }
  }, [_vm._v(_vm._s(_vm.lang.SP1036))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankDetailsData.AccountName),
      expression: "bankDetailsData.AccountName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputBankDetailsAccountName"
    },
    domProps: {
      "value": (_vm.bankDetailsData.AccountName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bankDetailsData, "AccountName", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingCustomProperties",
      "data-toggle": !_vm.globals.isMobileBrowser ? 'collapse' : '',
      "data-parent": "#accordion",
      "href": "#collapseCustomProperties",
      "aria-expanded": "true",
      "aria-controls": "collapseCustomProperties"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.SP1044))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    class: {
      in: _vm.globals.isMobileBrowser
    },
    attrs: {
      "id": "collapseCustomProperties",
      "role": "tabpanel",
      "aria-labelledby": "headingCustomProperties"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('custom-properties-form', {
    ref: "customPropertiesForm"
  })], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "scrollOverflowBlock"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.SP1007) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.validateBeforeSubmit('shopperProfileModal')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.SP1008) + "\n          ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
}]}

/***/ }),

/***/ 1075:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": 'changePasswordDialog' + _vm._uid,
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.PW0014))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.checkIfNewPasswordPassed()
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": 'inputOldPassword' + _vm._uid
    }
  }, [_vm._v(_vm._s(_vm.lang.PW0013))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwords.oldPassword),
      expression: "passwords.oldPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": 'inputOldPassword' + _vm._uid
    },
    domProps: {
      "value": (_vm.passwords.oldPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.passwords, "oldPassword", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": 'inputNewPassword' + _vm._uid
    }
  }, [_vm._v(_vm._s(_vm.lang.PW0001))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwords.newPassword),
      expression: "passwords.newPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": 'inputNewPassword' + _vm._uid
    },
    domProps: {
      "value": (_vm.passwords.newPassword)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.passwords, "newPassword", $event.target.value)
      }, function($event) {
        _vm.doCheckIfPasswordIsValid(), _vm.checkIfPasswordsMatch()
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "padding-bottom": "2px"
    }
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": 'inputNewPasswordRepeat' + _vm._uid
    }
  }, [_vm._v(_vm._s(_vm.lang.PW0002))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwords.newPasswordRepeat),
      expression: "passwords.newPasswordRepeat"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": 'inputNewPasswordRepeat' + _vm._uid
    },
    domProps: {
      "value": (_vm.passwords.newPasswordRepeat)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.passwords, "newPasswordRepeat", $event.target.value)
      }, function($event) {
        return _vm.checkIfPasswordsMatch()
      }]
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    attrs: {
      "id": "passwordPolicy"
    }
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.PW0003))])]), _vm._v(" "), (_vm.passwordPolicy.length > 0) ? _c('table', {
    staticClass: "table table-bordered"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "nopadding width-20"
  }, [(!_vm.passwordValidity.enoughCharacters) ? _c('i', {
    staticClass: "material-icons md-24 text-red"
  }, [_vm._v("clear")]) : _c('i', {
    staticClass: "material-icons md-24 text-green"
  }, [_vm._v("done")])]), _vm._v(" "), _c('td', {
    staticClass: "width-80"
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.PW0004) + " " + _vm._s(_vm.passwordPolicy[0].value) + "\n                  " + _vm._s(_vm.lang.PW0005) + "\n                ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "nopadding width-20"
  }, [(!_vm.passwordValidity.hasUpperCase) ? _c('i', {
    staticClass: "material-icons md-24 text-red"
  }, [_vm._v("clear")]) : _c('i', {
    staticClass: "material-icons md-24 text-green"
  }, [_vm._v("done")])]), _vm._v(" "), _c('td', {
    staticClass: "width-80"
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.PW0004) + " " + _vm._s(_vm.passwordPolicy[1].value) + "\n                  " + _vm._s(_vm.lang.PW0006) + "\n                ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "nopadding width-20"
  }, [(!_vm.passwordValidity.hasLowerCase) ? _c('i', {
    staticClass: "material-icons md-24 text-red"
  }, [_vm._v("clear")]) : _c('i', {
    staticClass: "material-icons md-24 text-green"
  }, [_vm._v("done")])]), _vm._v(" "), _c('td', {
    staticClass: "width-80"
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.PW0004) + " " + _vm._s(_vm.passwordPolicy[2].value) + "\n                  " + _vm._s(_vm.lang.PW0007) + "\n                ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "nopadding width-20"
  }, [(!_vm.passwordValidity.hasNumbers) ? _c('i', {
    staticClass: "material-icons md-24 text-red"
  }, [_vm._v("clear")]) : _c('i', {
    staticClass: "material-icons md-24 text-green"
  }, [_vm._v("done")])]), _vm._v(" "), _c('td', {
    staticClass: "width-80"
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.PW0004) + " " + _vm._s(_vm.passwordPolicy[3].value) + "\n                  " + _vm._s(_vm.lang.PW0008) + "\n                ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "nopadding width-20"
  }, [(!_vm.passwordValidity.hasNonalphas) ? _c('i', {
    staticClass: "material-icons md-24 text-red"
  }, [_vm._v("clear")]) : _c('i', {
    staticClass: "material-icons md-24 text-green"
  }, [_vm._v("done")])]), _vm._v(" "), _c('td', {
    staticClass: "width-80"
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.PW0004) + " " + _vm._s(_vm.passwordPolicy[4].value) + "\n                  " + _vm._s(_vm.lang.PW0009) + "\n                ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "nopadding width-20"
  }, [(!_vm.passwordsMatch) ? _c('i', {
    staticClass: "material-icons md-24 text-red"
  }, [_vm._v("clear")]) : _c('i', {
    staticClass: "material-icons md-24 text-green"
  }, [_vm._v("done")])]), _vm._v(" "), _c('td', {
    staticClass: "width-80"
  }, [_vm._v(_vm._s(_vm.lang.PW0012))])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.PW0010) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.isPasswordValid || !_vm.passwordsMatch
    },
    on: {
      "click": function($event) {
        return _vm.checkIfNewPasswordPassed()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.PW0011) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1076:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    class: {
      'text-red': _vm.Recommended && !_vm.value
    },
    attrs: {
      "for": ("input-shopper-custprop-" + _vm.Guid + "-" + _vm._uid)
    }
  }, [_vm._v("\n    " + _vm._s(_vm.Title) + "\n    "), (_vm.Recommended) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": ("input-shopper-custprop-" + _vm.Guid + "-" + _vm._uid)
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": _vm.updateValue
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 1077:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    class: {
      'text-red': _vm.Recommended && _vm.value === undefined
    },
    attrs: {
      "for": ("input-shopper-custprop-" + _vm.Guid + "-" + _vm._uid)
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateValue()
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.Title) + "\n    "), (_vm.Recommended) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('button', {
    staticClass: "btn-checkbox pull-left",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateValue()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [(_vm.value === true) ? _c('span', [_vm._v("check_box")]) : (_vm.value === false) ? _c('span', [_vm._v("check_box_outline_blank")]) : _c('span', [_vm._v("indeterminate_check_box")])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1079:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app__main",
    attrs: {
      "id": "app"
    }
  }, [(_vm.globals.spinnerVisible) ? _c('div', {
    staticClass: "loading"
  }) : _vm._e(), _vm._v(" "), _c('nav', {
    staticClass: "navbar",
    class: {
      db_layout: _vm.feature.isDBTarget
    },
    attrs: {
      "id": "app-navbar"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    class: {
      active: !_vm.$route.name
    }
  }, [_c('a', [(_vm.feature.isAudiTarget) ? _c('img', {
    attrs: {
      "src": "/static/audi_loop_logo.png",
      "height": "40"
    }
  }) : (_vm.feature.isDBTarget) ? _c('img', {
    attrs: {
      "src": "/static/DB_loop_service_store_logo.png",
      "height": "25"
    }
  }) : (_vm.feature.isPorscheTarget) ? _c('img', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "src": "/static/Porsche_loop_logo.png",
      "height": "35"
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/msm_loop_logo.png",
      "height": "40"
    }
  })])])]), _vm._v(" "), (!_vm.globals.isSmallScreen()) ? _c('ul', {
    staticClass: "nav navbar-nav"
  }, [(
    _vm.globals.isAccessAllowed('LoopOp_SurveyInstancesAnswers_ReadAll')
  ) ? _c('li', {
    class: {
      active: _vm.$route.name === 'SurveyView'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/surveyview"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0014))])], 1) : _vm._e(), _vm._v(" "), (
    !_vm.globals.isSurveyCodeUser &&
    _vm.globals.isAccessAllowed('LoopOp_SurveyInstancesAnswers_ReadAll')
  ) ? _c('li', {
    class: {
      active: _vm.$route.name === 'Settlement'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/settlement"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0030))])], 1) : _vm._e(), _vm._v(" "), (!_vm.globals.isSurveyCodeUser && _vm.globals.currentUserInfo) ? _c('li', {
    class: {
      active: _vm.$route.name === 'FreeOffers'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/freeoffers"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0019))])], 1) : _vm._e()]) : _c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.currentRouteHeaderTranslation) + "\n            "), _c('b', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    class: {
      'dropdown-active': _vm.$route.name === 'SurveyView'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/surveyview"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0014))])], 1), _vm._v(" "), (
    !_vm.globals.isSurveyCodeUser &&
    _vm.globals.isAccessAllowed(
      'LoopOp_SurveyInstancesAnswers_ReadAll'
    )
  ) ? _c('li', {
    class: {
      'dropdown-active': _vm.$route.name === 'Settlement'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/settlement"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0030))])], 1) : _vm._e(), _vm._v(" "), (!_vm.globals.isSurveyCodeUser) ? _c('li', {
    class: {
      'dropdown-active': _vm.$route.name === 'FreeOffers'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/freeoffers"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0019))])], 1) : _vm._e()])])]), _vm._v(" "), (_vm.userLoginState) ? _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openSelectLanguageDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("public")]), _vm._v("\n            " + _vm._s(_vm.globals.isMobileBrowser ?
    _vm.globals.selectedLanguage.toUpperCase() :
    _vm.languageList[_vm.globals.selectedLanguage]) + "\n          ")])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("person")]), _vm._v("\n            " + _vm._s(_vm.globals.isMobileBrowser ? "" : _vm.globals.currentUserInfo.LoginName) + "\n            "), _c('b', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [(_vm.globals.isSmallScreen()) ? _c('li', [_c('a', {
    staticStyle: {
      "pointer-events": "none"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("person")]), _vm._v("\n                " + _vm._s(_vm.globals.currentUserInfo.LoginName) + "\n              ")])]) : _vm._e(), _vm._v(" "), (!_vm.globals.isSurveyCodeUser) ? _c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        _vm.showShopperProfileModal = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("portrait")]), _vm._v("\n                " + _vm._s(_vm.lang.A0004) + "\n              ")])]) : _vm._e(), _vm._v(" "), (
    !_vm.globals.isSurveyCodeUser &&
    _vm.globals.isAccessAllowed(
      'LoopOp_Password_ChangePasswordSelf'
    ) &&
    _vm.globals.isAccessAllowed('LoopOp_Password_ValidatePassword')
  ) ? _c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        _vm.showChangePasswordDialog = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("vpn_key")]), _vm._v("\n                " + _vm._s(_vm.lang.A0031) + "\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.globals.selectedLanguage === 'de') ? _c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showHelpMessage()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("help_outline")]), _vm._v("\n                " + _vm._s(_vm.lang.A0022) + "\n              ")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.userLogout()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("exit_to_app")]), _vm._v("\n                " + _vm._s(_vm.lang.A0003) + "\n              ")])])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "app__router-view"
  }, [(_vm.isAccessTokenAvailable) ? _c('router-view', {
    key: _vm.$route.fullPath
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "selectLanguageDialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.A0006))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.A0007))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-md-offset-2",
    staticStyle: {
      "padding-bottom": "20px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nextLanguage),
      expression: "nextLanguage"
    }],
    staticClass: "form-control language-select",
    attrs: {
      "id": "selectLanguage"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.nextLanguage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.languageList), function(language, isocode) {
    return _c('option', {
      key: isocode,
      domProps: {
        "value": isocode
      }
    }, [_vm._v("\n                  " + _vm._s(language) + "\n                ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default dialog-btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.changeSelectedLanguage
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.A0009) + "\n          ")])])])])]), _vm._v(" "), _c('ShopperProfile', {
    attrs: {
      "showDialog": _vm.showShopperProfileModal
    },
    on: {
      "modalClosed": function($event) {
        _vm.showShopperProfileModal = false
      }
    }
  }), _vm._v(" "), _c('ChangePasswordDialog', {
    attrs: {
      "showDialog": _vm.showChangePasswordDialog
    },
    on: {
      "dialogClosed": function($event) {
        _vm.showChangePasswordDialog = false
      }
    }
  }), _vm._v(" "), _c('ConfirmationDialog', {
    attrs: {
      "dialogId": _vm.confirmationDialogId,
      "confirmationTitle": _vm.confirmationDialogData.confirmationTitle,
      "yesButtonText": _vm.confirmationDialogData.yesButtonText,
      "noButtonText": _vm.confirmationDialogData.noButtonText,
      "showDialog": _vm.showConfirmationDialog,
      "colorRed": _vm.confirmationDialogData.colorRed,
      "htmlText": _vm.confirmationDialogData.htmlText
    },
    on: {
      "onYesConfirmation": _vm.onYesConfirmation,
      "onNoConfirmation": _vm.onNoConfirmation,
      "dialogClosed": _vm.onConfirmationDialogClosed
    }
  }), _vm._v(" "), _c('NotificationDialog', {
    attrs: {
      "dialogId": _vm.notificationDialogId,
      "notificationTitle": _vm.notificationDialogData.notificationTitle,
      "closeButtonText": _vm.notificationDialogData.closeButtonText,
      "showDialog": _vm.showNotificationDialog,
      "colorRed": _vm.notificationDialogData.colorRed,
      "htmlText": _vm.notificationDialogData.htmlText
    },
    on: {
      "closeDialog": _vm.onCloseNotificationDialog,
      "dialogClosed": _vm.onNotificationDialogClosed
    }
  }), _vm._v(" "), _c('ErrorDialog', {
    attrs: {
      "errorText": _vm.errorDialogData.errorText,
      "showDialog": _vm.showErrorDialog,
      "colorOrange": _vm.errorDialogData.colorOrange
    },
    on: {
      "dialogClosed": _vm.onErrorDialogClosed
    }
  }), _vm._v(" "), _c('UploadProgressModal'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "defaultAppFooter"
    }
  }, [_c('span', {
    attrs: {
      "id": "footerLinkContainer"
    }
  }, [_c('a', {
    attrs: {
      "href": ("https://" + _vm.mainOpHost + "/imprint.html"),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0018))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": ("https://" + _vm.mainOpHost + "/dataProtection.html"),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0017))])]), _vm._v(" "), _c('span', {
    attrs: {
      "id": "frontendVersionIndicator"
    }
  }, [_vm._v("v" + _vm._s(_vm.appVersion))])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requestBase__ = __webpack_require__(37);


var API_BASE = "api/Live";

function clearSiteDataAll() {
    var queryString = API_BASE + "/ClearSiteData/all";
    return __WEBPACK_IMPORTED_MODULE_0__requestBase__["a" /* default */].get(queryString);
}

function getVersion() {
    return __WEBPACK_IMPORTED_MODULE_0__requestBase__["a" /* default */].get(API_BASE + "/Version");
}

/* harmony default export */ __webpack_exports__["a"] = ({
    clearSiteDataAll: clearSiteDataAll,
    getVersion: getVersion
});

/***/ }),

/***/ 1080:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.dialogId,
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.notificationTitle))])])]), _vm._v(" "), (!_vm.htmlText) ? _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("default")], 2) : _c('div', {
    staticClass: "modal-body",
    domProps: {
      "innerHTML": _vm._s(_vm.htmlText)
    }
  }, [_vm._v(_vm._s(_vm.htmlText))]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    class: [this.colorRed ? 'btn-danger' : 'dialog-btn-primary'],
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.closeButtonText) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1082:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    class: {
      'text-red': _vm.Recommended && !_vm.value
    },
    attrs: {
      "for": ("input-shopper-custprop-" + _vm.Guid + "-" + _vm._uid)
    }
  }, [_vm._v("\n    " + _vm._s(_vm.Title) + "\n    "), (_vm.Recommended) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": ("input-shopper-custprop-" + _vm.Guid + "-" + _vm._uid)
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": _vm.updateValue
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 1083:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "CustomPropertiesFormGenerator"
    }
  }, _vm._l((_vm.propertiesFormSchema), function(property) {
    return _c('div', {
      key: property.Guid
    }, [(property.ChildProperties) ? _c('div', {
      staticClass: "col-md-12"
    }, [_c('h4', {
      staticClass: "propertyThemeTitle"
    }, [_vm._v(_vm._s(property.Title))])]) : _vm._e(), _vm._v(" "), (property.ChildProperties) ? _vm._l((property.ChildProperties), function(childProperty) {
      return _c('div', {
        key: childProperty.Guid
      }, [(
        childProperty.Type === 'Group' && childProperty.ChildProperties
      ) ? _c('h5', {
        staticClass: "propertyGroupTitle"
      }, [_vm._v("\n          " + _vm._s(childProperty.Title) + "\n          "), _c('button', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (
            childProperty.Dynamic &&
            childProperty.ChildProperties &&
            childProperty.ChildProperties[0]
          ),
          expression: "\n              childProperty.Dynamic &&\n              childProperty.ChildProperties &&\n              childProperty.ChildProperties[0]\n            "
        }],
        staticClass: "btn btn-default btn-fab btn-fab-mini",
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.addDynamicGroup(childProperty)
          }
        }
      }, [_c('i', {
        staticClass: "material-icons text-green"
      }, [_vm._v("add")])])]) : _vm._e(), _vm._v(" "), (childProperty.Dynamic && childProperty.ValueGroups) ? _vm._l((childProperty.ValueGroups), function(valueGroup) {
        return _c('div', {
          key: valueGroup.ValueGroupGuid,
          staticClass: "col-md-12"
        }, [_c('div', {
          staticClass: "dynamicGroupBorder"
        }, [_vm._l((childProperty.ChildProperties), function(property) {
          return _c('div', {
            key: property.Guid,
            staticClass: "col-xs-11"
          }, [_c(((property.PropertyType) + "Input"), _vm._b({
            tag: "component",
            attrs: {
              "value": _vm.getShopperValues(property, valueGroup)
            },
            on: {
              "input": function($event) {
                return _vm.updateShopperValues(property, valueGroup, $event)
              }
            }
          }, 'component', property, false))], 1)
        }), _vm._v(" "), _c('div', [_c('button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (childProperty.Dynamic),
            expression: "childProperty.Dynamic"
          }],
          staticClass: "btn btn-default btn-fab btn-fab-mini btn-clear",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.removeDynamicGroup(
                childProperty,
                valueGroup.ValueGroupGuid
              )
            }
          }
        }, [_c('i', {
          staticClass: "material-icons text-red"
        }, [_vm._v("clear")])])])], 2)])
      }) : (childProperty.Type === 'Property') ? [_c('div', {
        staticClass: "col-md-12 nonDynamicGroup"
      }, [_c(((childProperty.PropertyType) + "Input"), _vm._b({
        tag: "component",
        attrs: {
          "value": _vm.getShopperValues(childProperty, null)
        },
        on: {
          "input": function($event) {
            return _vm.updateShopperValues(childProperty, null, $event)
          }
        }
      }, 'component', childProperty, false))], 1)] : _vm._e()], 2)
    }) : _vm._e()], 2)
  }), 0)
},staticRenderFns: []}

/***/ }),

/***/ 1084:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    class: {
      'text-red': _vm.Recommended && _vm.value.length < 1
    },
    attrs: {
      "for": ("input-shopper-custprop-" + _vm.Guid + "-" + _vm._uid)
    }
  }, [_vm._v("\n    " + _vm._s(_vm.Title) + "\n    "), (_vm.Recommended) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('Select2', {
    staticClass: "form-control",
    attrs: {
      "id": ("input-shopper-custprop-" + _vm.Guid + "-" + _vm._uid),
      "allowClear": true,
      "tags": _vm.AllowCustomValues,
      "multiple": true,
      "placeholder": ' ',
      "value": _vm.value
    },
    on: {
      "change": _vm.updateValue,
      "beforeOpen": _vm.scrollIntoViewMobile,
      "close": function($event) {
        return _vm.selectClosed()
      }
    }
  }, _vm._l((_vm.ListValues), function(element) {
    return _c('option', {
      key: element.ValueGuid,
      domProps: {
        "value": element.ValueGuid
      }
    }, [_vm._v("\n        " + _vm._s(element.Value) + "\n      ")])
  }), 0)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1088:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(287);
module.exports = __webpack_require__(550);


/***/ }),

/***/ 109:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__package_json__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__globals__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__feature__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_text_encoding_shim__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_text_encoding_shim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_text_encoding_shim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__surveyjs_store__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Live__ = __webpack_require__(108);












var base64url = __webpack_require__(442);
if (false) {
  process.auth = {};
}
var SERVER_URL = "https://dev.authentication.qm-servicestoredb.de/";
var CLIENT_URL = "https://dev.shopper.qm-servicestoredb.de/#/";

/* harmony default export */ __webpack_exports__["a"] = ({
  // app wide variables
  tokenRenewalPending: false,
  tokenRenewalCallbacks: [],
  appReloadPending: false,
  dynamicDomain: null,
  // app functions
  /**
   * Server Url is undefined at app start so we return it dynamically
   * @returns The auth server url
   */
  getServerUrl: function getServerUrl() {
    return SERVER_URL;
  },
  isJWTExpired: function isJWTExpired(token) {
    var payload = this.getTokenData(token);
    var expireDate = payload.exp * 1000;
    var now = Date.now();
    return now > expireDate;
  },

  /**
   * Allow using alternative Redirect Url if the feature is activated
   * @param {String} url
   * @returns if not allowed
   */
  allowAlternativeRedirectUrl: function allowAlternativeRedirectUrl(url) {
    var _this = this;

    if (!__WEBPACK_IMPORTED_MODULE_7__feature__["a" /* default */].isEnabled("MultipleDomains") || ![]) return;

    var urlArray = url.split("/");
    [].forEach(function (redirect) {
      if (urlArray.length >= 5 && urlArray.slice(0, 4).join("/") + "/" === redirect) {
        _this.dynamicDomain = redirect;
      }
    });
    if (!this.dynamicDomain) {
      this.dynamicDomain = CLIENT_URL;
    }
  },

  /**
   * @returns ClientURL
   */
  getClientURL: function getClientURL() {
    // #1313
    if (__WEBPACK_IMPORTED_MODULE_7__feature__["a" /* default */].isEnabled("MultipleDomains") && !this.dynamicDomain) this.allowAlternativeRedirectUrl(window.location.href);
    if (this.dynamicDomain) {
      return this.dynamicDomain;
    } else {
      return CLIENT_URL;
    }
  },
  isSurveyCodeUser: function isSurveyCodeUser() {
    var token = this.getAccessToken();
    var payload = this.getTokenData(token);
    return payload && !!payload.survey_code;
  },
  updateTokenDataDependencies: function updateTokenDataDependencies() {
    __WEBPACK_IMPORTED_MODULE_6__globals__["a" /* default */].isSurveyCodeUser = this.isSurveyCodeUser();
  },
  isUserAuthenticated: function isUserAuthenticated() {
    var access_token = this.getAccessToken();
    return access_token ? !this.isJWTExpired(access_token) : false;
  },
  getTokenData: function getTokenData(token) {
    if (!token) return;
    var data = JSON.parse(window.atob(token.split(".")[1]));
    return data;
  },
  getAccessToken: function getAccessToken() {
    return localStorage.getItem("access_token") || null;
  },
  getIdToken: function getIdToken() {
    return localStorage.getItem("id_token") || null;
  },
  checkRouteValid: function checkRouteValid(hash) {
    if (hash.length > 2) {
      var route = hash.slice(1);
      for (var r in __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].options.routes) {
        var path = __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].options.routes[r].path;
        if (path == route) return true;
      }
    }
    return false;
  },
  randomString: function randomString(length) {
    var charset = "0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz-._~";
    var result = "";

    while (length > 0) {
      var bytes = new Uint8Array(16);
      var crypto = window.crypto || window.msCrypto;
      var random = crypto.getRandomValues(bytes);

      random.forEach(function (c) {
        if (length == 0) {
          return;
        }
        if (c < charset.length) {
          result += charset[c];
          length--;
        }
      });
    }
    return result;
  },
  hexString: function hexString(buffer) {
    var byteArray = new Uint8Array(buffer);

    var hexCodes = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(byteArray)).map(function (value) {
      var hexCode = value.toString(16);
      var paddedHexCode = hexCode.padStart(2, "0");
      return paddedHexCode;
    });

    return hexCodes.join("");
  },
  digestMessage: function digestMessage(message) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var encoder, data, crypto, result;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              encoder = new __WEBPACK_IMPORTED_MODULE_8_text_encoding_shim__["TextEncoder"]();
              data = encoder.encode(message);
              crypto = window.crypto || window.msCrypto;
              _context.next = 5;
              return crypto.subtle.digest("SHA-256", data);

            case 5:
              result = _context.sent;

              if (result.result) result = result.result; // IE11 returns an object containing result property
              return _context.abrupt("return", result);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },
  digestMessageToHexString: function digestMessageToHexString(message) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.t0 = _this3;
              _context2.next = 3;
              return _this3.digestMessage(message);

            case 3:
              _context2.t1 = _context2.sent;
              return _context2.abrupt("return", _context2.t0.hexString.call(_context2.t0, _context2.t1));

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this3);
    }))();
  },
  directToLogin: function directToLogin(surveyCodeLogin, surveyCode) {
    var _this4 = this;

    this.tokenRenewalPending = true;
    var nonce = this.randomString(4096);
    var stateNonce = this.randomString(4096);
    var codeVerifier = this.randomString(128);
    this.digestMessageToHexString(nonce).then(function (nonceDigest) {
      _this4.digestMessageToHexString(stateNonce).then(function (stateDigest) {
        _this4.digestMessage(codeVerifier).then(function (codeVerifierDigest) {
          var urlData = _this4.getTokensFromUrl();
          var stateDigestFromUrl = urlData && urlData.state_digest;
          var state = void 0;
          var stateDigestForRedirect = stateDigest;
          if (surveyCodeLogin) {
            state = "/surveyview";
            sessionStorage.setItem(stateDigest, state);
          } else if (stateDigestFromUrl) {
            state = sessionStorage.getItem(stateDigestFromUrl);
            stateDigestForRedirect = stateDigestFromUrl;
          } else {
            if (location.pathname.indexOf("survey.html") > -1) state = location.pathname + location.hash;else state = __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].currentRoute.fullPath;
            sessionStorage.setItem(stateDigest, state);
          }
          sessionStorage.setItem("nonce_digest", nonceDigest);
          localStorage.setItem("code_verifier", codeVerifier);

          var codeVerifierDigestBase64 = base64url.encode(codeVerifierDigest);
          var postLoginRedirectUrl = _this4.getClientURL() + "callback";

          var fullAuthUrl = SERVER_URL + "connect/authorize?client_id=loopShopperFrontend&redirect_uri=" + encodeURIComponent(postLoginRedirectUrl) + "&response_type=code&scope=openid%20profile%20offline_access%20loopShopperBackend%20loopOpBackend&state=" + stateDigestForRedirect + "&nonce=" + nonceDigest + "&code_challenge_method=S256&code_challenge=" + codeVerifierDigestBase64;

          if (surveyCodeLogin) {
            fullAuthUrl += "&survey_code_login=true";
            if (surveyCode) fullAuthUrl += "&survey_code=" + surveyCode;
          }

          window.location.href = fullAuthUrl;
        });
      });
    });
  },
  redirectAfterLoginCallback: function redirectAfterLoginCallback() {
    var _this5 = this;

    var tokens = this.getTokensFromUrl();
    var codeVerifier = localStorage.getItem("code_verifier");
    if (!tokens || !tokens.code || !codeVerifier) {
      console.error("Missing code in URL");
      this.removeTokensFromStorage();
      this.directToLogin();
      return;
    }

    this.tokenRenewalPending = true;
    var formData = new FormData();
    formData.append("client_id", "loopShopperFrontend");
    formData.append("code_verifier", codeVerifier);
    formData.append("code", tokens.code);
    formData.append("grant_type", "authorization_code");
    formData.append("redirect_uri", this.getClientURL() + "callback");
    $.ajax({
      method: "POST",
      url: SERVER_URL + "connect/token",
      data: formData,
      contentType: false,
      processData: false,
      global: false,
      success: function success(data) {
        if (data && data.access_token && data.refresh_token && data.id_token) {
          _this5.storeTokensInStorage(data.access_token, data.id_token, data.refresh_token);
          _this5.updateTokenDataDependencies();
          _this5.configureAjaxSetup();
          _this5.setClientTimeZone();

          _this5.tokenRenewalCallbacks.forEach(function (callback) {
            callback();
          });
          _this5.tokenRenewalCallbacks = [];

          var nonceFromToken = _this5.getTokenData(data.id_token).nonce;
          var nonceFromStorage = sessionStorage.getItem("nonce_digest");
          sessionStorage.removeItem("nonce_digest");
          var stateFromStorage = void 0;
          if (tokens.state_digest) {
            stateFromStorage = sessionStorage.getItem(tokens.state_digest);
            sessionStorage.removeItem(tokens.state_digest);
          }
          if (nonceFromStorage !== nonceFromToken || !stateFromStorage) {
            _this5.directToLogin();
          } else {
            if (stateFromStorage.indexOf("survey.html") > -1) location = window.origin + stateFromStorage;else __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push(stateFromStorage);
          }
        }
      },
      error: function error() {
        console.error("Error on POST in redirectAfterLoginCallback()");
        _this5.removeTokensFromStorage();
        _this5.directToLogin();
      },
      complete: function complete() {
        _this5.tokenRenewalPending = false;
      }
    });
  },
  setClientTimeZone: function setClientTimeZone() {
    var tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (!tz) return;
    var query = "api/SecurityUsers/Localization?TimeZoneName=" + encodeURIComponent(tz);

    $.ajax({
      method: "PUT",
      url: query,
      dataType: "json",
      contentType: "application/json; charset=utf-8",
      error: function error() {
        console.error("Error on PUT in setClientTimeZone()");
        __WEBPACK_IMPORTED_MODULE_6__globals__["a" /* default */].$emit("openGlobalErrorDialog", { errorText: "Timezone update failed", colorOrange: false });
      }
    });
  },
  getDefaultAjaxSetupConfig: function getDefaultAjaxSetupConfig() {
    var _this6 = this;

    return {
      headers: {
        Pragma: "no-cache"
      },
      beforeSend: function beforeSend(jqXHR, options) {
        if (!_this6.isUserAuthenticated() && !options.isAuthRequest) {
          var repeatAjax = function repeatAjax() {
            $.ajax($.extend(options, {
              beforeSend: $.noop,
              headers: {
                Authorization: "Bearer " + _this6.getAccessToken()
              }
            }));
          };
          _this6.renewToken(repeatAjax);
          return false;
        }
      }
    };
  },
  configureAjaxSetup: function configureAjaxSetup() {
    var access_token = this.getAccessToken();
    if (!access_token) {
      console.error("No access token available");
      this.directToLogin();
      return;
    }
    var config = this.getDefaultAjaxSetupConfig();
    config.headers.Authorization = "Bearer " + access_token;
    $.ajaxSetup(config);
  },
  initializeGlobalAjaxEvents: function initializeGlobalAjaxEvents() {
    var _this7 = this;

    if (!localStorage.getItem("refresh_token") && !this.tokenRenewalPending) {
      this.removeTokensFromStorage();
      this.directToLogin();
      return;
    }

    var access_token = this.getAccessToken();
    this.updateTokenDataDependencies();
    var config = this.getDefaultAjaxSetupConfig();
    if (access_token) config.headers.Authorization = "Bearer " + access_token;
    $.ajaxSetup(config);

    window.addEventListener("storage", function (e) {
      if (e.key === "refresh_token") {
        _this7.configureAjaxSetup();
      }
    });

    $(document).ajaxComplete(function (event, jqXHR, options, data) {
      var apiVersion = jqXHR.getResponseHeader("shopper-version");
      var isDevSystem = __WEBPACK_IMPORTED_MODULE_7__feature__["a" /* default */].currentTarget.indexOf("dev") > -1;
      if (!isDevSystem && !_this7.appReloadPending && apiVersion && apiVersion !== __WEBPACK_IMPORTED_MODULE_5__package_json__["version"]) {
        _this7.appReloadPending = true;
        // Force hard reload of the page if a new version of the app is available
        console.error("Frontend version mismatch - reloading page \n Api-Version: " + apiVersion + "  App-Version: " + __WEBPACK_IMPORTED_MODULE_5__package_json__["version"]);
        __WEBPACK_IMPORTED_MODULE_10__Live__["a" /* default */].Live.clearSiteDataAll().then(function (res) {
          location.reload(true);
        }).catch(function () {
          console.error("Live error");
        });
      }

      if (jqXHR.status === 401) {
        _this7.renewToken(function () {
          $.ajax($.extend(options, {
            beforeSend: $.noop,
            headers: {
              Authorization: "Bearer " + _this7.getAccessToken()
            }
          }));
        });
      }
    });
  },

  /**
   * Renew the acces token if we have a refresh_token or code_verifier
   * @param {Function} doneCallback
   * @returns
   */
  renewToken: function renewToken(doneCallback) {
    var _this8 = this;

    if (doneCallback) this.tokenRenewalCallbacks.push(doneCallback);
    if (this.tokenRenewalPending) return;

    this.tokenRenewalPending = true;
    var refreshToken = localStorage.getItem("refresh_token");
    var codeVerifier = localStorage.getItem("code_verifier");
    if (!refreshToken || !codeVerifier) {
      this.removeTokensFromStorage();
      this.directToLogin();
      return;
    }
    var formData = new FormData();
    formData.append("client_id", "loopShopperFrontend");
    formData.append("code_verifier", codeVerifier);
    formData.append("refresh_token", refreshToken);
    formData.append("grant_type", "refresh_token");
    $.ajax({
      method: "POST",
      url: SERVER_URL + "connect/token",
      data: formData,
      contentType: false,
      processData: false,
      global: false,
      isAuthRequest: true,
      success: function success(data) {
        if (data && data.access_token && data.refresh_token && data.id_token) {
          _this8.storeTokensInStorage(data.access_token, data.id_token, data.refresh_token);
          _this8.updateTokenDataDependencies();
          _this8.configureAjaxSetup();

          _this8.tokenRenewalCallbacks.forEach(function (callback) {
            callback();
          });
          _this8.tokenRenewalCallbacks = [];
        }
      },
      error: function error(data) {
        console.error("Error on POST in renewToken()");
        _this8.removeTokensFromStorage();
        _this8.directToLogin();
      },
      complete: function complete() {
        _this8.tokenRenewalPending = false;
      }
    });
  },
  getPostLoginUrl: function getPostLoginUrl() {
    var hashString = window.location.hash;
    var idx = hashString.indexOf("id_token");
    if (idx < 0) return "";

    var postLoginUrl = hashString.slice(2, idx);
    return postLoginUrl;
  },
  storeTokensInStorage: function storeTokensInStorage(access_token, id_token, refresh_token) {
    localStorage.setItem("access_token", access_token);
    localStorage.setItem("id_token", id_token);
    localStorage.setItem("refresh_token", refresh_token);
    __WEBPACK_IMPORTED_MODULE_6__globals__["a" /* default */].$emit("accessTokenChanged");
  },
  removeTokensFromStorage: function removeTokensFromStorage() {
    localStorage.removeItem("access_token");
    localStorage.removeItem("id_token");
    localStorage.removeItem("refresh_token");
    __WEBPACK_IMPORTED_MODULE_6__globals__["a" /* default */].$emit("accessTokenChanged");
  },

  /**
   * @typedef {Object} TokenObject
   * @property {String} code
   * @property {String} state_digest
   */
  /**
   * Creates an object out of the url we got from the auth server
   *
   * @returns {?TokenObject} contains the code and the state_digest
   */
  getTokensFromUrl: function getTokensFromUrl() {
    var params = {};
    window.location.hash.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
      params[key] = value;
    });

    var result = {};
    if (params.code) result.code = params.code;
    if (params.state) result.state_digest = params.state;

    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(result).length < 1) return null;
    return result;
  },
  logout: function logout() {
    var _this9 = this;

    var logoutUrl = SERVER_URL + "connect/endsession";
    var postLogoutRedirectUrl = this.getClientURL() + "logout_callback";

    var stateNonce = this.randomString(4096);
    this.digestMessageToHexString(stateNonce).then(function (stateDigest) {
      var state = __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].currentRoute.fullPath;
      if (_this9.isSurveyCodeUser()) state = "/surveycode";
      sessionStorage.setItem(stateDigest, state);

      var id_token = _this9.getIdToken();
      var fullLogoutUrl = logoutUrl + "?id_token_hint=" + id_token + "&post_logout_redirect_uri=" + encodeURIComponent(postLogoutRedirectUrl) + "&state=" + stateDigest;

      _this9.removeTokensFromStorage();
      window.location.href = fullLogoutUrl;
    });
  },
  redirectAfterLogoutCallback: function redirectAfterLogoutCallback() {
    var urlData = this.getTokensFromUrl();
    if (urlData && urlData.state_digest) {
      var state = sessionStorage.getItem(urlData.state_digest);
      sessionStorage.removeItem(urlData.state_digest);
      if (state) {
        __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push(state);
        return;
      }
    }

    this.redirectAfterLoginCallback();
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),

/***/ 126:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SurveyView_SurveyList__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SurveyView_SurveyList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SurveyView_SurveyList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FreeOffers_FreeOffers__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FreeOffers_FreeOffers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_FreeOffers_FreeOffers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PageNotFound__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PageNotFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_PageNotFound__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Settlement_SettlementList__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Settlement_SettlementList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Settlement_SettlementList__);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = [
// Routes to the different components are registered here
{
  path: "/surveyview",
  name: "SurveyView",
  component: __WEBPACK_IMPORTED_MODULE_2__components_SurveyView_SurveyList___default.a
}, {
  path: "/settlement",
  name: "Settlement",
  component: __WEBPACK_IMPORTED_MODULE_5__components_Settlement_SettlementList___default.a
}, {
  path: "/freeoffers",
  name: "FreeOffers",
  component: __WEBPACK_IMPORTED_MODULE_3__components_FreeOffers_FreeOffers___default.a
}, {
  path: "/surveycode",
  name: "SurveyCodeLogin"
}, {
  path: "/surveycode/:sc",
  name: "SurveyCodeDirectLogin"
}, {
  path: "/callback",
  name: "DirectToLoginCallback"
}, {
  path: "/logout_callback",
  name: "DirectToLogoutCallback"
}];

routes.push({
  path: "*",
  component: __WEBPACK_IMPORTED_MODULE_4__components_PageNotFound___default.a
});

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  //mode: 'history',
  routes: routes
}));

/***/ }),

/***/ 127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LocalStorageDB__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocalIndexDB__ = __webpack_require__(306);




/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
  if (__WEBPACK_IMPORTED_MODULE_2__LocalIndexDB__["a" /* default */].opened === true) {
    resolve(__WEBPACK_IMPORTED_MODULE_2__LocalIndexDB__["a" /* default */]);
  } else {
    __WEBPACK_IMPORTED_MODULE_2__LocalIndexDB__["a" /* default */].openDatabase().then(function (result) {
      resolve(__WEBPACK_IMPORTED_MODULE_2__LocalIndexDB__["a" /* default */]);
    }).catch(function (err) {
      resolve(__WEBPACK_IMPORTED_MODULE_1__LocalStorageDB__["a" /* default */]);
    });
  }
}));

/***/ }),

/***/ 128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requestBase__ = __webpack_require__(37);


var API_BASE = "api/SurveyInstanceAnswerHistory/SurveyInstancesAnswersHistory";

/**
 * @typedef {Object} HistoryQuestionRequest
 * @property {String[]} QuestionGuid - Array of guid to fetch the History for
 */

/**
 *
 * @param {number} id The SurveyInstanceId
 */
function getAnswersHistory(id) {
  return __WEBPACK_IMPORTED_MODULE_0__requestBase__["a" /* default */].get(API_BASE + "/" + id);
}

var Hist = {
  getAnswersHistory: getAnswersHistory
};

/* harmony default export */ __webpack_exports__["a"] = (Hist);

/***/ }),

/***/ 129:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isIndexDbSupported; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);




var isIndexDbSupported = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              var request = window.indexedDB.open("TestName", 1);
              request.onerror = function (e) {
                resolve(false);
              };
              request.onsuccess = function (e) {
                resolve(true);
              };
              request.onupgradeneeded = function (e) {
                resolve(true);
              };
            });

          case 2:
            return _context.abrupt("return", _context.sent);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function isIndexDbSupported() {
    return _ref.apply(this, arguments);
  };
}();



/***/ }),

/***/ 156:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(375)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(409),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-16e8f212",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 288:
/***/ (function(module, exports) {

module.exports = {"AutoFillDateCheck":{"target":"deutscheBahn dev"},"Autosave":{"target":"prod dev training deutscheBahn"},"MultipleDomains":{"target":"dev china"},"SurveyAnswerHistory":{"target":"dev training deutscheBahn"}}

/***/ }),

/***/ 289:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "FreeOfferDetailsDialog",
  props: {
    showDialog: { type: Boolean, default: false },
    freeOffer: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      lang: {
        SFO100: "Free offer",
        SFO101: "Project",
        SFO102: "Location",
        SFO103: "Total Payment",
        SFO104: "Accept free offer failed",
        SFO105: "Info Text",
        SFO106: "DSGVO",
        SFO107: "AGB",
        SFO108: "Accept",
        SFO109: "Cancel",
        SFO110: "Location Address",
        SFO111: "Others",
        SFO112: "Free Offer Accepted",
        SFO113: "Informations",
        SFO114: "Scenario",
        SFO115: "Check Info",
        SFO116: "Distance",
        SFO117: "Location free",
        G00025: "File download failed"
      }
    };
  },

  watch: {
    showDialog: function showDialog(newVal) {
      newVal ? this.openFreeOfferDetailsDialog() : this.closeFreeOfferDetailsDialog();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#freeOfferDetailsDialog").on("hide.bs.modal", function (e) {
      _this.$emit("dialogClosed");
    });
  },

  methods: {
    downloadwithFileName: function downloadwithFileName(guid, name) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this2.globals.downloadFilewithName(guid, name);

              case 3:
                _context.next = 8;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context["catch"](0);

                _this2.globals.$emit("openGlobalErrorDialog", { errorText: _this2.lang.G00025, colorOrange: false });

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 5]]);
      }))();
    },
    openFreeOfferDetailsDialog: function openFreeOfferDetailsDialog() {
      $("#freeOfferDetailsDialog").modal("show");
    },
    closeFreeOfferDetailsDialog: function closeFreeOfferDetailsDialog() {
      $("#freeOfferDetailsDialog").modal("hide");
    },
    acceptFreeOffer: function acceptFreeOffer() {
      var _this3 = this;

      var queryString = "/shopper-api/FreeOffer/Accept/?SurveyInstanceGuid=" + this.freeOffer.SurveyInstanceGuid;
      this.refreshEnabled = false;

      $.ajax({
        method: "POST",
        url: queryString,
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this3.globals.$emit("openGlobalErrorDialog", { errorText: data.Error, colorOrange: false });
          } else {
            _this3.globals.showSuccessSnackbar(_this3.lang.SFO112);
          }
          _this3.closeFreeOfferDetailsDialog();
          _this3.$emit("freeOfferAccepted");
        },
        error: function error() {
          console.error("Error on POST in acceptFreeOffer()");
          _this3.globals.$emit("openGlobalErrorDialog", { errorText: _this3.lang.SFO104, colorOrange: false });
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),

/***/ 290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Live__ = __webpack_require__(108);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "FreeOfferFilterChecksDialog",
  props: {
    showDialog: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      useFilters: false,
      useMyLocation: false,
      locationString: "",
      geocoder: null,
      formModel: {
        CurrentLocation: {
          Latitude: 0,
          Longitude: 0
        },
        Radius: 20000,
        LocationFilterValue: "LocationAny"
      },
      locationFilterTypes: {
        LocationAny: "LocationAny",
        LocationFree: "LocationFree",
        LocationNotFree: "LocationNotFree"
      },
      lang: {
        SFO200: "Filter",
        SFO201: "Location free",
        SFO202: "OK",
        SFO203: "Maximum distance from",
        // SFO204: "Payment",
        // SFO205: "Period",
        SFO206: "Location",
        SFO207: "Distance in km",
        SFO208: "Country",
        SFO209: "Please select...",
        SFO210: "From",
        SFO211: "To",
        SFO212: "Use Filters",
        SFO213: "The end date must not be before the start date",
        SFO214: "Clear inputs",
        SFO215: "Unknown GPS Error",
        SFO216: "GPS request denied by user",
        SFO217: "GPS information is unavailable",
        SFO218: "GPS request timeout",
        SFO219: "Please select any location from the search results!",
        SFO220: "The maximum amount must not be less than the minimum amount",
        SFO221: "Use my current location",
        SFO222: "Location detected",
        SFO223: "Not supported by your browser",
        SFO224: "No address data available",
        SFO225: "For devices without GPS (especially PCs/notebooks) the recorded location can deviate significantly",
        SF0226: "All checks",
        SF0227: "Only location free checks",
        SF0228: "Only not location free checks"
      }
    };
  },

  computed: {
    distanceInKm: {
      get: function get() {
        return this.formModel.Radius / 1000;
      },
      set: function set(value) {
        if (value < 0) value = 0;else if (value > 1000) value = 1000;
        this.formModel.Radius = value * 1000;
      }
    }
  },
  watch: {
    showDialog: function showDialog(newVal) {
      newVal ? this.openFreeOfferFilterChecksDialog() : this.closeFreeOfferFilterChecksDialog();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    },
    useMyLocation: function useMyLocation(newVal) {
      newVal ? this.getCurrentPosition() : this.initPlacesAutocomplete();
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
    }

    $("#freeOfferFilterChecksDialog").on("hide.bs.modal", function (e) {
      _this.$emit("dialogClosed");
    });

    if (!window.google) {
      this.globals.$once("googleInitDone", function () {
        _this.initPlacesAutocomplete();
        _this.initGeocoder();
      });
    } else {
      this.initPlacesAutocomplete();
      this.initGeocoder();
    }
  },

  methods: {
    openFreeOfferFilterChecksDialog: function openFreeOfferFilterChecksDialog() {
      $("#freeOfferFilterChecksDialog").modal("show");
      this.initFreeOfferFilterChecksDialog();
    },
    closeFreeOfferFilterChecksDialog: function closeFreeOfferFilterChecksDialog() {
      $("#freeOfferFilterChecksDialog").modal("hide");
    },
    initPlacesAutocomplete: function initPlacesAutocomplete() {
      var _this2 = this;

      this.$nextTick(function () {
        var input = document.getElementById("inputFreeOffersLocation");
        if (!input) return;
        if (_this2.locationString && _this2.locationString !== _this2.lang.SFO224) input.value = _this2.locationString;
        var autocomplete = new google.maps.places.Autocomplete(input);
        autocomplete.setFields(["geometry"]);
        autocomplete.addListener("place_changed", function () {
          var place = autocomplete.getPlace();
          if (!place.geometry) {
            _this2.resetCurrentLocation();
            return;
          }
          _this2.formModel.CurrentLocation = {
            Latitude: place.geometry.location.lat(),
            Longitude: place.geometry.location.lng()
          };
        });
      });
    },
    initGeocoder: function initGeocoder() {
      this.geocoder = new google.maps.Geocoder();

      // Test whether the geocoder is working. If not, try to clear all cached data and reload.
      // #1828
      this.geocoder.geocode({ address: "Dubiln" }, function (results, status) {
        if (status != google.maps.GeocoderStatus.OK) {
          __WEBPACK_IMPORTED_MODULE_0__services_Live__["a" /* default */].clearSiteDataAll();
          window.location.reload();
        }
      });
    },
    initFreeOfferFilterChecksDialog: function initFreeOfferFilterChecksDialog() {
      if (!this.$firstOpeningDone) {
        this.useFilters = true;
        this.$firstOpeningDone = true;
      }
    },
    resetFilter: function resetFilter() {
      this.formModel = {
        CurrentLocation: {
          Latitude: 0,
          Longitude: 0
        },
        Radius: 20000,
        LocationFilterValue: this.locationFilterTypes.LocationAny
      };
      this.useMyLocation = false;
      this.locationString = "";
      var input = document.getElementById("inputFreeOffersLocation");
      if (input) input.value = "";
    },
    resetCurrentLocation: function resetCurrentLocation() {
      this.formModel.CurrentLocation.Latitude = 0;
      this.formModel.CurrentLocation.Longitude = 0;
    },
    removeEmptyProperties: function removeEmptyProperties(filterOptions) {
      if (filterOptions.LocationFree || !filterOptions.CurrentLocation.Latitude && !filterOptions.CurrentLocation.Longitude) {
        delete filterOptions.CurrentLocation;
        delete filterOptions.Radius;
      }
      delete filterOptions.LocationFilterValue;
    },
    doFilterChecks: function doFilterChecks() {
      var filterOptions = _.cloneDeep(this.formModel);
      delete filterOptions.LocationFree;
      if (filterOptions.LocationFilterValue === this.locationFilterTypes.LocationFree) {
        filterOptions.LocationFree = true;
      }
      if (filterOptions.LocationFilterValue === this.locationFilterTypes.LocationNotFree) {
        filterOptions.LocationFree = false;
      }

      this.removeEmptyProperties(filterOptions);
      if (this.useFilters && !_.isEmpty(filterOptions)) this.$emit("filterChecks", filterOptions);else this.$emit("filterChecks");
      this.closeFreeOfferFilterChecksDialog();
    },
    getCurrentPosition: function getCurrentPosition() {
      var _this3 = this;

      this.locationString = "";

      if (navigator.geolocation) {
        var success = function success(pos) {
          _this3.formModel.CurrentLocation.Longitude = pos.coords.longitude;
          _this3.formModel.CurrentLocation.Latitude = pos.coords.latitude;

          var latlng = { lat: pos.coords.latitude, lng: pos.coords.longitude };
          _this3.geocoder.geocode({ location: latlng }, function (results, status) {
            if (status !== "OK") {
              _this3.globals.$emit("openGlobalErrorDialog", { errorText: "Geocoding failed with status " + status, colorOrange: false });
              console.error("Geocoding failed with status " + status);
              _this3.locationString = _this3.lang.SFO224;
              return;
            }

            var locality = _.find(results, function (r) {
              return _.indexOf(r.types, "locality") > -1;
            });
            if (locality && locality.formatted_address) {
              _this3.locationString = locality.formatted_address;
              _this3.globals.showSuccessSnackbar(_this3.lang.SFO222);
            } else _this3.locationString = _this3.lang.SFO224;
          });
        };
        var error = function error(_error) {
          var errMsg = _this3.lang.SFO215;
          switch (_error.code) {
            case _error.PERMISSION_DENIED:
              errMsg = _this3.lang.SFO216;
              break;
            case _error.POSITION_UNAVAILABLE:
              errMsg = _this3.lang.SFO217;
              break;
            case _error.TIMEOUT:
              errMsg = _this3.lang.SFO218;
              break;
          }
          _this3.globals.$emit("openGlobalErrorDialog", { errorText: errMsg, colorOrange: false });
          _this3.useMyLocation = false;
        };
        navigator.geolocation.getCurrentPosition(success, error);
      } else this.globals.$emit("openGlobalErrorDialog", { errorText: this.lang.SFO223, colorOrange: false });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),

/***/ 291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FreeOfferDetailsDialog__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FreeOfferDetailsDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__FreeOfferDetailsDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FreeOfferFilterChecksDialog__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FreeOfferFilterChecksDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__FreeOfferFilterChecksDialog__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "FreeOffers",
  components: { FreeOfferDetailsDialog: __WEBPACK_IMPORTED_MODULE_1__FreeOfferDetailsDialog___default.a, FreeOfferFilterChecksDialog: __WEBPACK_IMPORTED_MODULE_2__FreeOfferFilterChecksDialog___default.a },
  data: function data() {
    return {
      refreshEnabled: false,
      isSmallScreen: false,
      showFreeOfferDetailsDialog: false,
      showFreeOfferFilterChecksDialog: false,
      pageSize: 20,
      selectedPage: 1,
      pageCount: 0,
      checkCount: 0,
      currentSort: { key: "SurveyInstanceId", asc: true },
      freeOffers: [],
      selectedFreeOffer: {},
      selectedFreeOfferGuid: "",
      lang: {
        SFO000: "Refresh",
        SFO001: "Show Details",
        SFO002: "Search...",
        SFO003: "Filter",
        SFO004: "Items per page",
        SFO005: "First page",
        SFO006: "Last page",
        SFO007: "Check data request failed",
        SFO008: "CheckID",
        SFO009: "Since",
        SFO010: "Until",
        SFO011: "Description",
        SFO012: "Project",
        SFO013: "Payment",
        SFO014: "Others",
        SFO015: "Distance",
        SFO016: "Filter",
        SFO017: "Project",
        SFO018: "City",
        SFO019: "Informations",
        SFO020: "Scenario",
        SFO021: "Check Info",
        SFO022: "Postal Code",
        SFO023: "Country",
        SFO024: "Total check count",
        SFO025: "Distance"
      },
      filterStrings: {
        Search: "",
        SurveyInstanceId: "",
        SurveyInstanceSince: "",
        SurveyInstanceUntil: "",
        SurveyInstanceDescription: "",
        LocationCity: "",
        LocationPostalCode: "",
        LocationCountry: "",
        ScenarioName: "",
        SurveyInstanceInfo: "",
        LocationAdditionalInfo: "",
        SurveyTitle: "",
        TotalPayment: ""
      },
      // userProfileLocation: {
      //   PostalCode: "",
      //   Country: ""
      // }
      filterOptions: {}
    };
  },

  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
      this.getFreeOffers();
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) {
      this.getFreeOffers();
      this.globals.getLanguageStrings(this);
    }

    var resizeFunc = function resizeFunc() {
      _this.isSmallScreen = _this.globals.isSmallScreen();
      _this.$nextTick(function () {
        _this.setElementHeights();
        _this.$forceUpdate();
      });
    };
    $(window).off("resize", resizeFunc);
    $(window).on("resize", resizeFunc).resize();
  },

  methods: {
    getFreeOffers: function getFreeOffers() {
      var _this2 = this;

      this.selectedFreeOfferGuid = "";

      if (!this.filterOptions.CurrentLocation && this.currentSort.key === "Distance") this.currentSort = { key: "SurveyInstanceId", asc: true };

      var queryString = "/shopper-api/FreeOffer/SurveyInstances?page_size=" + this.pageSize + "&page=" + this.selectedPage + "&sort_column=" + this.currentSort.key + "&sort_order=" + (this.currentSort.asc ? "asc" : "desc");

      var filterStrings = _.pickBy(this.filterStrings, function (value, key) {
        return value.length > 0;
      });
      var sendData = {};
      if (!_.isEmpty(filterStrings)) sendData.Filter = filterStrings;
      if (!_.isEmpty(this.filterOptions)) sendData.ParameterFilter = this.filterOptions;
      this.refreshEnabled = false;

      $.ajax({
        method: "POST",
        url: queryString,
        data: _.isEmpty(sendData) ? "" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (!_.isEmpty(data)) {
            _this2.freeOffers = data[0].SurveyInstances;
            _this2.pageCount = data[0].Page_Count;
            _this2.selectedPage = data[0].Page;
            _this2.pageSize = data[0].Page_Size;
            _this2.checkCount = data[0].Count;
          }
        },
        error: function error() {
          console.error("Error on POST in getFreeOffers()");
          _this2.globals.$emit("openGlobalErrorDialog", { errorText: _this2.lang.SFO007, colorOrange: false });
        },
        complete: function complete() {
          _this2.refreshEnabled = true;
        }
      });
    },
    updatePaging: function updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber;
      if (pageSize != 0) this.pageSize = pageSize;
      this.getFreeOffers();
    },
    getRange: function getRange(min, max, step) {
      var range = [],
          j = 0;
      for (var i = min; i <= max; i += step) {
        range[j++] = i;
      }
      return range;
    },
    getVisiblePages: function getVisiblePages() {
      if (this.pageCount <= 7) {
        return this.getRange(1, this.pageCount, 1);
      } else if (this.pageCount > 7 && this.selectedPage <= 4) {
        return this.getRange(1, 6, 1);
      } else if (this.pageCount > 7 && this.selectedPage >= this.pageCount - 3) {
        return this.getRange(this.pageCount - 5, this.pageCount, 1);
      } else {
        return this.getRange(this.selectedPage - 2, this.selectedPage + 2, 1);
      }
    },
    showSortArrow: function showSortArrow(key, asc) {
      return this.currentSort.key === key && this.currentSort.asc === asc;
    },
    orderTableByColumn: function orderTableByColumn(orderProp) {
      if (!orderProp && !this.currentSort.key) return;
      if (orderProp) {
        this.currentSort.key === orderProp ? this.currentSort.asc = !this.currentSort.asc : this.currentSort = { asc: true, key: orderProp };
      }
      this.getFreeOffers();
    },
    setElementHeights: function setElementHeights() {
      var height = $(window).height();
      /* height -=
        $("#app-navbar").height() +
        $("#free-offer-top-panel").height() +
        $(".main-table > thead").height() +
        47; */

      height -= $("#free-offer-top-panel").height() + $(".main-table > thead").height() + 47;

      $(".table-space").css("max-height", height);
      $(".main-table-scrollbar").css("max-height", height);
      var table = $(".main-table-scrollbar");
      table.css("max-height", height);

      // Set top for Filter, that it doesent scroll over table-header
      height = $(".main-table thead tr").height();
      $(".sticky-filter").css("top", height);
      /* if (
        this.globals.isMobileBrowser &&
        this.globals.isScreenOrientationLandscape()
      ) {
        table.css("overflow-y", "visible");
        table.css("height", "0");
      } else {
        table.css("overflow-y", "");
        table.css("height", "");
      } */
    },
    openFreeOfferDetailsDialog: function openFreeOfferDetailsDialog() {
      var _this3 = this;

      this.selectedFreeOffer = this.freeOffers.find(function (freeOffer) {
        return freeOffer.SurveyInstanceGuid === _this3.selectedFreeOfferGuid;
      });
      this.showFreeOfferDetailsDialog = true;
    },
    closeFreeOfferDetailsDialog: function closeFreeOfferDetailsDialog() {
      this.showFreeOfferDetailsDialog = false;
    },
    openFreeOfferFilterChecksDialog: function openFreeOfferFilterChecksDialog() {
      // this.getProfileData();
      this.showFreeOfferFilterChecksDialog = true;
    },
    closeFreeOfferFilterChecksDialog: function closeFreeOfferFilterChecksDialog() {
      this.showFreeOfferFilterChecksDialog = false;
    },
    onFreeOfferAccepted: function onFreeOfferAccepted() {
      this.getFreeOffers();
    },
    onFilterChecks: function onFilterChecks(filterOptions) {
      if (filterOptions) this.filterOptions = filterOptions;else this.filterOptions = {};
      this.selectedPage = 1;
      this.getFreeOffers();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),

/***/ 292:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var ibantools = __webpack_require__(392);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "BankDetails",
  props: {
    data: { type: Object, default: function _default() {} }
  },
  data: function data() {
    return {
      bankDetailsDataIsDirty: false,
      canEditBankDetails: false,
      hasBankDetails: false,
      lang: {
        SET300: "Bank Details",
        SET301: "Bank Name",
        SET302: "IBAN",
        SET303: "BIC",
        SET304: "Account Owner",
        SET305: "ATTENTION: Changes will update the data in your user profile!",
        SET306: "VAT",
        SET307: "VAT No",
        SET308: "VAT not mandatory",
        SET309: "Informations incomplete",
        SET310: "Invalid IBAN",
        SET311: "Invalid BIC"
      }
    };
  },
  mounted: function mounted() {
    this.setShopperHasBankDetails();
    this.globals.getLanguageStrings(this);
  },

  computed: {
    bankDetailsData: function bankDetailsData() {
      return this.data.BankDetails;
    },
    shopperProfileData: function shopperProfileData() {
      return this.data.ShopperProfileData;
    },
    missingFormData: function missingFormData() {
      return _.isEmpty(this.bankDetailsData) || !this.bankDetailsData.AccountName || !this.bankDetailsData.AccountNumber || !this.bankDetailsData.BankName || !this.bankDetailsData.SwiftCode || !this.shopperProfileData.VatNotMandatory && !this.shopperProfileData.VatNo;
    }
  },
  methods: {
    saveShopperBankDetails: function saveShopperBankDetails() {
      if (this.missingFormData) {
        this.globals.$emit("openGlobalErrorDialog", { errorText: this.lang.SET309, colorOrange: false });
        return;
      }

      if (!this.validateBankDetails()) return;

      this.globals.$emit("saveShopperBankDetails", {
        BankDetails: this.bankDetailsData,
        ShopperProfileData: this.shopperProfileData
      });
    },
    validateBankDetails: function validateBankDetails() {
      if (this.bankDetailsData.AccountNumber) {
        this.bankDetailsData.AccountNumber = this.bankDetailsData.AccountNumber.replace(/ /g, "");
        if (!ibantools.isValidIBAN(this.bankDetailsData.AccountNumber)) {
          this.globals.$emit("openGlobalErrorDialog", { errorText: this.lang.SET310, colorOrange: false });
          return false;
        }
      }
      if (this.bankDetailsData.SwiftCode) {
        this.bankDetailsData.SwiftCode = this.bankDetailsData.SwiftCode.replace(/ /g, "");
        if (!ibantools.isValidBIC(this.bankDetailsData.SwiftCode)) {
          this.globals.$emit("openGlobalErrorDialog", { errorText: this.lang.SET311, colorOrange: false });
          return false;
        }
      }
      return true;
    },
    setSavedShopperBankDetails: function setSavedShopperBankDetails() {
      this.bankDetailsDataIsDirty = false;
      this.setShopperHasBankDetails();
      this.globals.$emit("editBankDetails", this.canEditBankDetails);
    },
    setCanEditBankDetails: function setCanEditBankDetails() {
      this.canEditBankDetails = true;
      this.globals.$emit("editBankDetails", this.canEditBankDetails);
    },
    cancelEditBankDetails: function cancelEditBankDetails() {
      this.canEditBankDetails = false;
      this.bankDetailsDataIsDirty = false;
      this.globals.$emit("getBankDetails");
    },

    // if shopper has no bank details saved in his profile -> input fields are not disabled
    setShopperHasBankDetails: function setShopperHasBankDetails() {
      if (!this.missingFormData) {
        this.canEditBankDetails = false;
        this.hasBankDetails = true;
      } else {
        this.canEditBankDetails = true;
        this.hasBankDetails = false;
      }
      this.globals.$emit("editBankDetails", this.canEditBankDetails);
    }
  }
});

/***/ }),

/***/ 293:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "BillingOverview",
  props: {
    data: { type: Object, default: function _default() {} }
  },
  data: function data() {
    return {
      lang: {
        SET400: "Billing Overview",
        SET401: "The submission of the invoice is binding!",
        SET402: "Billing address",
        SET403: "Bank details",
        SET404: "Check ID",
        SET405: "Project",
        SET406: "Payment",
        SET407: "Bank Name",
        SET408: "IBAN",
        SET409: "BIC",
        SET410: "Account Owner",
        SET411: "Total",
        SET412: "VAT",
        SET413: "Others",
        SET414: "Payout"
      }
    };
  },

  computed: {
    bankDetailsData: function bankDetailsData() {
      return this.data.BankDetails;
    },
    shopperCart: function shopperCart() {
      return this.data.ShopperCart;
    },
    shopperBillingAddress: function shopperBillingAddress() {
      var data = this.data.ShopperProfileData;
      return {
        Name: data.FirstName + " " + data.LastName,
        Street: "" + data.Address1,
        PLZCity: data.PostalCode + " " + data.City
      };
    },
    vatNotMandatory: function vatNotMandatory() {
      return !!this.data.ShopperProfileData.VatNotMandatory;
    }
  },
  mounted: function mounted() {
    this.globals.getLanguageStrings(this);
  }
});

/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CheckOverview",
  props: {
    data: { type: Object, default: function _default() {} }
  },
  data: function data() {
    return {
      lang: {
        SET200: "Checks",
        SET201: "Check ID",
        SET202: "Project",
        SET203: "Payment",
        SET204: "Total"
      }
    };
  },
  mounted: function mounted() {
    this.globals.getLanguageStrings(this);
  },

  computed: {
    shopperCart: function shopperCart() {
      return this.data;
    }
  }
});

/***/ }),

/***/ 295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CompletionMessageComponent",
  props: {
    data: { type: Object, default: function _default() {} }
  },
  data: function data() {
    return {
      lang: {
        SET500: "Thank you! We process your invoice!"
      }
    };
  },
  mounted: function mounted() {
    this.globals.getLanguageStrings(this);
  }
});

/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CheckoutSteps_CheckOverview__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CheckoutSteps_CheckOverview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CheckoutSteps_CheckOverview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CheckoutSteps_BankDetails__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CheckoutSteps_BankDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CheckoutSteps_BankDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CheckoutSteps_CompletionMessage__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CheckoutSteps_CompletionMessage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CheckoutSteps_CompletionMessage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CheckoutSteps_BillingOverview__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CheckoutSteps_BillingOverview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CheckoutSteps_BillingOverview__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SettlementCheckout",
  props: {
    showDialog: { type: Boolean, default: false },
    selectedSurveys: { type: Array, default: function _default() {
        return [];
      } }
  },
  components: {
    CheckOverview: __WEBPACK_IMPORTED_MODULE_1__CheckoutSteps_CheckOverview___default.a,
    BankDetails: __WEBPACK_IMPORTED_MODULE_2__CheckoutSteps_BankDetails___default.a,
    CompletionMessage: __WEBPACK_IMPORTED_MODULE_3__CheckoutSteps_CompletionMessage___default.a,
    BillingOverview: __WEBPACK_IMPORTED_MODULE_4__CheckoutSteps_BillingOverview___default.a
  },
  data: function data() {
    return {
      currentStep: 0,
      shopperCart: {},
      shopperProfileData: {},
      shopperBankDetails: {},
      editBankDetails: false,
      isSmallScreen: false,
      checkoutGuid: "",
      lang: {
        SET100: "Invoice",
        SET101: "Cancel",
        SET102: "Next",
        SET103: "Confirm",
        SET104: "Bank details updated",
        SET105: "Bank details update failed",
        SET106: "Checks",
        SET107: "Bank Details",
        SET108: "Completion",
        SET109: "Billing Overview",
        SET110: "Previous",
        SET111: "Invoice submission failed",
        SET112: "Cart creation failed",
        SET113: "Adding cart content failed",
        SET114: "Cart request failed",
        SET115: "Cart deletion failed",
        SET116: "Bank details request failed",
        SET117: "Billing address request failed",
        SET118: "Close"
      }
    };
  },
  created: function created() {
    var _this = this;

    this.globals.$off("getBankDetails");
    this.globals.$on("getBankDetails", function () {
      _this.editBankDetails = false;
      _this.getShopperBankDetails();
      _this.getShopperProfileData();
    });

    this.globals.$off("saveShopperBankDetails");
    this.globals.$on("saveShopperBankDetails", function (data) {
      _this.shopperBankDetails = data.BankDetails;
      _this.shopperProfileData = data.ShopperProfileData;

      var requestCount = 2;
      var success = function success() {
        if (--requestCount > 0) return;
        _this.$refs.checkoutComponent.setSavedShopperBankDetails();
        _this.globals.showSuccessSnackbar(_this.lang.SET104);
      };
      var error = function error() {
        _this.globals.$emit("openGlobalErrorDialog", { errorText: _this.lang.SET105, colorOrange: false });
      };
      _this.saveShopperBankDetails(success, error);
      _this.saveShopperProfileData(success, error);
    });

    this.globals.$off("editBankDetails");
    this.globals.$on("editBankDetails", function (editBankDetails) {
      _this.editBankDetails = editBankDetails;
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#settlementCheckoutDialog").on("hide.bs.modal", function (e) {
      _this2.$emit("dialogClosed");
    });

    // Sets the new table height after the window got resized
    var resizeFunc = function resizeFunc() {
      _this2.isSmallScreen = _this2.globals.isSmallScreen();
      _this2.$forceUpdate();
    };
    $(window).off("resize", resizeFunc);
    $(window).on("resize", resizeFunc).resize();
  },

  computed: {
    checkoutComponents: function checkoutComponents() {
      // components in the series of their appearance
      return [{
        name: this.lang.SET106,
        component: "CheckOverview",
        props: this.shopperCart
      }, {
        name: this.lang.SET107,
        component: "BankDetails",
        props: {
          BankDetails: this.shopperBankDetails,
          ShopperProfileData: this.shopperProfileData
        }
      }, {
        name: this.lang.SET109,
        component: "BillingOverview",
        props: {
          ShopperCart: this.shopperCart,
          BankDetails: this.shopperBankDetails,
          ShopperProfileData: this.shopperProfileData
        }
      }, {
        name: this.lang.SET108,
        component: "CompletionMessage"
      }];
    }
  },
  watch: {
    showDialog: function showDialog(newValue) {
      newValue ? this.openSettlementCheckoutDialog() : this.closeSettlementCheckoutDialog();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    },
    currentStep: function currentStep(newValue, oldValue) {
      if (this.globals.isMobileBrowser || !this.globals.isLargeScreen()) return;
      if (newValue === 2) $("#settlementCheckoutDialog .modal-dialog").css("width", "1100px");else if (oldValue === 2) $("#settlementCheckoutDialog .modal-dialog").css("width", "");
    }
  },
  methods: {
    openSettlementCheckoutDialog: function openSettlementCheckoutDialog() {
      this.initSettlementCheckoutDialog();
    },
    closeSettlementCheckoutDialog: function closeSettlementCheckoutDialog() {
      if (this.checkoutGuid) this.$emit("dialogDataSaved");
      $("#settlementCheckoutDialog").modal("hide");
    },
    initSettlementCheckoutDialog: function initSettlementCheckoutDialog() {
      this.currentStep = 0;
      this.editBankDetails = false;
      this.checkoutGuid = "";
      this.getShopperBankDetails();
      this.getShopperProfileData();
      this.deleteAllCarts(true);
    },
    onFinishSettlement: function onFinishSettlement() {
      var _this3 = this;

      var payload = {
        CartGuid: this.shopperCart.CartGuid,
        BankDetailsGuid: this.shopperBankDetails.BankDetailsGuid
      };
      var queryString = "/shopper-api/Checkout";

      $.ajax({
        method: "POST",
        url: queryString,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            _this3.globals.$emit("openGlobalErrorDialog", { errorText: data.Error, colorOrange: false });
            console.error(data.Error);
            return;
          }
          _this3.checkoutGuid = data.CheckoutGuid;
          _this3.currentStep++;
        },
        error: function error() {
          console.error("Error on POST in onFinishSettlement()");
          _this3.globals.$emit("openGlobalErrorDialog", { errorText: _this3.lang.SET111, colorOrange: false });
        }
      });
    },
    createEmptyCart: function createEmptyCart() {
      var _this4 = this;

      var queryString = "/shopper-api/Cart";

      $.ajax({
        method: "POST",
        url: queryString,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            _this4.globals.$emit("openGlobalErrorDialog", { errorText: data.Error, colorOrange: false });
            console.error(data.Error);
            _this4.$emit("dialogClosed");
            return;
          }

          _this4.shopperCart.CartGuid = data.CartGuid;
          _this4.addSurveyInstancesToCart();
        },
        error: function error() {
          console.error("Error on POST in createEmptyCart()");
          _this4.globals.$emit("openGlobalErrorDialog", { errorText: _this4.lang.SET112, colorOrange: false });
        }
      });
    },
    addSurveyInstancesToCart: function addSurveyInstancesToCart() {
      var _this5 = this;

      var payload = this.selectedSurveys.map(function (selectedSurvey) {
        return {
          SurveyInstanceGuid: selectedSurvey
        };
      });
      var queryString = "/shopper-api/Cart/" + this.shopperCart.CartGuid + "/Items";

      $.ajax({
        method: "POST",
        url: queryString,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            _this5.globals.$emit("openGlobalErrorDialog", { errorText: data.Error, colorOrange: false });
            console.error(data.Error);
            _this5.$emit("dialogClosed");
            return;
          }

          _this5.getShopperCart(true);
          $("#settlementCheckoutDialog").modal("show");
        },
        error: function error() {
          console.error("Error on POST in addSurveyInstancesToCart()");
          _this5.globals.$emit("openGlobalErrorDialog", { errorText: _this5.lang.SET113, colorOrange: false });
        }
      });
    },
    getShopperCart: function getShopperCart(isCartEmpty) {
      var _this6 = this;

      var queryString = "/shopper-api/Cart";

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (!_.isEmpty(data)) {
            _this6.shopperCart = data;
            if (!isCartEmpty) _this6.deleteAllCarts(true);
          } else _this6.createEmptyCart();
        },
        error: function error() {
          console.error("Error on GET in getShopperCart()");
          _this6.globals.$emit("openGlobalErrorDialog", { errorText: _this6.lang.SET114, colorOrange: false });
        }
      });
    },
    deleteAllCarts: function deleteAllCarts(createNewCart) {
      var _this7 = this;

      $.ajax({
        method: "DELETE",
        url: "shopper-api/Cart",
        success: function success() {
          if (createNewCart) _this7.createEmptyCart();
        },
        error: function error() {
          console.error("Error on DELETE in deleteAllCarts()");
          _this7.globals.$emit("openGlobalErrorDialog", { errorText: _this7.lang.SET115, colorOrange: false });
        }
      });
    },
    getShopperBankDetails: function getShopperBankDetails() {
      var _this8 = this;

      var queryString = "/shopper-api/Profile/BankDetails";

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (!_.isEmpty(data)) {
            _this8.shopperBankDetails = data[0];
          } else _this8.shopperBankDetails = {};
        },
        error: function error() {
          console.error("Error on GET in getShopperBankDetails()");
          _this8.globals.$emit("openGlobalErrorDialog", { errorText: _this8.lang.SET116, colorOrange: false });
        }
      });
    },
    saveShopperBankDetails: function saveShopperBankDetails(_success, _error) {
      var _this9 = this;

      var queryString = "shopper-api/Profile/BankDetails";
      var reqMethod = "POST";
      if (this.shopperBankDetails.BankDetailsGuid) {
        queryString += "/" + this.shopperBankDetails.BankDetailsGuid;
        reqMethod = "PUT";
      }

      $.ajax({
        method: reqMethod,
        url: queryString,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.shopperBankDetails),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(response) {
          if (response && !_.isEmpty(response)) {
            _this9.shopperBankDetails = response;
          }
          if (_success) _success();
        },
        error: function error() {
          console.error("Error on " + reqMethod + " in saveShopperBankDetails()");
          if (_error) _error();
        }
      });
    },
    getShopperProfileData: function getShopperProfileData() {
      var _this10 = this;

      var queryString = "/shopper-api/Profile";

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this10.shopperProfileData = data;
        },
        error: function error() {
          console.error("Error on GET in getShopperProfileData()");
          _this10.globals.$emit("openGlobalErrorDialog", { errorText: _this10.lang.SET117, colorOrange: false });
        }
      });
    },
    saveShopperProfileData: function saveShopperProfileData(_success2, _error2) {
      var _this11 = this;

      var queryString = "shopper-api/Profile";

      $.ajax({
        method: "PUT",
        url: queryString,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.shopperProfileData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this11.getShopperCart(true);
          if (_success2) _success2();
        },
        error: function error() {
          console.error("Error on PUT in saveShopperProfileData()");
          if (_error2) _error2();
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),

/***/ 297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SettlementInformationModal",
  props: {
    showModal: { type: Boolean, default: false },
    checkData: { type: Object, default: function _default() {} }
  },
  data: function data() {
    return {
      lang: {
        SET600: "Invoice Information",
        SET601: "CheckID",
        SET602: "Project",
        SET603: "Location",
        SET604: "Invoice time",
        SET605: "Comment",
        SET606: "Base payment",
        SET607: "Addition",
        SET608: "Deduction",
        SET609: "Total payment",
        SET610: "VAT",
        SET611: "Others",
        SET612: "Payout",
        SET613: "Close",
        SET614: "Address",
        SET615: "Wave"
      }
    };
  },

  watch: {
    showModal: function showModal(newValue) {
      newValue ? this.openSettlementInformationModal() : this.closeSettlementInformationModal();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#settlementInformationModal").on("hide.bs.modal", function (e) {
      _this.$emit("closeModal");
    });
  },

  methods: {
    openSettlementInformationModal: function openSettlementInformationModal() {
      $("#settlementInformationModal").modal("show");
    },
    closeSettlementInformationModal: function closeSettlementInformationModal() {
      $("#settlementInformationModal").modal("hide");
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),

/***/ 298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SettlementCheckoutDialog__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SettlementCheckoutDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SettlementCheckoutDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SettlementInformationModal__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SettlementInformationModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SettlementInformationModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tools_Select2__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Tools_Select2__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SettlementList",
  components: {
    SettlementCheckoutDialog: __WEBPACK_IMPORTED_MODULE_1__SettlementCheckoutDialog___default.a,
    SettlementInformationModal: __WEBPACK_IMPORTED_MODULE_2__SettlementInformationModal___default.a,
    Select2: __WEBPACK_IMPORTED_MODULE_3__Tools_Select2___default.a
  },
  data: function data() {
    return {
      isSmallScreen: false,
      refreshEnabled: false,
      surveyInstances: [],
      pageSize: 20,
      selectedPage: 1,
      pageCount: 0,
      checkCount: 0,
      currentSort: { key: "SettlementStatusGuid", asc: true },
      showSettlementCheckoutDialog: false,
      showSettlementInformationModal: false,
      selectedSurveys: [],
      lastSelectedSurvey: -1,
      settlementStatusList: {},
      filterStrings: {
        Search: "",
        SurveyInstanceId: "",
        SurveyTitle: "",
        LocationName: "",
        SettlementStatusGuid: "",
        SurveyInstanceShopperSubmittedAt: "",
        Total: "",
        SettlementNumber: ""
      },
      lang: {
        SET000: "Refresh",
        SET001: "Filter",
        SET002: "Search...",
        SET003: "Items per page",
        SET004: "Settle",
        SET005: "CheckID",
        SET006: "Project",
        SET007: "Location",
        SET008: "Invoice State",
        SET009: "Submitted At",
        SET010: "Payment",
        SET011: "First page",
        SET012: "Invoice Number",
        SET013: "Project",
        SET014: "Where?",
        SET015: "Status...",
        SET016: "All",
        SET017: "State",
        SET018: "Notification",
        SET019: "Close",
        SET020: "The invoice was already initiated for some of the selected checks.",
        SET021: "Please only select checks with an open invoice state.",
        SET022: "Check data request failed",
        SET023: "Info",
        SET024: "Address",
        SET025: "Country",
        SET026: "Last page",
        SET027: "Total check count"
      }
    };
  },

  computed: {
    firstSelectedCheckData: function firstSelectedCheckData() {
      var _this = this;

      if (this.selectedSurveys.length < 1) return {};
      return _.find(this.surveyInstances, function (s) {
        return s.SurveyInstanceGuid === _this.selectedSurveys[0];
      });
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
      this.getSurveyInstances();
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.globals.getSettlementStatusList(function (callbackData) {
      _this2.settlementStatusList = callbackData;
    });

    if (this.globals.selectedLanguage) {
      this.getSurveyInstances();
      this.globals.getLanguageStrings(this);
    }

    // Sets the new table height after the window got resized
    var resizeFunc = function resizeFunc() {
      _this2.isSmallScreen = _this2.globals.isSmallScreen();
      _this2.$nextTick(function () {
        _this2.setElementHeights();
        _this2.$forceUpdate();
      });
    };
    $(window).off("resize", resizeFunc);
    $(window).on("resize", resizeFunc).resize();
  },

  methods: {
    getSurveyInstances: function getSurveyInstances() {
      var _this3 = this;

      this.selectedSurveys = [];

      var queryString = "/shopper-api/Settlement/SurveyInstances?page_size=" + this.pageSize + "&page=" + this.selectedPage + "&sort_column=" + this.currentSort.key + "&sort_order=" + (this.currentSort.asc ? "asc" : "desc");

      var filter = _.pickBy(this.filterStrings, function (value, key) {
        return value.length > 0;
      });
      this.refreshEnabled = false;

      $.ajax({
        method: "POST",
        url: queryString,
        data: _.isEmpty(filter) ? "" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ Filter: filter }),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (!_.isEmpty(data)) {
            _this3.surveyInstances = data[0].SurveyInstances;
            _this3.pageCount = data[0].Page_Count;
            _this3.selectedPage = data[0].Page;
            _this3.pageSize = data[0].Page_Size;
            _this3.checkCount = data[0].Count;
          }
        },
        error: function error() {
          console.error("Error on POST in getSurveyInstances()");
          _this3.globals.$emit("openGlobalErrorDialog", { errorText: _this3.lang.SET022, colorOrange: false });
        },
        complete: function complete() {
          _this3.refreshEnabled = true;
        }
      });
    },
    openSettlementCheckoutDialog: function openSettlementCheckoutDialog() {
      var _this4 = this;

      var canOpenDialog = true;
      this.selectedSurveys.forEach(function (selectedSurvey) {
        var survey = _this4.surveyInstances.find(function (surveyInstance) {
          return surveyInstance.SurveyInstanceGuid === selectedSurvey;
        });
        // 5D298073-70E7-472F-9E01-AF19E2BA1C03 -> in progress
        // 39E928BA-82BA-4ADD-9E89-04AE44CBCA04 -> completed
        if (survey.SettlementStatusGuid !== "31F176F1-6D31-4F88-BDC5-B62F4EFB5107") canOpenDialog = false;
      });
      if (canOpenDialog) this.showSettlementCheckoutDialog = true;else this.globals.$emit("openGlobalNotificationDialog", this.getNotificationDialogData());
    },
    getNotificationDialogData: function getNotificationDialogData() {
      return {
        initiator: "SettlementList",
        notificationTitle: this.lang.SET018,
        closeButtonText: this.lang.SET019,
        htmlText: "<p>" + this.lang.SET020 + "</p>\n                   <p>" + this.lang.SET021 + "</p>"
      };
    },
    closeSettlementCheckoutDialog: function closeSettlementCheckoutDialog() {
      this.showSettlementCheckoutDialog = false;
    },
    selectSurveys: function selectSurveys(surveyGuid, e) {
      var _this5 = this;

      if (!e) return;

      if (e.ctrlKey && !e.shiftKey || this.globals.isMobileBrowser) {
        var idx = _.indexOf(this.selectedSurveys, surveyGuid);
        if (idx > -1) {
          _.pullAt(this.selectedSurveys, idx);
          this.lastSelectedSurvey = -1;
        } else {
          this.selectedSurveys.push(surveyGuid);
          this.lastSelectedSurvey = surveyGuid;
        }
      } else if (!e.ctrlKey && e.shiftKey) {
        document.getSelection().removeAllRanges();
        if (this.lastSelectedSurvey < 0) return;
        var idx1 = _.findIndex(this.surveyInstances, function (c) {
          return c.SurveyInstanceGuid === _this5.lastSelectedSurvey;
        });
        var idx2 = _.findIndex(this.surveyInstances, function (c) {
          return c.SurveyInstanceGuid === surveyGuid;
        });

        if (idx1 > idx2) {
          ;

          var _ref = [idx1, idx2];
          idx2 = _ref[0];
          idx1 = _ref[1];
        }for (var i = idx1; i <= idx2; i++) {
          if (!this.isSurveySelected(this.surveyInstances[i].SurveyInstanceGuid)) this.selectedSurveys.push(this.surveyInstances[i].SurveyInstanceGuid);
        }
      } else {
        this.selectedSurveys = [surveyGuid];
        this.lastSelectedSurvey = surveyGuid;
      }
      this.$forceUpdate();
    },
    isSurveySelected: function isSurveySelected(surveyGuid) {
      return _.indexOf(this.selectedSurveys, surveyGuid) > -1;
    },
    updatePaging: function updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber;
      if (pageSize != 0) this.pageSize = pageSize;
      this.getSurveyInstances();
    },
    getRange: function getRange(min, max, step) {
      var range = [],
          j = 0;
      for (var i = min; i <= max; i += step) {
        range[j++] = i;
      }
      return range;
    },
    getVisiblePages: function getVisiblePages() {
      if (this.pageCount <= 7) {
        return this.getRange(1, this.pageCount, 1);
      } else if (this.pageCount > 7 && this.selectedPage <= 4) {
        return this.getRange(1, 6, 1);
      } else if (this.pageCount > 7 && this.selectedPage >= this.pageCount - 3) {
        return this.getRange(this.pageCount - 5, this.pageCount, 1);
      } else {
        return this.getRange(this.selectedPage - 2, this.selectedPage + 2, 1);
      }
    },
    showSortArrow: function showSortArrow(key, asc) {
      return this.currentSort.key === key && this.currentSort.asc === asc;
    },
    orderTableByColumn: function orderTableByColumn(orderProp) {
      if (!orderProp && !this.currentSort.key) return;
      if (orderProp) {
        this.currentSort.key === orderProp ? this.currentSort.asc = !this.currentSort.asc : this.currentSort = { asc: true, key: orderProp };
      }
      this.getSurveyInstances();
    },
    setElementHeights: function setElementHeights() {
      var height = $(window).height();

      height -= $("#settlement-top-panel").height() + $(".main-table > thead").height() + 47;
      //$(".table-space").css("max-height", height);
      //$(".main-table-scrollbar").css("max-height", height);
      //let table = $(".main-table-scrollbar");
      //table.css("max-height", height);

      // Set top for Filter, that it doesent scroll over table-header
      height = $(".main-table thead tr").height();
      $(".sticky-filter").css("top", height);
      /* 
      if (
        this.globals.isMobileBrowser &&
        this.globals.isScreenOrientationLandscape()
      ) {
        table.css("overflow-y", "visible");
        table.css("height", "0");
      } else {
        table.css("overflow-y", "");
        table.css("height", "");
      }
      */
    },
    onDialogDataSaved: function onDialogDataSaved() {
      this.getSurveyInstances();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),

/***/ 299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Tools_Dialogs_ConfirmationDialog__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Tools_Dialogs_ConfirmationDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Tools_Dialogs_ConfirmationDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Tools_Select2__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Tools_Select2__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SurveyList",
  components: {
    ConfirmationDialog: __WEBPACK_IMPORTED_MODULE_5__Tools_Dialogs_ConfirmationDialog___default.a,
    Select2: __WEBPACK_IMPORTED_MODULE_6__Tools_Select2___default.a
  },
  data: function data() {
    return {
      showConfirmationDialog: false,
      locationChoosen: false,
      languageChoosen: false,
      possibleLocations: [],
      placeholderSelectLocation: { id: "0", text: "Please select an entry..." },
      allSurveyInstancesAnswersData: [],
      selectedLocation: null,
      selectedSurveyInstanceId: -1,
      selectedSurveyInstance: null,
      surveyInstanceAnswerData: null,
      surveyInstanceAnswerLanguageList: [],
      selectedSurveyInstanceAnswerLanguage: "",
      selectedSurveyDisplayOnlyMode: false,
      showSurvey: false,
      filteredSurveyListData: [],
      searchString: "",
      filters: {
        SurveyInstanceStatusId: "",
        SurveyTitle: "",
        SurveyInstanceId: "",
        LocationName: "",
        LocationAddress: "",
        ScenarioName: "",
        WaveName: "",
        SurveyInstanceInfo: "",
        LocationAdditionalInfo: "",
        SurveyInstanceProgress: "",
        SurveyInstanceShopperSubmittedAt: ""
      },
      refreshEnabled: false, // false, if client data is requested and server did not respond yet to avoid multiple requests at the same time
      surveysOnCurrentPage: [],
      pageSize: 20, // Number of projects on one page of the table
      selectedPage: 1, // Number of the page, that is visible
      debouncedFilterFunction: null,
      lang: {
        SL0000: "SurveyInstanceID",
        SL0001: "Language",
        SL0002: "Please choose...",
        SL0003: "Status",
        SL0004: "Project",
        SL0005: "SurveyInstanceID",
        SL0006: "StoreID",
        SL0007: "Address",
        SL0008: "Progress",
        SL0009: "Refresh",
        SL0010: "Open",
        SL0011: "Submit",
        SL0012: "Search...",
        SL0013: "Scenario Name",
        SL0014: "Wave Name",
        SL0015: "Location Info",
        SL0016: "Location Name",
        SL0017: "Display only mode",
        SL0018: "Open survey",
        SL0019: "Open",
        SL0020: "Cancel",
        SL0021: "Items per page",
        SL0022: "First page",
        SL0023: "Last page",
        SL0024: "Where?",
        SL0025: "Project",
        SL0026: "Info",
        SL0027: "Filter",
        SL0028: "New",
        SL0029: "In progress",
        SL0030: "Submitted",
        SL0031: "Query",
        SL0032: "Submitted At",
        SL0033: "Status...",
        SL0034: "All",
        SL0035: "Briefing",
        SL0036: "Survey",
        SL0037: "Payment",
        SL0038: "Expiry Date",
        SL0039: "Check Info",
        SL0040: "Total check count",
        SL0041: "Start Date",
        SL0042: "Start Date",
        SL0043: "Please enable Pop-ups for this application",
        SL0044: "Please select a language",
        G00025: "File download failed"
      },
      currentSort: { key: "SurveyInstanceStatusId", asc: true },
      isSmallScreen: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.$router.currentRoute.query.newLogin) {
      this.$appService.removeTokensFromStorage();
      delete this.$router.currentRoute.query.newLogin;
    }
    if (this.globals.selectedLanguage) {
      this.getAllSurveyInstancesAnswers();
      this.globals.getLanguageStrings(this, this.setElementHeights);
    }

    if (!this.globals.currentUserInfo) this.globals.$once("currentUserInfoReceived", this.setElementHeights);

    // Sets the new table height after the window got resized
    var resizeFunc = function resizeFunc() {
      _this.isSmallScreen = _this.globals.isSmallScreen();
      _this.$nextTick(function () {
        _this.setElementHeights();
        _this.$forceUpdate();
      });
    };
    $(window).off("resize", resizeFunc);
    $(window).on("resize", resizeFunc).resize();

    //Old resize function
    /* $(window).on("resize", this.setElementHeights).resize();
    // Sets the new table height after the window got resized
    let resizeFunc = () => {
      this.isSmallScreen = this.globals.isSmallScreen();
      this.$forceUpdate();
    } */ //$(window).off("resize", resizeFunc);

    this.debouncedFilterFunction = _.debounce(this.doFiltering, 500);
  },
  destroyed: function destroyed() {
    $(window).off("resize", this.setElementHeights);
  },

  computed: {
    selectedSurveyInstanceStatusId: function selectedSurveyInstanceStatusId() {
      var _this2 = this;

      if (this.selectedSurveyInstanceId < 0) return -1;
      var surveyInstance = this.allSurveyInstancesAnswersData.filter(function (s) {
        return s.SurveyInstanceId === _this2.selectedSurveyInstanceId;
      });
      if (surveyInstance && surveyInstance[0]) return surveyInstance[0].SurveyInstanceStatusId;
      return -1;
    },
    hasLocationDummy: function hasLocationDummy() {
      return this.selectedSurveyInstance && this.selectedSurveyInstance.LocationName && this.selectedSurveyInstance.LocationName === "DummyLocation";
    }
  },
  methods: {
    donwloadBriefing: function donwloadBriefing(guid, filename) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this3.globals.downloadFilewithName(guid, filename);

              case 3:
                _context.next = 8;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context["catch"](0);

                _this3.globals.$emit("openGlobalErrorDialog", { errorText: _this3.lang.G00025, colorOrange: false });

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[0, 5]]);
      }))();
    },
    downloadSurveyDownload: function downloadSurveyDownload(guid, filename) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _this4.globals.downloadFilewithName(guid, filename);

              case 3:
                _context2.next = 8;
                break;

              case 5:
                _context2.prev = 5;
                _context2.t0 = _context2["catch"](0);

                _this4.globals.$emit("openGlobalErrorDialog", { errorText: _this4.lang.G00025, colorOrange: false });

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[0, 5]]);
      }))();
    },

    /**
     * Apply the selected location
     */
    /* applyLocationSelection(surveyObject) {
      if (!this.hasLocationDummy) return;
      let locationObject = _.find(this.possibleLocations, (l) => {
        return l.LocationGuid === this.selectedLocation;
      });
      surveyObject.LocationAddress = locationObject.LocationAddress;
      surveyObject.LocationCountry = locationObject.LocationCountry;
      surveyObject.LocationName = locationObject.LocationName;
      surveyObject.LocationStoreId = locationObject.LocationStoreId;
      surveyObject.LocationId = locationObject.LocationId;
    }, */
    /**
     * Create a new DCA (dynamic check actual) from DCT (dynamic check template)
     * (Or get previously created DCA)
     * @return created SurveyInstanceId
     */
    createDCASurveyInstance: function createDCASurveyInstance() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var locationObject, requestObject;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(_this5.selectedSurveyInstance.SurveyInstanceType === "DCT")) {
                  _context3.next = 8;
                  break;
                }

                locationObject = _.find(_this5.possibleLocations, function (l) {
                  return l.LocationGuid === _this5.selectedLocation;
                });
                requestObject = {};
                // only send what is needed

                requestObject.LocationId = locationObject.LocationId;
                requestObject.SurveyInstanceId = _this5.selectedSurveyInstanceId;

                return _context3.abrupt("return", new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  $.ajax({
                    method: "POST",
                    url: "api/SurveyInstances/CreateDCA",
                    data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(requestObject),
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    success: function success(data) {
                      if (data.DCASurveyInstanceId) {
                        resolve(data.DCASurveyInstanceId);
                      } else {
                        reject();
                      }
                    },
                    error: function error() {
                      console.error("Error on POST in createDCASurveyInstance()");
                      _this5.globals.$emit("openGlobalErrorDialog", { errorText: "Location selection failed", colorOrange: false });
                      reject();
                    }
                  });
                }));

              case 8:
                throw new TypeError("Wrong SurveyInstanceType");

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },

    /**
     *  Get selectable locations for the current client
     */
    getLocationsOfSelectedClient: function getLocationsOfSelectedClient() {
      var _this6 = this;

      if (!this.selectedSurveyInstance.ClientGuid) {
        this.possibleLocations = [];
        return;
      }

      $.ajax({
        method: "POST",
        url: "api/SurveyInstances/Locations/" + this.selectedSurveyInstance.ClientGuid,
        success: function success(data) {
          if (data[0]) {
            if (data[0].Locations) _this6.possibleLocations = data[0].Locations;else _this6.possibleLocations = [];
          }
        },
        error: function error() {
          console.error("Error on POST in getLocationsOfSelectedClient()");
          _this6.globals.$emit("openGlobalErrorDialog", { errorText: "Location data access failed", colorOrange: false });
        }
      });
    },


    /*
    setElementHeights() {
      this.$nextTick(() => {
        let height = $(window).height();
        height -=
          $("#checks-top-panel").height() + $("#app-navbar").height() + 47; // 47 pixel for the free space around the cards;
         $(".table-space").css("max-height", height);
        $(".main-table-scrollbar").css("max-height", height);
         //height -= $(".main-table > thead").height();
        //$(".main-table-scrollbar").css("max-height", height);
         height = $(window).height();
        height -= $(".main-table > thead").height() + 390;
        $("#create-checks-table").css("max-height", height);
        height += 85;
        $("#check-list-table").css("max-height", height);
      });
    },
     */

    setElementHeights: function setElementHeights() {
      var height = $(window).height();

      height -= $("#app-navbar").height() * 2.7 + $(".main-table > thead").height() + 47;

      $(".table-space").css("max-height", height);
      $(".main-table-scrollbar").css("max-height", height);
      var table = $(".main-table-scrollbar");
      table.css("max-height", height);

      // Set top for Filter, that it doesent scroll over table-header
      height = $(".main-table thead tr").height();
      $(".sticky-filter").css("top", height);
    },


    /*
     * Operations with the backend
     */
    // if no progress, init progress with 0
    initSurveyInstanceProgress: function initSurveyInstanceProgress(data) {
      data.forEach(function (d) {
        d.SurveyInstanceProgress = d.SurveyInstanceProgress ? d.SurveyInstanceProgress : 0;
      });
    },
    surveyEditAllowed: function surveyEditAllowed(check) {
      if (_.indexOf([100, 110, 130], check.SurveyInstanceStatusId) > -1 && !check.SurveyInstanceIsInactive) return true;
      return false;
    },

    // fetch all survey instances answers for table
    getAllSurveyInstancesAnswers: function getAllSurveyInstancesAnswers() {
      var _this7 = this;

      this.refreshEnabled = false;
      var queryString = "api/SurveyInstancesAnswers/?languageCode=" + this.globals.selectedLanguage;

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          // this.allSurveyInstancesAnswersData = data;
          // this.filteredSurveyListData = data;
          if (_.isEmpty(data)) {
            _this7.allSurveyInstancesAnswersData = [];
            _this7.surveysOnCurrentPage = [];
            return;
          }
          _this7.initSurveyInstanceProgress(data);
          _this7.allSurveyInstancesAnswersData = data;

          if (_this7.selectedSurveyInstanceId > -1) _this7.selectedSurveyInstance = _.find(_this7.allSurveyInstancesAnswersData, ["SurveyInstanceId", _this7.selectedSurveyInstanceId]);
          if (!_this7.selectedSurveyInstance) {
            _this7.selectedSurveyInstanceId = -1;
            _this7.selectedSurveyInstance = null;
          }

          _this7.orderTableCell("");
          _this7.doFiltering(true);
        },
        error: function error() {
          console.error("Error in getAllSurveyInstancesAnswers");
          _this7.globals.$emit("openGlobalErrorDialog", { errorText: "Survey list request failed", colorOrange: false });
        },
        complete: function complete() {
          _this7.refreshEnabled = true;
        }
      });
    },

    // open selected survey instance
    openSelectedSurveyInstance: function openSelectedSurveyInstance() {
      if (this.selectedSurveyInstanceId > -1) {
        this.selectedSurveyDisplayOnlyMode = !this.surveyEditAllowed(this.selectedSurveyInstance);
        this.getSurveyInstanceAnswer();
        if (this.hasLocationDummy) {
          this.getLocationsOfSelectedClient();
        }
        this.chooseSurveyLanguage();
        this.showConfirmationDialog = true;
      }
    },

    /**
     * Save SurveyInstance Answer.
     * @param {int} id
     * @return {Promise}
     */
    putSurvey: function putSurvey(id, surveyObject) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var queryString;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                queryString = "api/SurveyInstancesAnswers/" + id;
                return _context4.abrupt("return", new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  $.ajax({
                    method: "PUT",
                    url: queryString,
                    data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(surveyObject),
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    success: function success(data) {
                      if (data.Error) {
                        reject("Backendmsg:" + data.Error);
                      }
                      resolve(data);
                    }
                  });
                }));

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this8);
      }))();
    },

    /**
     * If we have a Internet Connection,then it will send a req to backend for SurveyInstanceData
     * with id
     * else it will try the internal Storage
     * @param {number} id
     * @param {String} lang
     * @returns {Promise<SurveyInstanceData>}
     */
    requestSurvey: function requestSurvey(id, lang) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var queryString;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (navigator.onLine) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt("return", _this9.getSurveyfromDB_byID(id));

              case 2:
                queryString = "api/SurveyInstancesAnswers/" + id + "?localeCode=" + lang;
                return _context5.abrupt("return", new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  $.ajax({
                    url: queryString,
                    type: "GET",
                    success: function success(data) {
                      if (data.Error) {
                        reject(data.Error);
                      }
                      resolve(data);
                    },
                    error: function error(_error) {
                      reject(_error);
                    }
                  });
                }));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this9);
      }))();
    },

    // fetch the selected surveyinstanceanswer
    getSurveyInstanceAnswer: function getSurveyInstanceAnswer() {
      var _this10 = this;

      var surveyInstancesAnswersDataIndex = _.findIndex(this.allSurveyInstancesAnswersData, function (o) {
        return o.SurveyInstanceId == _this10.selectedSurveyInstanceId;
      });
      this.surveyInstanceAnswerData = this.allSurveyInstancesAnswersData[surveyInstancesAnswersDataIndex];
      if (this.surveyInstanceAnswerData.Languages) {
        this.getSurveyInstanceAnswerDataLanguage();
      } else {
        this.surveyInstanceAnswerLanguageList = [];
        this.selectedSurveyInstanceAnswerLanguage = "";
      }
    },

    // fetch languages for one specific survey instance answer data
    getSurveyInstanceAnswerDataLanguage: function getSurveyInstanceAnswerDataLanguage() {
      var _this11 = this;

      this.surveyInstanceAnswerLanguageList = [];
      this.surveyInstanceAnswerData.Languages.forEach(function (element) {
        _this11.surveyInstanceAnswerLanguageList.push({
          LocaleCode: element.LocaleCode,
          LocaleName: element.LocaleName
        });
      });
      if (this.surveyInstanceAnswerLanguageList.length === 1) {
        this.selectedSurveyInstanceAnswerLanguage = this.surveyInstanceAnswerLanguageList[0].LocaleCode;
      } else if (this.surveyInstanceAnswerData.LocaleCode) {
        // LocaleCode fits 100%
        if (this.surveyInstanceAnswerLanguageList.includes(this.surveyInstanceAnswerData.LocaleCode)) {
          this.selectedSurveyInstanceAnswerLanguage = this.surveyInstanceAnswerData.LocaleCode;
        } else {
          // LocaleCode fits only in language part for instance 'de-DE' <-> 'de-AU'
          this.surveyInstanceAnswerLanguageList.forEach(function (lang) {
            if (lang.LocaleCode.split("-")[0] === _this11.surveyInstanceAnswerData.LocaleCode.split("-")[0]) _this11.selectedSurveyInstanceAnswerLanguage = lang.LocaleCode;
          });
        }
      }
    },
    chooseSurveyLanguage: function chooseSurveyLanguage() {
      this.languageChoosen = this.selectedSurveyInstanceAnswerLanguage ? true : false;
    },
    chooseLocation: function chooseLocation() {
      this.locationChoosen = this.selectedLocation ? true : false;
    },

    /*
     * modal methods
     */
    onConfirmationDialogClosed: function onConfirmationDialogClosed() {
      this.showConfirmationDialog = false;
      this.selectedSurveyInstanceAnswerLanguage = "";
    },
    onYesConfirmation: function onYesConfirmation() {
      var _this12 = this;

      if (this.selectedSurveyInstanceAnswerLanguage.length > 0) {
        // If DCT and LocationDummy replaced by selected location generate and show DCA
        if (this.selectedSurveyInstance.SurveyInstanceType === "DCT") {
          this.createDCASurveyInstance().then(function (NewSurveyInstanceId) {
            if (_this12.selectedSurveyInstanceAnswerLanguage.length > 0 && NewSurveyInstanceId) {
              _this12.showConfirmationDialog = false;
              window.name = "MSMLoopShopperApp";
              var url = window.origin + "/survey.html#/view/" + NewSurveyInstanceId + "?lang=" + _this12.selectedSurveyInstanceAnswerLanguage;
              if (_this12.selectedSurveyDisplayOnlyMode) url += "&ro=1";
              var newWindow = window.open(url);
              if (newWindow) {
                newWindow.onbeforeunload = function () {
                  _this12.getAllSurveyInstancesAnswers();
                };
                newWindow.openerVueInstance = _this12;
              } else {
                throw new ReferenceError("Pop-up blocked!");
              }
            }
          }).catch(function (e) {
            if (e && e.message == "Pop-up blocked!") {
              _this12.globals.$emit("openGlobalErrorDialog", { errorText: _this12.lang.SL0043, colorOrange: false });
            }
          });

          /* this.requestSurvey(
            this.selectedSurveyInstanceId,
            this.selectedSurveyInstance.LocaleCode
          ).then((surveyData) => {
            this.applyLocationSelection(surveyData);
            this.putSurvey(this.selectedSurveyInstanceId, surveyData).then(
              (data) => {
                if (
                  this.selectedSurveyInstanceAnswerLanguage.length > 0 &&
                  data.NewSurveyInstanceId
                ) {
                  this.showConfirmationDialog = false;
                  window.name = `MSMLoopShopperApp`;
                  let url = `${window.origin}/survey.html#/view/${data.NewSurveyInstanceId}?lang=${this.selectedSurveyInstanceAnswerLanguage}`;
                  if (this.selectedSurveyDisplayOnlyMode) url += `&ro=1`;
                  let newWindow = window.open(url);
                  if(newWindow) {
                    newWindow.onbeforeunload = () => {
                      this.getAllSurveyInstancesAnswers();
                    };
                    newWindow.openerVueInstance = this;
                  }
                  else {
                    throw new ReferenceError("Pop-up blocked!");
                  }
                }
              }
            ).catch( e =>
              this.globals.$emit("openGlobalErrorDialog", {errorText: this.lang.SL0043, colorOrange: false});
            );
          }); */
        } else {
          this.showConfirmationDialog = false;
          window.name = "MSMLoopShopperApp";
          var url = window.origin + "/survey.html#/view/" + this.selectedSurveyInstanceId + "?lang=" + this.selectedSurveyInstanceAnswerLanguage;
          if (this.selectedSurveyDisplayOnlyMode) url += "&ro=1";
          var newWindow = window.open(url);
          if (newWindow) {
            newWindow.onbeforeunload = function () {
              _this12.getAllSurveyInstancesAnswers();
            };
            newWindow.openerVueInstance = this;
          } else {
            this.globals.$emit("openGlobalErrorDialog", { errorText: this.lang.SL0043, colorOrange: false });
          }
        }
      } else {
        this.globals.$emit("openGlobalErrorDialog", { errorText: this.lang.SL0044, colorOrange: false });
      }
    },

    /*
     * table sorting
     */
    showSortArrow: function showSortArrow(key, asc) {
      return this.currentSort.key === key && this.currentSort.asc === asc;
    },
    orderTableCell: function orderTableCell(orderProp) {
      var _this13 = this;

      // Nothing to sort by => return
      if (orderProp === "" && this.currentSort.key === "") return;

      if (orderProp !== "") {
        this.currentSort.key === orderProp ? this.currentSort.asc = !this.currentSort.asc : this.currentSort = { asc: true, key: orderProp };
      }

      var sortFunction = function sortFunction(survey) {
        if (typeof survey[_this13.currentSort.key] === "string") {
          return survey[_this13.currentSort.key].toLowerCase();
        }
        if (_this13.currentSort.key === "SurveyInstanceStatusId") {
          if (survey[_this13.currentSort.key] === 100) return 110;
          if (survey[_this13.currentSort.key] === 110) return 100;
        }
        return survey[_this13.currentSort.key];
      };
      this.filteredSurveyListData = _.orderBy(this.filteredSurveyListData, [sortFunction], [this.currentSort.asc ? "asc" : "desc", "asc"]);
      this.loadCurrentPageOfSurveys();
    },
    doDebouncedFiltering: function doDebouncedFiltering() {
      if (this.debouncedFilterFunction) this.debouncedFilterFunction();
    },
    doFiltering: function doFiltering(keepPage) {
      var _this14 = this;

      var words = this.searchString.split(" ");
      var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.filters);

      var surveyFilter = function surveyFilter(survey) {
        var containsSearch = false;
        words.forEach(function (word) {
          keys.forEach(function (key) {
            if (survey[key] && survey[key].toString().toLowerCase().indexOf(word.toLowerCase()) > -1) {
              containsSearch = true;
              return;
            }
          });
        });
        if (!containsSearch) return false; // Survey does not match search string

        keys.forEach(function (key) {
          if (!containsSearch) return;

          if (!survey[key] && _this14.filters[key] || survey[key] && survey[key].toString().toLowerCase().indexOf(_this14.filters[key].toLowerCase()) < 0) {
            containsSearch = false; // Survey does not match filterstring
            return;
          }
        });
        return containsSearch;
      };

      this.filteredSurveyListData = !_.isEmpty(this.allSurveyInstancesAnswersData) ? this.allSurveyInstancesAnswersData.filter(surveyFilter) : [];
      this.currentSort.asc = !this.currentSort.asc;
      if (!keepPage) this.updatePaging(1, 0);
      this.orderTableCell(this.currentSort.key);
    },
    numberOfPages: function numberOfPages() {
      if (this.pageSize == -1) return 1;
      if (this.filteredSurveyListData.length % this.pageSize == 0) return this.filteredSurveyListData.length / this.pageSize;else return parseInt(this.filteredSurveyListData.length / this.pageSize) + 1;
    },

    // Updates the current pagesize and the selected pagenumber and triggers the refresh of the table
    updatePaging: function updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber;
      if (pageSize != 0) this.pageSize = pageSize;
      this.loadCurrentPageOfSurveys();
    },

    // Returns a range of numbers with min-value, max-value and stepsize
    getRange: function getRange(min, max, step) {
      var range = [],
          j = 0;
      for (var i = min; i <= max; i += step) {
        range[j++] = i;
      }
      return range;
    },

    // Returns a list of all pagenumbers that should be visible depending on the current page and the count of pages
    getVisiblePages: function getVisiblePages() {
      if (this.numberOfPages() <= 7) {
        return this.getRange(1, this.numberOfPages(), 1);
      } else if (this.numberOfPages() > 7 && this.selectedPage <= 4) {
        return this.getRange(1, 6, 1);
      } else if (this.numberOfPages() > 7 && this.selectedPage >= this.numberOfPages() - 3) {
        return this.getRange(this.numberOfPages() - 5, this.numberOfPages(), 1);
      } else {
        return this.getRange(this.selectedPage - 2, this.selectedPage + 2, 1);
      }
    },
    loadCurrentPageOfSurveys: function loadCurrentPageOfSurveys() {
      if (this.pageSize === -1) this.surveysOnCurrentPage = this.filteredSurveyListData;else {
        this.surveysOnCurrentPage = [];
        var startIndex = (this.selectedPage - 1) * this.pageSize;
        for (var i = startIndex; i < startIndex + this.pageSize; i++) {
          if (this.filteredSurveyListData[i] != null) this.surveysOnCurrentPage[i - startIndex] = this.filteredSurveyListData[i];
        }
      }
      if (_.findIndex(this.surveysOnCurrentPage, {
        SurveyInstanceId: this.selectedSurveyInstanceId
      }) < 0) {
        this.selectedSurveyInstanceId = -1;
        this.selectedSurveyInstance = null;
      }
    },
    surveyListStatusFilterSelectOpened: function surveyListStatusFilterSelectOpened() {
      // Force with of status filter select to fit the content
      this.$nextTick(function () {
        $("#select2-surveyListStatusFilterSelect-results").parent().parent().css("width", "fit-content");
      });
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this, this.setElementHeights);
      // We need to refresh the list of surveys, because there is the LocaleCode whose default
      // value (survey never saved) will depend on the current frontend language
      this.getAllSurveyInstancesAnswers();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),

/***/ 300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ConfirmationDialog",
  props: {
    dialogId: {
      type: String,
      default: "confirmationDialog"
    },
    confirmationTitle: {
      type: String,
      default: ""
    },
    yesButtonText: {
      type: String,
      default: "Yes"
    },
    yesButtonDisable: {
      type: Boolean,
      default: false
    },
    noButtonText: {
      type: String,
      default: "No"
    },
    noButtonDisable: {
      type: Boolean,
      default: false
    },
    showDialog: {
      type: Boolean,
      default: false
    },
    colorRed: {
      type: Boolean,
      default: false
    },
    htmlText: {
      type: String,
      default: ""
    }
  },
  mounted: function mounted() {
    var _this = this;

    $("#" + this.dialogId).on("hide.bs.modal", function (e) {
      return _this.$emit("closeDialog");
    });
    $("#" + this.dialogId).on("hidden.bs.modal", function (e) {
      return _this.$emit("dialogClosed");
    });
  },

  watch: {
    showDialog: function showDialog() {
      this.showDialog ? this.openConfirmationDialog() : this.closeConfirmationDialog();
    }
  },
  methods: {
    openConfirmationDialog: function openConfirmationDialog() {
      var _this2 = this;

      this.$nextTick(function () {
        $("#" + _this2.dialogId).modal("show");
      });
    },
    closeConfirmationDialog: function closeConfirmationDialog() {
      $("#" + this.dialogId).modal("hide");
    },
    onYesConfirmation: function onYesConfirmation() {
      this.$emit("onYesConfirmation");
    },
    onNoConfirmation: function onNoConfirmation() {
      this.$emit("onNoConfirmation");
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),

/***/ 301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ErrorDialog",
  props: {
    dialogId: {
      type: String,
      default: "ErrorDialog"
    },
    errorText: {
      type: String,
      default: "An Error has occurred"
    },
    showDialog: {
      type: Boolean,
      default: false
    },
    colorOrange: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    modalStyle: function modalStyle() {
      var bgColor = "red";
      var txtColor = "black";

      if (this.colorOrange) {
        bgColor = "orange";
      }

      return {
        "background-color": bgColor,
        "color": txtColor,
        "padding": "20px"
      };
    }
  },
  mounted: function mounted() {
    var _this = this;

    $("#" + this.dialogId).on("hide.bs.modal", function (e) {
      return _this.$emit("closeDialog");
    });
    $("#" + this.dialogId).on("hidden.bs.modal", function (e) {
      return _this.$emit("dialogClosed");
    });
  },

  watch: {
    showDialog: function showDialog() {
      this.showDialog ? this.openDialog() : this.closeDialog();
    }
  },
  methods: {
    openDialog: function openDialog() {
      var _this2 = this;

      this.$nextTick(function () {
        $("#" + _this2.dialogId).modal("show");
      });
    },
    closeDialog: function closeDialog() {
      $("#" + this.dialogId).modal("hide");
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),

/***/ 302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "UploadProgressModal",
  data: function data() {
    return {
      lang: {
        UPM000: "Uploading",
        UPM001: "Cancel"
      }
    };
  },

  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    },
    "globals.currentUploadProgress": function globalsCurrentUploadProgress(newValue) {
      var _this = this;

      if (newValue === 100) this.closeModal();else {
        setTimeout(function () {
          if (_this.globals.currentUploadProgress < 50) _this.openModal();
        }, 1000);
      }
    }
  },
  mounted: function mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
  },

  methods: {
    openModal: function openModal() {
      $("#uploadProgressModal").modal("show");
    },
    closeModal: function closeModal() {
      $("#uploadProgressModal").modal("hide");
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),

/***/ 303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_select2__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_select2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_select2_dist_css_select2_css__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_select2_dist_css_select2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_select2_dist_css_select2_css__);

//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Select2",
  props: {
    value: {
      default: null
    },
    width: {
      type: String,
      default: "100%"
    },
    placeholder: {
      // Example object: { id: '', text: 'Please select an entry...' }
      // id is the value of the option
      // an empty option needs to be added to the list
      // If only a string is provided, the placeholder will appear for any value that no option exists for
      type: [Object, String],
      default: null
    },
    allowClear: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    tags: {
      type: Boolean,
      default: false
    },
    minimumInputLength: {
      type: Number,
      default: 0
    },
    noResultsString: {
      type: String,
      default: ""
    }
  },
  mounted: function mounted() {
    this.initSelect2();
  },

  watch: {
    value: function value(_value) {
      if (this.tags) this.addTaggedValues();
      $(this.$el).val(_value).trigger("change.select2");
    },
    placeholder: function placeholder(value) {
      this.initSelect2();
    },
    allowClear: function allowClear() {
      this.initSelect2();
    },
    multiple: function multiple() {
      this.initSelect2();
    },
    tags: function tags() {
      this.initSelect2();
    },
    minimumInputLength: function minimumInputLength() {
      this.initSelect2();
    }
  },
  destroyed: function destroyed() {
    this.destroySelect2();
  },

  methods: {
    addTaggedValues: function addTaggedValues() {
      if (this.multiple) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.value), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _val = _step.value;

            if (!this.isValueInOptions(_val)) this.addCustomValueToOptions(_val);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } else if (!this.isValueInOptions(this.value)) this.addCustomValueToOptions(this.value);
    },
    isValueInOptions: function isValueInOptions(value) {
      var options = $(this.$el).find("option");
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(options), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var option = _step2.value;

          if (value === option.value) return true;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return false;
    },
    addCustomValueToOptions: function addCustomValueToOptions(value) {
      $(this.$el).append(new Option(value, value));
    },
    updateValue: function updateValue() {
      var _this = this;

      this.$nextTick(function () {
        $(_this.$el).val(_this.value).trigger("change.select2");
      });
    },
    reinit: function reinit() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.destroySelect2();
        _this2.initSelect2();
      });
    },
    destroySelect2: function destroySelect2() {
      $(this.$el).off().select2("destroy");
    },
    open: function open() {
      $(this.$el).select2("open");
    },
    close: function close() {
      $(this.$el).select2("close");
    },
    initSelect2: function initSelect2() {
      var _this3 = this;

      var vm = this;
      var options = {
        width: this.width,
        allowClear: this.allowClear,
        tags: this.tags,
        multiple: this.multiple,
        language: {
          noResults: function noResults() {
            return _this3.noResultsString || _this3.globals.lang.G00000;
          }
        }
      };
      if (this.placeholder) options.placeholder = this.placeholder;
      if (this.tags) options.tokenSeparators = [",", " "];
      if (this.minimumInputLength) options.minimumInputLength = this.minimumInputLength;

      // If this select was already initialized before, events are already registered
      var alreadyInitialized = $(this.$el).hasClass("select2-hidden-accessible");

      $(this.$el)
      // init select2
      .select2(options).val(this.value).trigger("change.select2");

      if (this.tags && this.value) {
        this.addTaggedValues();
        this.updateValue();
      }

      if (!alreadyInitialized) {
        // emit event on change.
        $(this.$el).on("change", function (event) {
          var result = void 0;
          if (!vm.multiple) result = this.value;else {
            var selected = $(this).select2("data");
            result = [];
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
              for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(selected), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var option = _step3.value;

                result.push(option.id);
              }
            } catch (err) {
              _didIteratorError3 = true;
              _iteratorError3 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }
              } finally {
                if (_didIteratorError3) {
                  throw _iteratorError3;
                }
              }
            }
          }
          vm.$emit("input", result, event);
          vm.$emit("change", result, event);
        }).focus(function () {
          $(this).select2("open");
        });

        $(this.$el).on("select2:open", function (e) {
          vm.$emit("open", e);
        });

        $(this.$el).on("select2:opening", function (e) {
          vm.$emit("beforeOpen", e);
        });

        $(this.$el).on("select2:close", function (e) {
          vm.$emit("close", e);
        });
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),

/***/ 304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return blobToFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reduceFileSize; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);




// Modified from https://stackoverflow.com/a/32490603, cc by-sa 3.0
// -2 = not jpeg, -1 = no data, 1..8 = orientations
var getExifOrientation = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(file) {
    var reader;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // Suggestion from http://code.flickr.net/2012/06/01/parsing-exif-client-side-using-javascript-2/:
            if (file.slice) {
              file = file.slice(0, 131072);
            } else if (file.webkitSlice) {
              file = file.webkitSlice(0, 131072);
            }

            reader = new FileReader();

            reader.onload = function (e) {
              var view = new DataView(e.target.result);
              if (view.getUint16(0, false) != 0xffd8) {
                return -2;
              }
              var length = view.byteLength,
                  offset = 2;
              while (offset < length) {
                var marker = view.getUint16(offset, false);
                offset += 2;
                if (marker == 0xffe1) {
                  if (view.getUint32(offset += 2, false) != 0x45786966) {
                    return -1;
                  }
                  var little = view.getUint16(offset += 6, false) == 0x4949;
                  offset += view.getUint32(offset + 4, little);
                  var tags = view.getUint16(offset, little);
                  offset += 2;
                  for (var i = 0; i < tags; i++) {
                    if (view.getUint16(offset + i * 12, little) == 0x0112) {
                      return view.getUint16(offset + i * 12 + 8, little);
                    }
                  }
                } else if ((marker & 0xff00) != 0xff00) break;else offset += view.getUint16(offset, false);
              }
              return -1;
            };
            reader.readAsArrayBuffer(file);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getExifOrientation(_x) {
    return _ref.apply(this, arguments);
  };
}();

// from https://stackoverflow.com/questions/14672746/how-to-compress-an-image-via-javascript-in-the-browser
// not mine



// From https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob, needed for Safari:
if (!HTMLCanvasElement.prototype.toBlob) {
  Object.defineProperty(HTMLCanvasElement.prototype, "toBlob", {
    value: function value(callback, type, quality) {
      var binStr = atob(this.toDataURL(type, quality).split(",")[1]),
          len = binStr.length,
          arr = new Uint8Array(len);

      for (var i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
      }

      callback(new Blob([arr], { type: type || "image/png" }));
    }
  });
}

window.URL = window.URL || window.webkitURL;

var blobToFile = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(theBlob, oldfile) {
    var file;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            //A Blob() is almost a File() - it's just missing the two properties below which we will add
            file = new File([theBlob], oldfile.name, {
              type: oldfile.type
            });
            return _context2.abrupt("return", file);

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function blobToFile(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

// Derived from https://stackoverflow.com/a/40867559, cc by-sa
function imgToCanvasWithOrientation(img, rawWidth, rawHeight, orientation) {
  var canvas = document.createElement("canvas");
  if (orientation > 4) {
    canvas.width = rawHeight;
    canvas.height = rawWidth;
  } else {
    canvas.width = rawWidth;
    canvas.height = rawHeight;
  }

  if (orientation > 1) {
    console.debug("EXIF orientation = " + orientation + ", rotating picture");
  }

  var ctx = canvas.getContext("2d");
  switch (orientation) {
    case 2:
      ctx.transform(-1, 0, 0, 1, rawWidth, 0);
      break;
    case 3:
      ctx.transform(-1, 0, 0, -1, rawWidth, rawHeight);
      break;
    case 4:
      ctx.transform(1, 0, 0, -1, 0, rawHeight);
      break;
    case 5:
      ctx.transform(0, 1, 1, 0, 0, 0);
      break;
    case 6:
      ctx.transform(0, 1, -1, 0, rawHeight, 0);
      break;
    case 7:
      ctx.transform(0, -1, -1, 0, rawHeight, rawWidth);
      break;
    case 8:
      ctx.transform(0, -1, 1, 0, 0, rawWidth);
      break;
  }
  ctx.drawImage(img, 0, 0, rawWidth, rawHeight);
  return canvas;
}
/**
 *  Will resize the image and return the te compressed one  if the original if it is smaller than
 * @param {File} file The File
 * @param {number} acceptFileSize checks before resizeing if we are already at target
 * @param {number} maxWidth
 * @param {number} maxHeight
 * @param {Float} quality 0 to 1
 * @param {boolean} rotateExif if true will rotate the image to its exif rotation
 * @returns
 */
var reduceFileSize = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(file, acceptFileSize, maxWidth, maxHeight, quality) {
    var rotateExif = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
    var img, o, orientation, w, h, scale, canvas, blob;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return addImageProcess(file);

          case 2:
            img = _context3.sent;
            _context3.next = 5;
            return getExifOrientation(file);

          case 5:
            o = _context3.sent;

            // [#1416] dont rotate images for now until we fix getExifOrientation
            orientation = rotateExif ? 1 : o;
            w = img.width, h = img.height;


            if (file.size > acceptFileSize) {
              scale = orientation > 4 ? Math.min(maxHeight / w, maxWidth / h, 1) : Math.min(maxWidth / w, maxHeight / h, 1);

              h = Math.round(h * scale);
              w = Math.round(w * scale);
            }

            canvas = imgToCanvasWithOrientation(img, w, h, orientation);
            _context3.next = 12;
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
              canvas.toBlob(resolve, "image/jpeg", quality);
            });

          case 12:
            blob = _context3.sent;


            console.debug("Resized image to " + w + "x" + h + ", " + (blob.size >> 10) + "kB" + " from " + (file.size >> 10) + "kB");

            return _context3.abrupt("return", blob);

          case 15:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function reduceFileSize(_x4, _x5, _x6, _x7, _x8) {
    return _ref3.apply(this, arguments);
  };
}();

function addImageProcess(file) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var img = new Image();
    img.onload = function () {
      return resolve(img);
    };
    img.onerror = reject;
    img.src = URL.createObjectURL(file);
  });
}

/***/ }),

/***/ 305:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requestBase__ = __webpack_require__(37);



var API_BASE = "api/Language/Translations";

/**
 * Get the Translation for the given strings
 * @param {object} langobj - the lang Object where the Keys are the ids of the localizable string
 * @returns
 */
function getTranslationfor(langobj) {
  var langKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(langobj);
  return __WEBPACK_IMPORTED_MODULE_1__requestBase__["a" /* default */].post(API_BASE, langKeys);
}

var UseLang = {
  getTranslationfor: getTranslationfor
};

/* harmony default export */ __webpack_exports__["a"] = (UseLang);

/***/ }),

/***/ 306:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_b64_to_blob__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_b64_to_blob___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_b64_to_blob__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__StoreNames__ = __webpack_require__(94);










var LocalIndexDB = function () {
  function LocalIndexDB() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, LocalIndexDB);

    this.db = null;
    this.opened = false;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(LocalIndexDB, [{
    key: 'openDatabase',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  var request = indexedDB.open(__WEBPACK_IMPORTED_MODULE_8__StoreNames__["b" /* DB_NAME */]);

                  var that = _this;

                  request.onerror = function (e) {
                    reject();
                  };

                  request.onsuccess = function (e) {
                    that.db = e.target.result;
                    that.opened = true;
                    resolve();
                  };

                  request.onupgradeneeded = function (e) {
                    var db = e.target.result;
                    if (!db.objectStoreNames.contains(__WEBPACK_IMPORTED_MODULE_8__StoreNames__["a" /* FILES_STORE_NAME */])) {
                      db.createObjectStore(__WEBPACK_IMPORTED_MODULE_8__StoreNames__["a" /* FILES_STORE_NAME */], {
                        autoIncrement: false,
                        keyPath: "id"
                      });
                    }
                    if (!db.objectStoreNames.contains(__WEBPACK_IMPORTED_MODULE_8__StoreNames__["c" /* SURVEY_STORE_NAME */])) {
                      db.createObjectStore(__WEBPACK_IMPORTED_MODULE_8__StoreNames__["c" /* SURVEY_STORE_NAME */], {
                        autoIncrement: false,
                        keyPath: "id"
                      });
                    }
                    if (!db.objectStoreNames.contains(__WEBPACK_IMPORTED_MODULE_8__StoreNames__["d" /* TICKETS_STORE_NAME */])) {
                      db.createObjectStore(__WEBPACK_IMPORTED_MODULE_8__StoreNames__["d" /* TICKETS_STORE_NAME */], {
                        autoIncrement: false,
                        keyPath: "id"
                      });
                    }
                    if (!db.objectStoreNames.contains("app")) {
                      db.createObjectStore("app", {
                        autoIncrement: false,
                        keyPath: "id"
                      });
                    }
                  };
                }));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function openDatabase() {
        return _ref.apply(this, arguments);
      }

      return openDatabase;
    }()
  }, {
    key: 'clearDatabase',
    value: function clearDatabase() {
      var except = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var filesTransaction = this.db.transaction(__WEBPACK_IMPORTED_MODULE_8__StoreNames__["a" /* FILES_STORE_NAME */], "readwrite");
      var filesStore = filesTransaction.objectStore(__WEBPACK_IMPORTED_MODULE_8__StoreNames__["a" /* FILES_STORE_NAME */]);
      var getAllFilesKeysRequest = filesStore.getAllKeys();
      getAllFilesKeysRequest.onsuccess = function () {
        var keys = getAllFilesKeysRequest.result;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          var _loop = function _loop() {
            var key = _step.value;

            if (except.some(function (v) {
              return v.split("_")[1] === key;
            }) === false) {
              var deleteRequest = filesStore.delete(key);
              deleteRequest.onerror = function () {
                console.error("Object delete error");
              };
            }
          };

          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(keys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            _loop();
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      };
      getAllFilesKeysRequest.onerror = function () {
        console.error("Keys get error");
      };
      filesTransaction.oncomplete = function () {};

      var surveyTransaction = this.db.transaction(__WEBPACK_IMPORTED_MODULE_8__StoreNames__["c" /* SURVEY_STORE_NAME */], "readwrite");
      var surveyStore = surveyTransaction.objectStore(__WEBPACK_IMPORTED_MODULE_8__StoreNames__["c" /* SURVEY_STORE_NAME */]);
      var getAllSurveyKeysRequest = surveyStore.getAllKeys();
      getAllSurveyKeysRequest.onsuccess = function () {
        var keys = getAllSurveyKeysRequest.result;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          var _loop2 = function _loop2() {
            var key = _step2.value;

            if (except.some(function (v) {
              return v.split("_")[1] === key;
            }) === false) {
              var deleteRequest = surveyStore.delete(key);
              deleteRequest.onerror = function () {
                console.error("Object delete error");
              };
            }
          };

          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(keys), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            _loop2();
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      };
      getAllSurveyKeysRequest.onerror = function () {
        console.error("Keys get error");
      };
      surveyTransaction.oncomplete = function () {};

      var ticketTransaction = this.db.transaction(__WEBPACK_IMPORTED_MODULE_8__StoreNames__["d" /* TICKETS_STORE_NAME */], "readwrite");
      var ticketStore = ticketTransaction.objectStore(__WEBPACK_IMPORTED_MODULE_8__StoreNames__["d" /* TICKETS_STORE_NAME */]);
      var getAllTicketKeysRequest = ticketStore.getAllKeys();
      getAllTicketKeysRequest.onsuccess = function () {
        var keys = getAllTicketKeysRequest.result;
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          var _loop3 = function _loop3() {
            var key = _step3.value;

            if (except.some(function (v) {
              return v.split("_")[1] === key;
            }) === false) {
              var deleteRequest = ticketStore.delete(key);
              deleteRequest.onerror = function () {
                console.error("Object delete error");
              };
            }
          };

          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(keys), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            _loop3();
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      };
      getAllTicketKeysRequest.onerror = function () {
        console.error("Keys get error");
      };
      ticketTransaction.oncomplete = function () {};
    }
  }, {
    key: 'remove',
    value: function remove(store, id) {
      var transaction = this.db.transaction(store, "readwrite");
      var dbStore = transaction.objectStore(store);
      var request = dbStore.delete(id);
      request.onsuccess = function () {};
      request.onerror = function () {
        throw new Error("Object save error");
      };
      transaction.oncomplete = function () {};
    }
  }, {
    key: 'saveObject',
    value: function saveObject(store, id, object) {
      var transaction = this.db.transaction(store, "readwrite");
      var dbStore = transaction.objectStore(store);
      var request = dbStore.put({ id: id, data: object });
      request.onsuccess = function () {};
      request.onerror = function () {
        throw new Error("Object save error");
      };
      transaction.oncomplete = function () {};
    }
  }, {
    key: 'getObject',
    value: function getObject(store, id) {
      var that = this;
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var transaction = that.db.transaction(store, "readonly");
        var dbStore = transaction.objectStore(store);
        var request = dbStore.get(id);
        request.onsuccess = function () {
          if (!request.result) {
            reject(id + " is not found");
            return;
          }
          if (!request.result.data) {
            reject(id + " is not found");
            return;
          }
          resolve(request.result.data);
        };
        request.onerror = function () {
          reject(id + " is not found");
        };
        transaction.oncomplete = function () {};
      });
    }
  }, {
    key: 'getStoreObjects',
    value: function getStoreObjects(store) {
      var that = this;
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var transaction = that.db.transaction(store, "readonly");
        var dbStore = transaction.objectStore(store);
        var request = dbStore.getAll();
        request.onsuccess = function () {
          if (!Array.isArray(request.result)) {
            resolve([]);
            return;
          }
          if (request.result.length === 0) {
            resolve([]);
            return;
          }
          resolve(request.result.map(function (v) {
            return v.data;
          }));
        };
        request.onerror = function () {
          reject("unable to get store " + store);
        };
        transaction.oncomplete = function () {};
      });
    }
  }, {
    key: 'saveFile',
    value: function saveFile(store, id, file) {
      var that = this;
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        try {
          var reader = new FileReader();
          reader.onload = function (e) {
            var transaction = that.db.transaction(store, "readwrite");
            var dbStore = transaction.objectStore(store);
            var request = dbStore.put({
              id: id,
              data: file.name + ";" + e.target.result
            });
            request.onsuccess = function () {
              resolve(id);
            };
            request.onerror = function () {
              reject("File save error");
            };
          };
          reader.readAsDataURL(file);
        } catch (err) {
          reject(err);
        }
      });
    }
  }, {
    key: 'getFile',
    value: function getFile(store, id) {
      var that = this;
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var transaction = that.db.transaction(store, "readwrite");
        var dbStore = transaction.objectStore(store);
        var request = dbStore.get(id);
        request.onsuccess = function () {
          if (!request.result) {
            reject(id + " is not found");
            return;
          }
          if (!request.result.data) {
            reject(id + " is not found");
            return;
          }
          var data = request.result.data;
          var base64Parts = data.split(';');
          var contentType = base64Parts[1].split(':')[1];
          var b64Data = base64Parts[2].split(',')[1];;
          var blob = __WEBPACK_IMPORTED_MODULE_6_b64_to_blob___default()(b64Data, contentType);
          blob.name = base64Parts[0]; // file name
          resolve(blob);
        };
        request.onerror = function () {
          reject(id + " is not found");
        };
      });
    }
  }]);

  return LocalIndexDB;
}();

var localIndexDB = new LocalIndexDB();

/* harmony default export */ __webpack_exports__["a"] = (localIndexDB);

/***/ }),

/***/ 307:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_b64_to_blob__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_b64_to_blob___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_b64_to_blob__);







var LocalStorageDB = function () {
  function LocalStorageDB() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, LocalStorageDB);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(LocalStorageDB, [{
    key: "getKeys",
    value: function getKeys() {
      var data = localStorage.getItem("db_keys");
      if (!data) {
        return [];
      } else {
        return JSON.parse(data);
      }
    }
  }, {
    key: "addKey",
    value: function addKey(key) {
      var keys = this.getKeys();
      keys.push(key);
      localStorage.setItem("db_keys", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(keys));
    }
  }, {
    key: "clearDatabase",
    value: function clearDatabase() {
      var except = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var keys = this.getKeys().filter(function (v) {
        return except.indexOf(v) === -1;
      });
      keys.forEach(function (key) {
        localStorage.removeItem(key);
      });
      localStorage.setItem("db_keys", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(except));
    }
  }, {
    key: "hasKey",
    value: function hasKey(store, id) {
      var key = (store + "_" + id).toUpperCase();
      if (localStorage.getItem(key)) {
        return true;
      }
      return false;
    }
  }, {
    key: "remove",
    value: function remove(store, id) {
      var key = (store + "_" + id).toUpperCase();
      var keys = this.getKeys();
      var newKeys = [];
      keys.forEach(function (item) {
        if (item === key) {
          localStorage.removeItem(item);
        } else {
          newKeys.push(item);
        }
      });
      localStorage.setItem("db_keys", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(newKeys));
    }
  }, {
    key: "saveObject",
    value: function saveObject(store, id, object) {
      var key = (store + "_" + id).toUpperCase();
      if (!this.hasKey(store, id)) {
        this.addKey(key);
      }
      localStorage.setItem(key, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(object));
    }
  }, {
    key: "getObject",
    value: function getObject(store, id) {
      var key = (store + "_" + id).toUpperCase();
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var data = localStorage.getItem(key);
        if (!data) {
          reject(id + " is not found");
        } else {
          resolve(JSON.parse(data));
        }
      });
    }
  }, {
    key: "getStoreObjects",
    value: function getStoreObjects(store) {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        try {
          var data = [];
          var keys = _this.getKeys();
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(keys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var key = _step.value;

              if (key.split('_')[0] === store.toUpperCase()) {
                var item = localStorage.getItem(key);
                if (item) {
                  data.push(item);
                }
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          resolve(data);
        } catch (err) {
          reject("unable to get store " + store);
        }
      });
    }
  }, {
    key: "saveFile",
    value: function saveFile(store, id, file) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        try {
          var key = (store + "_" + id).toUpperCase();
          var reader = new FileReader();
          if (!_this2.hasKey(store, id)) {
            _this2.addKey(key);
          }
          reader.onload = function (e) {
            try {
              localStorage.setItem(key, file.name + ";" + e.target.result);
              resolve(id);
            } catch (err) {
              reject("Local storage limit exceeded");
            }
          };
          reader.readAsDataURL(file);
        } catch (err) {
          reject(err);
        }
      });
    }
  }, {
    key: "getFile",
    value: function getFile(store, id) {
      var key = (store + "_" + id).toUpperCase();
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var data = localStorage.getItem(key);
        if (!data) {
          reject(id + " is not found");
        } else {
          var base64Parts = data.split(';');
          var contentType = base64Parts[1].split(':')[1];
          var b64Data = base64Parts[2].split(',')[1];;
          var blob = __WEBPACK_IMPORTED_MODULE_5_b64_to_blob___default()(b64Data, contentType);
          blob.name = base64Parts[0]; // file name
          resolve(blob);
        }
      });
    }
  }]);

  return LocalStorageDB;
}();

var localStorageDB = new LocalStorageDB();

/* harmony default export */ __webpack_exports__["a"] = (localStorageDB);

/***/ }),

/***/ 308:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Tools_typdefs__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Tools_typdefs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Tools_typdefs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_SurveyInstances_SurveyAnswerHistory__ = __webpack_require__(128);







var HIST_MUTAIONS = {
  updateShow: "updateShow",
  replaceHistory: "replaceHistory",
  toggleHistoryfor: "toggleHistoryfor",
  showHistoryComponentFor: "showHistoryComponentFor",
  hideHistoryComponentFor: "hideHistoryComponentFor"
};

var state = {
  showHistForCheck: {},
  /** @type {ShowHistory[]} */
  showHistfor: [],
  /** @type {QuestionHistory[]} */
  answershist: []
};

/** @type {import("vuex").GetterTree<typeof state,any>} */
var getters = {
  showbyName: function showbyName(state) {
    return function (name) {
      var hist = state.showHistfor.find(function (el) {
        return el.name === name;
      });
      if (hist) {
        return hist.show;
      } else {
        return false;
      }
    };
  },
  historybyName: function historybyName(state) {
    return function (name) {
      var question = state.answershist.find(function (el) {
        return el.name === name;
      });
      if (question) {
        var answers = question.answers.map(function (a) {
          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, a, { type: question.type });
        });
        return answers;
      } else {
        return [];
      }
    };
  },
  getHistory: function getHistory(state) {
    return function () {
      return state.answershist ? state.answershist : [];
    };
  }
};

/** @type {import("vuex").ActionTree<typeof state>} */
var actions = {
  fetchHistory: function fetchHistory(_ref, payload) {
    var _this = this;

    var commit = _ref.commit,
        state = _ref.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var res, histData, isHistenabled, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, question, hist;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_5__services_SurveyInstances_SurveyAnswerHistory__["a" /* default */].getAnswersHistory(payload.id, {
                QuestionGuid: payload.names
              });

            case 2:
              res = _context.sent;

              /**
               * @type {QuestionHistory[]}
               */
              histData = [];
              isHistenabled = res.data.HistoryCount && res.data.HistoryCount > 0;

              if (!isHistenabled) {
                _context.next = 30;
                break;
              }

              histData = res.data.HistoryAnswers;
              histData = Array.isArray(histData) ? histData : [];

              // we hope for no bugs but sometimes bugs
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 11;
              for (_iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(histData); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                question = _step.value;

                if (["checkbox", "radiogroup"].includes(question.type) && payload.choicesText[question.name]) {
                  (function () {
                    var questiontext = payload.choicesText[question.name];
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                      for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(question.answers), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var ans = _step2.value;

                        ans.values = ans.values.map(function (val) {
                          var valueKey = questiontext.find(function (el) {
                            return el.value == val;
                          });
                          if (valueKey) return valueKey.text;else return val;
                        });
                      }
                    } catch (err) {
                      _didIteratorError2 = true;
                      _iteratorError2 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                          _iterator2.return();
                        }
                      } finally {
                        if (_didIteratorError2) {
                          throw _iteratorError2;
                        }
                      }
                    }
                  })();
                }
              }

              _context.next = 19;
              break;

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](11);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 19:
              _context.prev = 19;
              _context.prev = 20;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 22:
              _context.prev = 22;

              if (!_didIteratorError) {
                _context.next = 25;
                break;
              }

              throw _iteratorError;

            case 25:
              return _context.finish(22);

            case 26:
              return _context.finish(19);

            case 27:
              commit(HIST_MUTAIONS.showHistoryComponentFor, payload.id);
              _context.next = 31;
              break;

            case 30:
              commit(HIST_MUTAIONS.hideHistoryComponentFor, payload.id);

            case 31:
              hist = histData;


              commit(HIST_MUTAIONS.replaceHistory, hist);
              hist.forEach(function (el) {
                commit(HIST_MUTAIONS.updateShow, el);
              });
              return _context.abrupt("return", isHistenabled);

            case 35:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[11, 15, 19, 27], [20,, 22, 26]]);
    }))();
  }
};

/** @type {import("vuex").MutationTree<typeof state>} */
var mutations = {
  showHistoryComponentFor: function showHistoryComponentFor(state, id) {
    state.showHistForCheck[id] = true;
  },
  hideHistoryComponentFor: function hideHistoryComponentFor(state, id) {
    state.showHistForCheck[id] = false;
  },
  toggleHistoryfor: function toggleHistoryfor(state, _ref2) {
    var name = _ref2.name,
        show = _ref2.show;

    var hist = state.showHistfor.find(function (el) {
      return el.name === name;
    });

    if (hist) {
      hist.show = show;
    } else {
      state.showHistfor.push({ name: name, show: show });
    }
  },
  replaceHistory: function replaceHistory(state, payload) {
    state.answershist = payload;
  },
  updateShow: function updateShow(state, el) {
    state.showHistfor.push({ name: el.name, show: false });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 309:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Tools_typdefs__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Tools_typdefs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Tools_typdefs__);


var state = {
  /** @type {StoredFlags} */
  SurveyFlags: {
    redirectCache: false
  }
};

/** @type {import("vuex").GetterTree<typeof state,any>} */
var getters = {};

/** @type {import("vuex").ActionTree<typeof state>} */
var actions = {
  toogleCache: function toogleCache(_ref, id) {
    var commit = _ref.commit,
        state = _ref.state;

    var key = id.toString();
    if (state.SurveyFlags[key] && state.SurveyFlags[key].offlineCache) {
      commit("destroyCache", id);
      commit("dectivateRedirectCache");
    } else {
      commit("buildCache", id);
    }
  },
  flushCacheFor: function flushCacheFor(_ref2, _ref3) {
    var commit = _ref2.commit;
    var flushoffline = _ref3.flushoffline,
        id = _ref3.id;

    var key = id.toString();
    if (flushoffline) {
      commit("flushoffline", key);
    }
    commit("flushUnsavechanges", key);
  }
};

/** @type {import("vuex").MutationTree<typeof state>} */
var mutations = {
  flushoffline: function flushoffline(state, key) {
    state.SurveyFlags[key].offlineCache = false;
  },
  flushUnsavechanges: function flushUnsavechanges(state, key) {
    state.SurveyFlags[key].unsavedChanges = false;
  },
  dectivateRedirectCache: function dectivateRedirectCache(state) {
    state.SurveyFlags.redirectCache = false;
  },
  flushCachefor: function flushCachefor(state, key) {
    state.SurveyFlags[key].offlineCache = false;
    state.SurveyFlags[key].unsavedChanges = false;
  },
  initializeFlags: function initializeFlags(state, id) {
    var key = id.toString();
    if (!state.SurveyFlags[key]) {
      state.SurveyFlags[key] = {};
      state.SurveyFlags[key].unsavedChanges = false;
      state.SurveyFlags[key].offlineCache = false;
    }
  },
  buildCache: function buildCache(state, id) {
    var key = id.toString();
    state.SurveyFlags[key].offlineCache = true;
  },
  unsavedChanges: function unsavedChanges(state, id) {
    var key = id.toString();
    state.SurveyFlags[key].unsavedChanges = true;
  },
  flushCache: function flushCache(state, _ref4) {
    var offline = _ref4.offline,
        id = _ref4.id;

    var key = id.toString();
    if (!offline) {
      state.SurveyFlags[key].offlineCache = false;
    }
    state.SurveyFlags[key].unsavedChanges = false;
  },
  destroyCache: function destroyCache(state, id) {
    var key = id.toString();
    state.SurveyFlags[key].offlineCache = false;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 31:
/***/ (function(module, exports) {

/**
 * @typedef QuestionHistory
 * @property {string} name
 * @property {string} type
 * @property {HistforDate[]} answers
 */

/**
 * @typedef HistforDate
 * @property {number} id
 * @property {string} date
 * @property {string[]}values
 */

/**
 * An Answer Object
 * @typedef AnswerObject
 * @property {number} SurveyInstanceId The Id and PK of the Object
 * @property {Object} SurveyInstanceAnswer List of questions with answers
 */

/**
 * @typedef ShowHistory
 * @type {object}
 * @property {boolean} show
 * @property {String} name
 */
/**
 * @typedef questions
 * @property { Array | String} questionName
 */

/**
 * An Answer Object
 * @typedef LanguageObj
 * @property {number} SurveyInstanceId The Id and PK of the Object
 * @property {Object} SurveyInstanceAnswer List of questions with answers
 */

/**
 * @typedef StoredAnswers
 * @property {number} id
 * @property {questions}
 */

/**
 * @typedef questions
 * @property { Array | String} questionName
 */

/**
 * @typedef SurveyObj
 * @property {String} title
 * @property {Array} pages
 * @property {String} showQuestionNumbers
 */

/**
 * @typedef {object} SurveyInstanceData
 * @property {String} ClientGuid
 * @property {number} ClientId
 * @property {Array<LanguageObj>} Languages
 * @property {String} LocaleCode
 * @property {String} LocationAddress
 * @property {String} LocationCountry
 * @property {String} LocationName
 * @property {String} LocationStoreId
 * @property {String} ScenarioName
 * @property {SurveyObj} Survey
 * @property {number} SurveyId
 * @property {Object} SurveyInstanceAnswer
 * @property {String} SurveyInstanceAnswerMemoAgency
 * @property {String} SurveyInstanceAnswerMemoMSM
 * @property {String} SurveyInstanceAnswerMemoShopper
 * @property {number} SurveyInstanceAnswerPoints
 * @property {Object} SurveyInstanceAnswerPosition
 * @property {boolean} SurveyInstanceAnswerReadOnly
 * @property {String} SurveyInstanceGuid
 * @property {number} SurveyInstanceId
 * @property {number} SurveyInstanceProgress
 * @property {number} SurveyInstanceStatusId
 * @property {String} SurveyInstanceType
 * @property {String} WaveName
 */

/**
 * @typedef  newTicketData
 * @property {String} Comment
 * @property {number} SurveyInstanceId
 * @property {Array<String>} FileGuidList
 * @property {String} Answer
 * @property {String} FileGuids
 * @property {String} QuestionGuid
 * @property {String} ExpirationDate
 * @property {String} Name
 */

/**
 * @typedef StoredFlags
 * @type {object}
 * @property {SurveyFlags}
 * @property {boolean} redirectCache
 */

/**
 * @typedef SurveyFlags
 * @property {boolean} offlineCache
 */

/**
 * @typedef SurveyInstanceAnswerFile
 * @type {object}
 * @property {String} content
 * @property {String} name
 * @property {String} questionId
 * @property {String} type
 */

/***/ }),

/***/ 310:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Tools_typdefs__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Tools_typdefs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Tools_typdefs__);




var state = {
  /** @type {StoredAnswers} */
  surveyInstances: {}
};

/** @type {import("vuex").GetterTree<typeof state,any>} */
var getters = {
  getSurveyAnswerbyId: function getSurveyAnswerbyId(state) {
    return function (id) {
      var key = id.toString();
      return state.surveyInstances[key];
    };
  }
};

/** @type {import("vuex").ActionTree<typeof state>} */
var actions = {
  syncSurvey: function syncSurvey(_ref, payload) {
    var commit = _ref.commit,
        state = _ref.state;

    commit("addSurveyInstance", payload);
  },
  syncAnswers: function syncAnswers(_ref2, _ref3) {
    var commit = _ref2.commit,
        state = _ref2.state;
    var id = _ref3.id,
        data = _ref3.data;

    var key = id.toString();
    var questionsNames = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data);
    if (key in state.surveyInstances) {
      questionsNames.forEach(function (qname) {
        var payload = { key: key, qname: qname, value: data[qname] };
        commit("changeQuestion", payload);
      });
    } else {
      var payload = { id: key, data: data };
      commit("addSurveyInstance", payload);
    }
  },
  clearAllAnswers: function clearAllAnswers(_ref4) {
    var state = _ref4.state;

    state.surveyInstances = {};
  }
};

/** @type {import("vuex").MutationTree<typeof state>} */
var mutations = {
  addSurveyInstance: function addSurveyInstance(state, _ref5) {
    var id = _ref5.id,
        data = _ref5.data;

    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.surveyInstances, id, data);
  },
  changeQuestion: function changeQuestion(state, _ref6) {
    var key = _ref6.key,
        qname = _ref6.qname,
        value = _ref6.value;

    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.surveyInstances[key], qname, value);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 311:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Tools_typdefs__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Tools_typdefs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Tools_typdefs__);




var state = {
  /** @type {newTicketData[]} */
  ticketList: []
};

/** @type {import("vuex").GetterTree<typeof state,any>} */
var getters = {
  ticketList: function ticketList(state) {
    return state.ticketList;
  },
  filteredTicketListListById: function filteredTicketListListById(state) {
    return function (id) {
      return state.ticketList ? state.ticketList.filter(function (ticket) {
        return ticket.SurveyInstanceId === id;
      }) : [];
    };
  },
  activeTickets: function activeTickets(state) {
    return state.ticketList.filter(function (ticket) {
      return ticket.isActive;
    });
  },

  ticketByName: function ticketByName(state) {
    return function (name) {
      var result = state.ticketList.find(function (ticket) {
        return ticket.Name === name;
      });
      if (result) {
        return result;
      } else {
        return false;
      }
    };
  },
  /**
   *
   * @param {*} state the state obj
   * @param {String} name the question name
   * @returns {boolean}
   */
  ticketDoesExist: function ticketDoesExist(state) {
    return function (name) {
      return state.ticketList.some(function (ticket) {
        return ticket.Name === name;
      });
    };
  }
};

/** @type {import("vuex").ActionTree<typeof state>} */
var actions = {};

/** @type {import("vuex").MutationTree<typeof state>} */
var mutations = {
  clearAll: function clearAll(state) {
    state.ticketList = [];
  },
  addTicket: function addTicket(state, ticket) {
    state.ticketList.push(ticket);
  },
  updateTicket: function updateTicket(state, ticket) {
    var updatingTicket = state.ticketList.find(function (t) {
      return t.Name === ticket.Name;
    });
    updatingTicket = ticket;
  },
  replaceTicketList: function replaceTicketList(state, newTicketList) {
    state.ticketList = newTicketList;
  },
  removeInactiveTickets: function removeInactiveTickets(state) {
    state.ticketList = state.ticketList.filter(function (ticket) {
      return ticket.isActive;
    });
  },
  updateTicketFiles: function updateTicketFiles(state, _ref) {
    var Name = _ref.Name,
        newlist = _ref.newlist;

    var updatingTicket = state.ticketList.find(function (t) {
      return t.Name === Name;
    });
    updatingTicket.FileGuidList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(newlist));
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 37:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_service__ = __webpack_require__(109);




var _this = this;

var renewToken = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    var refreshToken, codeVerifier, formData, url;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            refreshToken = localStorage.getItem("refresh_token");
            codeVerifier = localStorage.getItem("code_verifier");
            formData = new FormData();

            formData.append("client_id", "loopShopperFrontend");
            formData.append("code_verifier", codeVerifier);
            formData.append("refresh_token", refreshToken);
            formData.append("grant_type", "refresh_token");
            url = __WEBPACK_IMPORTED_MODULE_4__app_service__["a" /* default */].getServerUrl() + "connect/token";
            return _context.abrupt("return", new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              if (!refreshToken) {
                throw Error("no refreshToken or codeVerifier");
              }

              axiosInstanceAuth.post(url, formData).then(function (res) {
                var data = res.data;
                if (data && data.access_token && data.refresh_token && data.id_token) {
                  __WEBPACK_IMPORTED_MODULE_4__app_service__["a" /* default */].storeTokensInStorage(data.access_token, data.id_token, data.refresh_token);
                  resolve(localStorage.getItem("access_token") || "yooo");
                } else {
                  throw Error("Bad token response");
                }
              }).catch(function (err) {
                console.error("Error on POST in renewToken()");
                reject(err);
              });
            }));

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function renewToken() {
    return _ref.apply(this, arguments);
  };
}();




var current_token = __WEBPACK_IMPORTED_MODULE_4__app_service__["a" /* default */].getAccessToken();

function validToken(access_token) {
  if (!access_token || access_token === "") return false;
  function JWTExpired(payload) {
    var expireDate = payload.exp * 1000;
    var now = Date.now();
    return now > expireDate;
  }
  var tokendata = JSON.parse(window.atob(access_token.split(".")[1]));
  return tokendata && !JWTExpired(tokendata);
}

var axiosInstance = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
  headers: {
    "Content-type": "application/json",
    Accept: "application/json, text/plain, */*"
  }
});
var axiosInstanceAuth = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
  headers: {
    "Content-type": "application/json",
    Accept: "application/json, text/plain, */*"
  }
});

axiosInstance.interceptors.request.use(function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(config) {
    var access_token;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            current_token = __WEBPACK_IMPORTED_MODULE_4__app_service__["a" /* default */].getAccessToken();
            access_token = void 0;

            if (!validToken(current_token)) {
              _context2.next = 6;
              break;
            }

            access_token = current_token;
            _context2.next = 18;
            break;

          case 6:
            _context2.prev = 6;
            _context2.next = 9;
            return renewToken();

          case 9:
            access_token = _context2.sent;
            _context2.next = 17;
            break;

          case 12:
            _context2.prev = 12;
            _context2.t0 = _context2["catch"](6);

            console.error("Token Renwal failed:", _context2.t0);
            __WEBPACK_IMPORTED_MODULE_4__app_service__["a" /* default */].removeTokensFromStorage();
            __WEBPACK_IMPORTED_MODULE_4__app_service__["a" /* default */].directToLogin();

          case 17:
            console.warn("Token has beed renewed");

          case 18:
            config.headers = {
              Authorization: "Bearer " + access_token,
              Accept: "application/json"
            };
            return _context2.abrupt("return", config);

          case 20:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, _this, [[6, 12]]);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}(), function (error) {
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
});

axiosInstance.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  if (response.data.Error) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject({
      msg: "Backendmsg: " + response.Error,
      Error: response.Error
    });
  }
  if (!response.data) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject({
      msg: "We got a 200 OK with an empty response",
      Error: "EMPTY SERVER RESPONSE"
    });
  }
  return response;
}, function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (axiosInstance);

/***/ }),

/***/ 371:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 372:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 373:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 374:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 375:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 376:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 377:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 378:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 379:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 380:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 381:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 382:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 383:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 384:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 385:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 386:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 387:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 388:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 389:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 390:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 391:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 394:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(377)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(411),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2bac9b18",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 395:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(376)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(410),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-17af96d1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 396:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(389)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(421),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c6d4a146",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 397:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(391)
}
var Component = __webpack_require__(3)(
  /* script */
  null,
  /* template */
  __webpack_require__(423),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ecb0bf40",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(379)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(413),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3275b118",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(390)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(422),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e3b013bc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(384)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(418),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-708c1aa2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(382)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(295),
  /* template */
  __webpack_require__(416),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 402:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(374)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(408),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-01b4bbaa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 403:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(378)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(412),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2fabd21e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(385)
  __webpack_require__(386)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(419),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7a3b3adb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(387)
  __webpack_require__(388)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(420),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8e702954",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(380)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(301),
  /* template */
  __webpack_require__(414),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3ed27d46",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(381)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(415),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-481db255",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 408:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "settlementCheckoutDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.SET100))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c(_vm.checkoutComponents[_vm.currentStep].component, {
    ref: "checkoutComponent",
    tag: "component",
    attrs: {
      "data": _vm.checkoutComponents[_vm.currentStep].props
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.currentStep > 2 ? _vm.lang.SET118 : _vm.lang.SET101) + "\n          ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep > 0 && _vm.currentStep < 3),
      expression: "currentStep > 0 && currentStep < 3"
    }],
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.currentStep--, (_vm.editBankDetails = false)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.SET110) + "\n          ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep < 3),
      expression: "currentStep < 3"
    }],
    staticClass: "btn btn-raised btn-success",
    class: {
      'dialog-btn-primary': _vm.currentStep !== 2
    },
    attrs: {
      "type": "button",
      "disabled": _vm.editBankDetails
    },
    on: {
      "click": function($event) {
        _vm.currentStep === 2 ? _vm.onFinishSettlement() : _vm.currentStep++
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.currentStep === 2 ? _vm.lang.SET103 : _vm.lang.SET102) + "\n          ")])])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 409:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.dialogId,
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.confirmationTitle))])])]), _vm._v(" "), (!_vm.htmlText) ? _c('div', {
    staticClass: "modal-body table-responsive"
  }, [_vm._t("default")], 2) : _c('div', {
    staticClass: "modal-body table-responsive",
    domProps: {
      "innerHTML": _vm._s(_vm.htmlText)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "disabled": _vm.noButtonDisable
    },
    on: {
      "click": function($event) {
        return _vm.onNoConfirmation()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.noButtonText) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised",
    class: [this.colorRed ? 'btn-danger' : 'dialog-btn-primary'],
    attrs: {
      "type": "button",
      "disabled": _vm.yesButtonDisable
    },
    on: {
      "click": function($event) {
        return _vm.onYesConfirmation()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.yesButtonText) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 410:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "freeOfferFilterChecksDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "id": "freeOfferFilterChecksForm"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.SFO200))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h4', {
    staticClass: "filterTitle"
  }, [_vm._v(_vm._s(_vm.lang.SFO203))]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12 cb-form-group"
  }, [_c('div', {
    staticClass: "pull-left cb-location-free"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formModel.LocationFilterValue),
      expression: "formModel.LocationFilterValue"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formModel, "LocationFilterValue", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.locationFilterTypes.LocationAny
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.lang.SF0226) + "\n                  ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.locationFilterTypes.LocationFree
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.lang.SF0227) + "\n                  ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.locationFilterTypes.LocationNotFree
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.lang.SF0228) + "\n                  ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12 cb-form-group"
  }, [_c('div', {
    staticClass: "checkbox pull-left cb-location-free"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.useMyLocation),
      expression: "useMyLocation"
    }],
    attrs: {
      "type": "checkbox",
      "id": "useMyLocation",
      "disabled": _vm.formModel.LocationFilterValue ===
        _vm.locationFilterTypes.LocationFree
    },
    domProps: {
      "checked": Array.isArray(_vm.useMyLocation) ? _vm._i(_vm.useMyLocation, null) > -1 : (_vm.useMyLocation)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.useMyLocation,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.useMyLocation = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.useMyLocation = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.useMyLocation = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "text text-black"
  }, [_vm._v("\n                    " + _vm._s(_vm.lang.SFO221) + "\n                    "), (!_vm.globals.isMobileBrowser) ? _c('i', {
    staticClass: "material-icons md-cb-info",
    attrs: {
      "id": "useMyLocationInfo"
    }
  }, [_vm._v("info_outline")]) : _vm._e()])])]), _vm._v(" "), (!_vm.globals.isMobileBrowser) ? _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "useMyLocationInfo",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SFO225))]) : _vm._e()], 1), _vm._v(" "), (_vm.useMyLocation) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "text-red",
    class: {
      'text-green': _vm.locationString !== _vm.lang.SFO224
    },
    attrs: {
      "id": "geocodedLocationString"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.locationString) + "\n              ")])]) : _c('div', {
    staticClass: "form-group col-md-8"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputFreeOffersLocation"
    }
  }, [_vm._v(_vm._s(_vm.lang.SFO206))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputFreeOffersLocation",
      "disabled": _vm.formModel.LocationFilterValue ===
        _vm.locationFilterTypes.LocationFree || _vm.useMyLocation
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
      },
      "focus": function($event) {
        return $event.target.select()
      },
      "input": function($event) {
        return _vm.resetCurrentLocation()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('label', {
    staticClass: "col-md-6 control-label",
    attrs: {
      "for": "inputFreeOffersRadius"
    }
  }, [_vm._v(_vm._s(_vm.lang.SFO207))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.distanceInKm),
      expression: "distanceInKm",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "inputFreeOffersRadius",
      "type": "number",
      "disabled": _vm.formModel.LocationFilterValue ===
        _vm.locationFilterTypes.LocationFree
    },
    domProps: {
      "value": (_vm.distanceInKm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.distanceInKm = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        _vm.useFilters &&
        !(
          _vm.formModel.LocationFilterValue ===
          _vm.locationFilterTypes.LocationFree
        ) &&
        !_vm.useMyLocation &&
        !_vm.formModel.CurrentLocation.Latitude &&
        !_vm.formModel.CurrentLocation.Longitude
      ),
      expression: "\n                useFilters &&\n                !(\n                  formModel.LocationFilterValue ===\n                  locationFilterTypes.LocationFree\n                ) &&\n                !useMyLocation &&\n                !formModel.CurrentLocation.Latitude &&\n                !formModel.CurrentLocation.Longitude\n              "
    }],
    staticClass: "\n                col-md-12\n                help-block\n                error\n                text-danger\n                notification-message\n              "
  }, [_vm._v("\n              " + _vm._s(_vm.lang.SFO219) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "checkbox cb-filter-active"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.useFilters),
      expression: "useFilters"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.useFilters) ? _vm._i(_vm.useFilters, null) > -1 : (_vm.useFilters)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.useFilters,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.useFilters = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.useFilters = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.useFilters = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "text text-black"
  }, [_vm._v(_vm._s(_vm.lang.SFO212))])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    class: {
      'pull-left': !_vm.globals.isSmallScreen()
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.resetFilter()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.SFO214) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    class: {
      'pull-right': !_vm.globals.isSmallScreen()
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.doFilterChecks()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.SFO202) + "\n          ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
}]}

/***/ }),

/***/ 411:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "freeOfferDetailsDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.SFO100))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel panel-default table-responsive"
  }, [_c('div', {
    attrs: {
      "id": "surveyFreeOfferDetailsTable"
    }
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v(_vm._s(_vm.lang.SFO101))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v(_vm._s(_vm.freeOffer.SurveyTitle))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v(_vm._s(_vm.lang.SFO102))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.freeOffer.LocationName) + "\n                    "), (_vm.freeOffer.LocationFree) ? _c('span', [_vm._v("(" + _vm._s(_vm.lang.SFO117) + ")")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v(_vm._s(_vm.lang.SFO110))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v(_vm._s(_vm.freeOffer.LocationAddress))])]), _vm._v(" "), (_vm.freeOffer.Distance) ? _c('tr', [_c('td', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v(_vm._s(_vm.lang.SFO116))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.freeOffer.Distance.toFixed(1)) + " km\n                  ")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v(_vm._s(_vm.lang.SFO114))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v(_vm._s(_vm.freeOffer.ScenarioName))])]), _vm._v(" "), (_vm.freeOffer.SurveyInstanceInfo) ? _c('tr', [_c('td', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v(_vm._s(_vm.lang.SFO115))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.freeOffer.SurveyInstanceInfo) + "\n                  ")])]) : _vm._e(), _vm._v(" "), (_vm.freeOffer.LocationAdditionalInfo) ? _c('tr', [_c('td', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v(_vm._s(_vm.lang.SFO113))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "60%"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.freeOffer.LocationAdditionalInfo)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.freeOffer.PurchaseMoney) ? _c('tr', [_c('td', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v(_vm._s(_vm.lang.SFO111))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.globals.getCurrencyString(
    _vm.freeOffer.PurchaseMoney,
    "EUR"
  )) + "\n                  ")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v(_vm._s(_vm.lang.SFO103))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.globals.getCurrencyString(_vm.freeOffer.TotalPayment, "EUR")) + "\n                  ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v(_vm._s(_vm.lang.SFO107))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "60%"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.downloadwithFileName(
          _vm.freeOffer.AGBDownloadId,
          'Free_offer_AGB'
        )
      }
    }
  }, [_vm._v("AGB")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v(_vm._s(_vm.lang.SFO106))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "60%"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.downloadwithFileName(
          _vm.freeOffer.DSGVODownloadId,
          'Free_offer_DSG'
        )
      }
    }
  }, [_vm._v("DSGVO")])])])])])])]), _vm._v(" "), (_vm.freeOffer.SurveyInstanceDescription) ? _c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "surveyInstanceDescriptionPanel"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.freeOffer.SurveyInstanceDescription)
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.SFO109) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.acceptFreeOffer()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.SFO108) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 412:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "settlementInformationModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.SET600))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SET601))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.checkData.SurveyInstanceId))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SET602))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.checkData.SurveyTitle))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SET603))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.checkData.LocationName))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SET614))]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm.checkData.LocationAddress) + " (" + _vm._s(_vm.checkData.LocationCountry) + ")\n                ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SET615))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.checkData.WaveName))])]), _vm._v(" "), (_vm.checkData.CheckoutCreatedAt) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SET604))]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm.globals.getLocalizedDateTimeFromUtcIsoTimestamp(
    _vm.checkData.CheckoutCreatedAt
  )) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.checkData.SettlementComment) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SET605))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.checkData.SettlementComment))])]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SET606))]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm.globals.getCurrencyString(_vm.checkData.BasePayment, "EUR")) + "\n                ")])]), _vm._v(" "), (_vm.checkData.PlusPayment) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SET607))]), _vm._v(" "), _c('td', {
    staticClass: "text-green"
  }, [_vm._v("\n                  " + _vm._s(_vm.globals.getCurrencyString(_vm.checkData.PlusPayment, "EUR")) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.checkData.MinusPayment) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SET608))]), _vm._v(" "), _c('td', {
    staticClass: "text-red"
  }, [_vm._v("\n                  " + _vm._s(_vm.globals.getCurrencyString(_vm.checkData.MinusPayment, "EUR")) + "\n                ")])]) : _vm._e(), _vm._v(" "), _c('tr', {
    staticClass: "total-background"
  }, [_c('td', {
    staticClass: "format-total-text"
  }, [_vm._v(_vm._s(_vm.lang.SET609))]), _vm._v(" "), _c('td', {
    staticClass: "format-total-text"
  }, [_vm._v("\n                  " + _vm._s(_vm.globals.getCurrencyString(_vm.checkData.Total, "EUR")) + "\n                ")])]), _vm._v(" "), (_vm.checkData.VatValue) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SET610) + " (" + _vm._s(_vm.checkData.VatRate * 100) + "%)")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm.globals.getCurrencyString(_vm.checkData.VatValue, "EUR")) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.checkData.PurchaseMoney) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SET611))]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm.globals.getCurrencyString(_vm.checkData.PurchaseMoney, "EUR")) + "\n                ")])]) : _vm._e(), _vm._v(" "), _c('tr', {
    staticClass: "payout-background"
  }, [_c('td', {
    staticClass: "format-total-text"
  }, [_vm._v(_vm._s(_vm.lang.SET612))]), _vm._v(" "), _c('td', {
    staticClass: "format-total-text"
  }, [_vm._v("\n                  " + _vm._s(_vm.globals.getCurrencyString(
    _vm.checkData.TotalWithVatAndPurchaseMoney,
    "EUR"
  )) + "\n                ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.SET613) + "\n          ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col', {
    staticClass: "col-md-4 col-xs-5"
  }), _vm._v(" "), _c('col', {
    staticClass: "col-md-8 col-xs-7"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "empty-row"
  }, [_c('td'), _vm._v(" "), _c('td')])
}]}

/***/ }),

/***/ 413:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "id": "ShopperBankAccountForm"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canEditBankDetails),
      expression: "canEditBankDetails"
    }],
    staticClass: "step-bank-account-notification"
  }, [_vm._v("\n    " + _vm._s(_vm.lang.SET305) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "step-bank-account-title"
  }, [_vm._v(_vm._s(_vm.lang.SET300))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "disabled": _vm.canEditBankDetails
    },
    on: {
      "click": function($event) {
        return _vm.setCanEditBankDetails()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("edit")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    class: {
      'btn-warning': _vm.bankDetailsDataIsDirty
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.bankDetailsDataIsDirty
    },
    on: {
      "click": function($event) {
        return _vm.saveShopperBankDetails()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("save")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "disabled": !_vm.canEditBankDetails || !_vm.hasBankDetails
    },
    on: {
      "click": function($event) {
        return _vm.cancelEditBankDetails()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("cancel")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': !_vm.bankDetailsData.BankName
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperBankName"
    }
  }, [_vm._v(_vm._s(_vm.lang.SET301) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankDetailsData.BankName),
      expression: "bankDetailsData.BankName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperBankName",
      "disabled": !_vm.canEditBankDetails,
      "required": ""
    },
    domProps: {
      "value": (_vm.bankDetailsData.BankName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bankDetailsData, "BankName", $event.target.value)
      }, function($event) {
        _vm.bankDetailsDataIsDirty = true
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': !_vm.bankDetailsData.SwiftCode
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperBankSwiftCode"
    }
  }, [_vm._v(_vm._s(_vm.lang.SET303) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankDetailsData.SwiftCode),
      expression: "bankDetailsData.SwiftCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperBankSwiftCode",
      "disabled": !_vm.canEditBankDetails,
      "required": ""
    },
    domProps: {
      "value": (_vm.bankDetailsData.SwiftCode)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bankDetailsData, "SwiftCode", $event.target.value)
      }, function($event) {
        _vm.bankDetailsDataIsDirty = true
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': !_vm.bankDetailsData.AccountNumber
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperBankAccoutNumber"
    }
  }, [_vm._v(_vm._s(_vm.lang.SET302) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankDetailsData.AccountNumber),
      expression: "bankDetailsData.AccountNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperBankAccoutNumber",
      "disabled": !_vm.canEditBankDetails,
      "required": ""
    },
    domProps: {
      "value": (_vm.bankDetailsData.AccountNumber)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bankDetailsData, "AccountNumber", $event.target.value)
      }, function($event) {
        _vm.bankDetailsDataIsDirty = true
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': !_vm.bankDetailsData.AccountName
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperBankAccoutName"
    }
  }, [_vm._v(_vm._s(_vm.lang.SET304) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankDetailsData.AccountName),
      expression: "bankDetailsData.AccountName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperBankAccoutName",
      "disabled": !_vm.canEditBankDetails,
      "required": ""
    },
    domProps: {
      "value": (_vm.bankDetailsData.AccountName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bankDetailsData, "AccountName", $event.target.value)
      }, function($event) {
        _vm.bankDetailsDataIsDirty = true
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "VAT-title"
  }, [_vm._v(_vm._s(_vm.lang.SET306))]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error':
      !_vm.shopperProfileData.VatNo && !_vm.shopperProfileData.VatNotMandatory,
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputSettlementVatNo"
    }
  }, [_vm._v(_vm._s(_vm.lang.SET307) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shopperProfileData.VatNo),
      expression: "shopperProfileData.VatNo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputSettlementVatNo",
      "disabled": !_vm.canEditBankDetails || _vm.shopperProfileData.VatNotMandatory,
      "required": ""
    },
    domProps: {
      "value": (_vm.shopperProfileData.VatNo)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shopperProfileData, "VatNo", $event.target.value)
      }, function($event) {
        _vm.bankDetailsDataIsDirty = true
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shopperProfileData.VatNotMandatory),
      expression: "shopperProfileData.VatNotMandatory"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": !_vm.canEditBankDetails
    },
    domProps: {
      "checked": Array.isArray(_vm.shopperProfileData.VatNotMandatory) ? _vm._i(_vm.shopperProfileData.VatNotMandatory, null) > -1 : (_vm.shopperProfileData.VatNotMandatory)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.shopperProfileData.VatNotMandatory,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.shopperProfileData, "VatNotMandatory", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.shopperProfileData, "VatNotMandatory", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.shopperProfileData, "VatNotMandatory", $$c)
        }
      }, function($event) {
        delete _vm.shopperProfileData.VatNo
      }],
      "input": function($event) {
        _vm.bankDetailsDataIsDirty = true
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "text text-black"
  }, [_vm._v(_vm._s(_vm.lang.SET308))])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
}]}

/***/ }),

/***/ 414:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    attrs: {
      "id": _vm.dialogId,
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header",
    style: (_vm.modalStyle)
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h2', {
    staticClass: "modal-title"
  }, [_c('b', {
    domProps: {
      "innerHTML": _vm._s(_vm.errorText)
    }
  })])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 415:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "uploadProgressModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content msm-form-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.UPM000) + "...")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-msm",
    style: (("width: " + (_vm.globals.currentUploadProgress) + "%"))
  })]), _vm._v("\n        " + _vm._s(_vm.globals.currentUploadProgress) + " %\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.globals.cancelPendingUploads();
        _vm.closeModal();
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.UPM001) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 416:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "completion-text"
  }, [_vm._v(_vm._s(_vm.lang.SET500))])
},staticRenderFns: []}

/***/ }),

/***/ 417:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    staticClass: "select2-control hidden"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 418:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "step-check-overview-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.SET200))])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.lang.SET201))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.lang.SET202))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.lang.SET203))])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.shopperCart.CartItems), function(cartItem) {
    return _c('tr', {
      key: cartItem.CartItemGuid
    }, [_c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(cartItem.SurveyInstanceId))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "65%"
      }
    }, [_vm._v(_vm._s(cartItem.SurveyTitle))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v("\n          " + _vm._s(_vm.globals.getCurrencyString(cartItem.Total, "EUR")) + "\n        ")])])
  }), _vm._v(" "), _c('tr', {
    staticClass: "total-background"
  }, [_c('td', {
    staticClass: "align-total-text format-total-text",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.SET204) + "\n        ")]), _vm._v(" "), _c('td', {
    staticClass: "format-total-text"
  }, [_vm._v("\n          " + _vm._s(_vm.globals.getCurrencyString(_vm.shopperCart.Total, "EUR")) + "\n        ")])])], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ 419:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "settlement-top-panel"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.refreshEnabled
    },
    on: {
      "click": function($event) {
        return _vm.getSurveyInstances()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("refresh")]), _vm._v(" "), (!_vm.isSmallScreen) ? [_c('br'), _vm._v("\n            " + _vm._s(_vm.lang.SET000) + "\n          ")] : _vm._e()], 2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": _vm.selectedSurveys.length === 0
    },
    on: {
      "click": function($event) {
        return _vm.openSettlementCheckoutDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("attach_money")]), _vm._v(" "), (!_vm.isSmallScreen) ? [_c('br'), _vm._v("\n            " + _vm._s(_vm.lang.SET004) + "\n          ")] : _vm._e()], 2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": _vm.selectedSurveys.length !== 1
    },
    on: {
      "click": function($event) {
        _vm.showSettlementInformationModal = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("info_outline")]), _vm._v(" "), (!_vm.isSmallScreen) ? [_c('br'), _vm._v("\n            " + _vm._s(_vm.lang.SET023) + "\n          ")] : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-group searchbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Search),
      expression: "filterStrings.Search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "id": "inputSearch",
      "placeholder": _vm.lang.SET002
    },
    domProps: {
      "value": (_vm.filterStrings.Search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getSurveyInstances()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Search", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.isSmallScreen) ? _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-group searchbar"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SettlementStatusGuid),
      expression: "filterStrings.SettlementStatusGuid"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filterStrings, "SettlementStatusGuid", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        (_vm.selectedPage = 1), _vm.getSurveyInstances()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "hidden": ""
    }
  }, [_vm._v(_vm._s(_vm.lang.SET015))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.lang.SET016))]), _vm._v(" "), _vm._l((_vm.settlementStatusList), function(settlementState) {
    return _c('option', {
      key: settlementState.SettlementStatusGuid,
      domProps: {
        "value": settlementState.SettlementStatusGuid
      }
    }, [_vm._v("\n              " + _vm._s(settlementState.SettlementStatusText) + "\n            ")])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-xs-12 nopadding"
  }, [_c('ul', {
    staticClass: "pagination-fonts pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdown",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SET003))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 100
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 200
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 500
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 500)
      }
    }
  }, [_vm._v("500")])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: _vm.selectedPage == 1
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 0)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SET011))])], 1), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage > 4) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getVisiblePages()), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.selectedPage == pageNumber
      },
      on: {
        "click": function($event) {
          return _vm.updatePaging(pageNumber, 0)
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage < _vm.pageCount - 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled: _vm.selectedPage == _vm.pageCount
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(_vm.pageCount, 0)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SET026))])], 1), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "settlementChecksTotalElementsCounter"
    }
  }, [_vm._v(_vm._s(_vm.checkCount))]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "settlementChecksTotalElementsCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SET027))])], 1)], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "settlement-table"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "table-space main-table-scrollbar"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center sticky-header",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('SettlementStatusGuid')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.isSmallScreen ? _vm.lang.SET017 : _vm.lang.SET008) + "\n                  "), (_vm.showSortArrow('SettlementStatusGuid', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SettlementStatusGuid', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), (!_vm.isSmallScreen) ? _c('th', {
    staticClass: "text-center sticky-header",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('SurveyInstanceId')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SET005) + "\n                  "), (_vm.showSortArrow('SurveyInstanceId', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SurveyInstanceId', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header",
    style: (("width:" + (_vm.isSmallScreen ? '40' : '20') + "%;"))
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('SurveyTitle')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.isSmallScreen ? _vm.lang.SET013 : _vm.lang.SET006) + "\n                  "), (_vm.showSortArrow('SurveyTitle', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SurveyTitle', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), (!_vm.isSmallScreen) ? _c('th', {
    staticClass: "text-center sticky-header",
    style: ("width:10%;")
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('LocationName')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.isSmallScreen ? _vm.lang.SET014 : _vm.lang.SET007) + "\n                  "), (_vm.showSortArrow('LocationName', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('LocationName', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.isSmallScreen) ? _c('th', {
    staticClass: "text-center sticky-header",
    style: ("width:15%;")
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('LocationAddress')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SET024) + "\n                  "), (_vm.showSortArrow('LocationAddress', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('LocationAddress', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.isSmallScreen) ? _c('th', {
    staticClass: "text-center sticky-header",
    style: ("width:5%;")
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('LocationCountry')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SET025) + "\n                  "), (_vm.showSortArrow('LocationCountry', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('LocationCountry', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header",
    style: (("width:" + (_vm.isSmallScreen ? '15' : '10') + "%;"))
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('Total')
      }
    }
  }, [(!_vm.isSmallScreen) ? [_vm._v(_vm._s(_vm.lang.SET010))] : _c('i', {
    staticClass: "material-icons md-20"
  }, [_vm._v("euro_symbol")]), _vm._v(" "), (_vm.showSortArrow('Total', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('Total', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()], 2)]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header",
    style: (("width:" + (_vm.isSmallScreen ? '15' : '10') + "%;"))
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('SettlementNumber')
      }
    }
  }, [(!_vm.isSmallScreen) ? [_vm._v(_vm._s(_vm.lang.SET012))] : _c('i', {
    staticClass: "material-symbols-outlined"
  }, [_vm._v("#")]), _vm._v(" "), (_vm.showSortArrow('SettlementNumber', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SettlementNumber', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()], 2)]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header",
    style: (("width:" + (_vm.isSmallScreen ? '20' : '10') + "%;"))
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('SurveyInstanceShopperSubmittedAt')
      }
    }
  }, [(!_vm.isSmallScreen) ? [_vm._v(_vm._s(_vm.lang.SET009))] : _c('i', {
    staticClass: "material-icons md-20"
  }, [_vm._v("today")]), _vm._v(" "), (
    _vm.showSortArrow('SurveyInstanceShopperSubmittedAt', true)
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.showSortArrow('SurveyInstanceShopperSubmittedAt', false)
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()], 2)])]), _vm._v(" "), (_vm.globals.isLargeScreen()) ? _c('tr', {
    staticClass: "table-filters"
  }, [_c('th', {
    staticClass: "nopadding sticky-filter",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar",
    attrs: {
      "id": "settlementStatusFilterContainer"
    }
  }, [_c('Select2', {
    staticClass: "form-control nopadding",
    attrs: {
      "id": "settlementStatusFilterSelect",
      "allowClear": true,
      "placeholder": _vm.lang.SET001
    },
    on: {
      "change": function($event) {
        (_vm.selectedPage = 1), _vm.getSurveyInstances()
      }
    },
    model: {
      value: (_vm.filterStrings.SettlementStatusGuid),
      callback: function($$v) {
        _vm.$set(_vm.filterStrings, "SettlementStatusGuid", $$v)
      },
      expression: "filterStrings.SettlementStatusGuid"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.settlementStatusList), function(settlementState) {
    return _c('option', {
      key: settlementState.SettlementStatusGuid,
      domProps: {
        "value": settlementState.SettlementStatusGuid
      }
    }, [_vm._v("\n                      " + _vm._s(settlementState.SettlementStatusText) + "\n                    ")])
  })], 2)], 1)]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceId),
      expression: "filterStrings.SurveyInstanceId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SET001
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getSurveyInstances()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter",
    staticStyle: {
      "width": "20%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyTitle),
      expression: "filterStrings.SurveyTitle"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SET001
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyTitle)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getSurveyInstances()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyTitle", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationName),
      expression: "filterStrings.LocationName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SET001
    },
    domProps: {
      "value": (_vm.filterStrings.LocationName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getSurveyInstances()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter",
    staticStyle: {
      "width": "15%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationAddress),
      expression: "filterStrings.LocationAddress"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SET001
    },
    domProps: {
      "value": (_vm.filterStrings.LocationAddress)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getSurveyInstances()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationAddress", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationCountry),
      expression: "filterStrings.LocationCountry"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SET001
    },
    domProps: {
      "value": (_vm.filterStrings.LocationCountry)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getSurveyInstances()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationCountry", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Total),
      expression: "filterStrings.Total"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SET001
    },
    domProps: {
      "value": (_vm.filterStrings.Total)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getSurveyInstances()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Total", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SettlementNumber),
      expression: "filterStrings.SettlementNumber"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SET001
    },
    domProps: {
      "value": (_vm.filterStrings.SettlementNumber)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getSurveyInstances()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SettlementNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceShopperSubmittedAt),
      expression: "filterStrings.SurveyInstanceShopperSubmittedAt"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SET001
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceShopperSubmittedAt)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getSurveyInstances()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceShopperSubmittedAt", $event.target.value)
      }
    }
  })])])]) : _vm._e()]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar"
  }, _vm._l((_vm.surveyInstances), function(survey) {
    return _c('tr', {
      directives: [{
        name: "longclick",
        rawName: "v-longclick",
        value: (
          function () { return (_vm.selectedSurveys = [survey.SurveyInstanceGuid]); }
        ),
        expression: "\n                () => (selectedSurveys = [survey.SurveyInstanceGuid])\n              "
      }],
      key: survey.SurveyInstanceGuid,
      staticClass: "text-center",
      class: {
        info: _vm.isSurveySelected(survey.SurveyInstanceGuid)
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.selectSurveys(survey.SurveyInstanceGuid, $event)
        }
      }
    }, [_c('td', {
      staticClass: "nopadding",
      style: (("width:" + (_vm.isSmallScreen ? '10' : '10') + "%;")),
      attrs: {
        "id": "materialIconCell"
      }
    }, [(
      survey.SettlementStatusGuid ===
      '5D298073-70E7-472F-9E01-AF19E2BA1C03'
    ) ? _c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("autorenew")]) : _vm._e(), _vm._v(" "), (
      survey.SettlementStatusGuid ===
      '31F176F1-6D31-4F88-BDC5-B62F4EFB5107'
    ) ? _c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("add_circle_outline")]) : _vm._e(), _vm._v(" "), (
      survey.SettlementStatusGuid ===
      '39E928BA-82BA-4ADD-9E89-04AE44CBCA04'
    ) ? _c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("check_circle")]) : _vm._e()]), _vm._v(" "), (!_vm.isSmallScreen) ? _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v("\n                " + _vm._s(survey.SurveyInstanceId) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('td', {
      style: (("width:" + (_vm.isSmallScreen ? '40' : '20') + "%;"))
    }, [_vm._v("\n                " + _vm._s(survey.SurveyTitle) + "\n              ")]), _vm._v(" "), (!_vm.isSmallScreen) ? _c('td', {
      style: ("width:10%;")
    }, [_vm._v("\n                " + _vm._s(survey.LocationName) + "\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.isSmallScreen) ? _c('td', {
      style: ("width:15%;")
    }, [_vm._v("\n                " + _vm._s(survey.LocationAddress) + "\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.isSmallScreen) ? _c('td', {
      style: ("width:5%;")
    }, [_vm._v("\n                " + _vm._s(survey.LocationCountry) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('td', {
      style: (("width:" + (_vm.isSmallScreen ? '15' : '10') + "%;"))
    }, [_vm._v("\n                " + _vm._s(_vm.globals.getCurrencyString(survey.Total, "EUR")) + "\n              ")]), _vm._v(" "), _c('td', {
      style: (("width:" + (_vm.isSmallScreen ? '15' : '10') + "%;"))
    }, [_vm._v("\n                " + _vm._s(survey.SettlementNumber) + "\n              ")]), _vm._v(" "), _c('td', {
      style: (("width:" + (_vm.isSmallScreen ? '20' : '10') + "%;"))
    }, [_vm._v("\n                " + _vm._s(survey.SurveyInstanceShopperSubmittedAt) + "\n              ")])])
  }), 0)])])])]), _vm._v(" "), _c('SettlementCheckoutDialog', {
    attrs: {
      "showDialog": _vm.showSettlementCheckoutDialog,
      "selectedSurveys": _vm.selectedSurveys
    },
    on: {
      "dialogClosed": _vm.closeSettlementCheckoutDialog,
      "dialogDataSaved": _vm.onDialogDataSaved
    }
  }), _vm._v(" "), _c('SettlementInformationModal', {
    attrs: {
      "showModal": _vm.showSettlementInformationModal,
      "checkData": _vm.firstSelectedCheckData
    },
    on: {
      "closeModal": function($event) {
        _vm.showSettlementInformationModal = false
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])])
}]}

/***/ }),

/***/ 420:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (
    _vm.globals.isAccessAllowed('LoopOp_SurveyInstancesAnswers_ReadAll') &&
    _vm.globals.currentUserRole == 3
  ) ? _c('div', [_c('ConfirmationDialog', {
    attrs: {
      "dialogId": 'openSurveyConfirmationModal',
      "confirmationTitle": _vm.lang.SL0018,
      "showDialog": _vm.showConfirmationDialog,
      "yesButtonDisable": !_vm.languageChoosen || (!_vm.locationChoosen && _vm.hasLocationDummy),
      "yesButtonText": _vm.lang.SL0019,
      "noButtonText": _vm.lang.SL0020
    },
    on: {
      "dialogClosed": _vm.onConfirmationDialogClosed,
      "onYesConfirmation": _vm.onYesConfirmation
    }
  }, [_c('div', {
    attrs: {
      "id": "confirmation-table"
    }
  }, [(_vm.selectedSurveyInstance) ? _c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SL0000))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.selectedSurveyInstanceId))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SL0025))]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.selectedSurveyInstance.SurveyTitle) + "\n            ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SL0016))]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.selectedSurveyInstance.LocationName) + "\n            ")])]), _vm._v(" "), (_vm.hasLocationDummy) ? _c('tr', [_c('td', [_vm._v("Select Location")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    staticClass: "form-control m-0",
    attrs: {
      "id": "select-location",
      "placeholder": _vm.placeholderSelectLocation,
      "allowClear": true
    },
    on: {
      "change": _vm.chooseLocation
    },
    model: {
      value: (_vm.selectedLocation),
      callback: function($$v) {
        _vm.selectedLocation = $$v
      },
      expression: "selectedLocation"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.possibleLocations), function(location) {
    return _c('option', {
      key: location.LocationGuid,
      domProps: {
        "value": location.LocationGuid
      }
    }, [_vm._v("\n                    (" + _vm._s(location.LocationStoreId) + ")\n                    " + _vm._s(location.LocationAddress) + "\n                  ")])
  })], 2)], 1)])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SL0007))]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.selectedSurveyInstance.LocationAddress) + "\n            ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SL0013))]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.selectedSurveyInstance.ScenarioName) + "\n            ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SL0014))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.selectedSurveyInstance.WaveName))])]), _vm._v(" "), (_vm.selectedSurveyInstance.SurveyInstanceInfo) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SL0039))]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.selectedSurveyInstance.SurveyInstanceInfo) + "\n            ")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SL0041))]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.selectedSurveyInstance.SurveyInstanceSince) + "\n            ")])]), _vm._v(" "), _c('tr', {
    class: {
      'text-red': _vm.selectedSurveyInstance.SurveyInstanceIsExpired,
    }
  }, [_c('td', [_vm._v(_vm._s(_vm.lang.SL0038))]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.selectedSurveyInstance.SurveyInstanceUntil) + "\n            ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SL0015))]), _vm._v(" "), _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.selectedSurveyInstance.LocationAdditionalInfo)
    }
  })]), _vm._v(" "), (
    _vm.selectedSurveyInstance.SurveyInstanceTotalPayment &&
    !_vm.globals.isSurveyCodeUser
  ) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SL0037))]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.globals.getCurrencyString(
    _vm.selectedSurveyInstance.SurveyInstanceTotalPayment,
    "EUR"
  )) + "\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.selectedSurveyInstance.SurveyInstanceShopperSubmittedAt) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SL0032))]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.selectedSurveyInstance.SurveyInstanceShopperSubmittedAt) + "\n            ")])]) : _vm._e(), _vm._v(" "), (
    _vm.selectedSurveyInstance.BriefingDownload &&
    _vm.selectedSurveyInstance.BriefingDownload.Guid
  ) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SL0035))]), _vm._v(" "), _c('td', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.donwloadBriefing(
          _vm.selectedSurveyInstance.BriefingDownload.Guid,
          _vm.selectedSurveyInstance.BriefingDownload.FileName
        )
      }
    }
  }, [_vm._v(_vm._s(_vm.selectedSurveyInstance.BriefingDownload.FileName))])])]) : _vm._e(), _vm._v(" "), (
    _vm.selectedSurveyInstance.SurveyDownload &&
    _vm.selectedSurveyInstance.SurveyDownload.Guid
  ) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SL0036))]), _vm._v(" "), _c('td', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.downloadSurveyDownload(
          _vm.selectedSurveyInstance.SurveyDownload.Guid,
          _vm.selectedSurveyInstance.SurveyDownload.FileName
        )
      }
    }
  }, [_vm._v(_vm._s(_vm.selectedSurveyInstance.SurveyDownload.FileName))])])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.SL0001))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    staticClass: "form-control nopadding",
    attrs: {
      "id": "selectLanguage"
    },
    on: {
      "change": function($event) {
        return _vm.chooseSurveyLanguage()
      }
    },
    model: {
      value: (_vm.selectedSurveyInstanceAnswerLanguage),
      callback: function($$v) {
        _vm.selectedSurveyInstanceAnswerLanguage = $$v
      },
      expression: "selectedSurveyInstanceAnswerLanguage"
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0002))]), _vm._v(" "), _vm._l((_vm.surveyInstanceAnswerLanguageList), function(language) {
    return _c('option', {
      key: language.LocaleCode,
      domProps: {
        "value": language.LocaleCode,
        "selected": _vm.selectedSurveyInstanceAnswerLanguage ===
          language.LocaleCode
      }
    }, [_vm._v("\n                    " + _vm._s(language.LocaleName) + "\n                  ")])
  })], 2)], 1)])])])]) : _vm._e()])]), _vm._v(" "), (!_vm.showSurvey) ? _c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "survey-top-panel"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.refreshEnabled
    },
    on: {
      "click": function($event) {
        return _vm.getAllSurveyInstancesAnswers()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("refresh")]), _vm._v(" "), (!_vm.isSmallScreen) ? [_c('br'), _vm._v("\n            " + _vm._s(_vm.lang.SL0009) + "\n          ")] : _vm._e()], 2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.globals.isAccessAllowed('LoopOp_SurveyInstancesAnswers_Read') ||
        _vm.selectedSurveyInstanceId < 0
    },
    on: {
      "click": function($event) {
        return _vm.openSelectedSurveyInstance()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("open_in_browser")]), _vm._v(" "), (!_vm.isSmallScreen) ? [_c('br'), _vm._v("\n            " + _vm._s(_vm.lang.SL0010) + "\n          ")] : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-group searchbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchString),
      expression: "searchString"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "id": "inputSearch",
      "placeholder": _vm.lang.SL0012
    },
    domProps: {
      "value": (_vm.searchString)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchString = $event.target.value
      }, function($event) {
        return _vm.doDebouncedFiltering()
      }]
    }
  })])]), _vm._v(" "), (_vm.isSmallScreen) ? _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-group searchbar"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.SurveyInstanceStatusId),
      expression: "filters.SurveyInstanceStatusId"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "SurveyInstanceStatusId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.doFiltering()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "hidden": ""
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0033))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0034))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0028))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "110"
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0029))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "120"
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0030))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "130"
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0031))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-xs-12 nopadding"
  }, [_c('ul', {
    staticClass: "pagination-fonts pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdown",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0021))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 100
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 200
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 500
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 500)
      }
    }
  }, [_vm._v("500")])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: _vm.selectedPage == 1
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 0)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0022))])], 1), _vm._v(" "), (_vm.numberOfPages() > 7 && _vm.selectedPage > 4) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getVisiblePages()), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.selectedPage == pageNumber
      },
      on: {
        "click": function($event) {
          return _vm.updatePaging(pageNumber, 0)
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (_vm.numberOfPages() > 7 && _vm.selectedPage < _vm.numberOfPages() - 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled: _vm.selectedPage == _vm.numberOfPages()
    },
    on: {
      "click": function($event) {
        _vm.updatePaging(_vm.numberOfPages(), 0)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0023))])], 1), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "checksTotalElementsCounter"
    }
  }, [_vm._v(_vm._s(_vm.filteredSurveyListData.length))]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "checksTotalElementsCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0040))])], 1)], 2)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "survey"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table",
    attrs: {
      "id": "the-table"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('SurveyInstanceStatusId')
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0003) + "\n                "), (_vm.showSortArrow('SurveyInstanceStatusId', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SurveyInstanceStatusId', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('SurveyTitle')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.isSmallScreen ? _vm.lang.SL0025 : _vm.lang.SL0004) + "\n                "), (_vm.showSortArrow('SurveyTitle', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SurveyTitle', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header",
    class: {
      hidden: _vm.isSmallScreen
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('SurveyInstanceId')
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0005) + "\n                "), (_vm.showSortArrow('SurveyInstanceId', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SurveyInstanceId', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('LocationName')
      }
    }
  }, [_vm._v(_vm._s(_vm.isSmallScreen ? _vm.lang.SL0024 : _vm.lang.SL0016) + "\n                "), (_vm.showSortArrow('LocationName', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('LocationName', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('LocationAddress')
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0007) + "\n                "), (_vm.showSortArrow('LocationAddress', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('LocationAddress', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('ScenarioName')
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0013) + "\n                "), (_vm.showSortArrow('ScenarioName', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('ScenarioName', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header",
    class: {
      hidden: _vm.isSmallScreen
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('WaveName')
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0014) + "\n                "), (_vm.showSortArrow('WaveName', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('WaveName', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header",
    class: {
      hidden: _vm.isSmallScreen
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('SurveyInstanceInfo')
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0039) + "\n                "), (_vm.showSortArrow('SurveyInstanceInfo', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SurveyInstanceInfo', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header",
    class: {
      hidden: _vm.isSmallScreen
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('LocationAdditionalInfo')
      }
    }
  }, [_vm._v(_vm._s(_vm.isSmallScreen ? _vm.lang.SL0026 : _vm.lang.SL0015) + "\n                "), (_vm.showSortArrow('LocationAdditionalInfo', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('LocationAdditionalInfo', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header",
    class: {
      hidden: _vm.isSmallScreen || _vm.globals.isSurveyCodeUser
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('SurveyInstanceTotalPayment')
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0037) + "\n                "), (_vm.showSortArrow('SurveyInstanceTotalPayment', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SurveyInstanceTotalPayment', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('SurveyInstanceProgress')
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0008) + "\n                "), (_vm.showSortArrow('SurveyInstanceProgress', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SurveyInstanceProgress', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header",
    class: {
      hidden: _vm.isSmallScreen
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('SurveyInstanceShopperSubmittedAt')
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0032) + "\n                "), (
    _vm.showSortArrow('SurveyInstanceShopperSubmittedAt', true)
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.showSortArrow('SurveyInstanceShopperSubmittedAt', false)
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header",
    class: {
      hidden: _vm.isSmallScreen
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('SurveyInstanceUntil')
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0038) + "\n                "), (_vm.showSortArrow('SurveyInstanceUntil', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SurveyInstanceUntil', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])])]), _vm._v(" "), (_vm.globals.isLargeScreen()) ? _c('tr', {
    staticClass: "table-filters"
  }, [_c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar",
    attrs: {
      "id": "surveyListStatusFilterContainer"
    }
  }, [_c('select2', {
    staticClass: "form-control nopadding",
    attrs: {
      "id": "surveyListStatusFilterSelect",
      "allowClear": true,
      "placeholder": _vm.lang.SL0027
    },
    on: {
      "change": function($event) {
        return _vm.doFiltering()
      },
      "open": function($event) {
        return _vm.surveyListStatusFilterSelectOpened()
      }
    },
    model: {
      value: (_vm.filters.SurveyInstanceStatusId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "SurveyInstanceStatusId", $$v)
      },
      expression: "filters.SurveyInstanceStatusId"
    }
  }, [_c('option'), _vm._v(" "), _c('option', {
    domProps: {
      "value": 100
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0028))]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 110
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0029))]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 120
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0030))]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 130
    }
  }, [_vm._v(_vm._s(_vm.lang.SL0031))])])], 1)]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.SurveyTitle),
      expression: "filters.SurveyTitle"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SL0027
    },
    domProps: {
      "value": (_vm.filters.SurveyTitle)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "SurveyTitle", $event.target.value)
      }, function($event) {
        return _vm.doDebouncedFiltering()
      }]
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.SurveyInstanceId),
      expression: "filters.SurveyInstanceId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SL0027
    },
    domProps: {
      "value": (_vm.filters.SurveyInstanceId)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "SurveyInstanceId", $event.target.value)
      }, function($event) {
        return _vm.doDebouncedFiltering()
      }]
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.LocationName),
      expression: "filters.LocationName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SL0027
    },
    domProps: {
      "value": (_vm.filters.LocationName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "LocationName", $event.target.value)
      }, function($event) {
        return _vm.doDebouncedFiltering()
      }]
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.LocationAddress),
      expression: "filters.LocationAddress"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SL0027
    },
    domProps: {
      "value": (_vm.filters.LocationAddress)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "LocationAddress", $event.target.value)
      }, function($event) {
        return _vm.doDebouncedFiltering()
      }]
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.ScenarioName),
      expression: "filters.ScenarioName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SL0027
    },
    domProps: {
      "value": (_vm.filters.ScenarioName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "ScenarioName", $event.target.value)
      }, function($event) {
        return _vm.doDebouncedFiltering()
      }]
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.WaveName),
      expression: "filters.WaveName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SL0027
    },
    domProps: {
      "value": (_vm.filters.WaveName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "WaveName", $event.target.value)
      }, function($event) {
        return _vm.doDebouncedFiltering()
      }]
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.SurveyInstanceInfo),
      expression: "filters.SurveyInstanceInfo"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SL0027
    },
    domProps: {
      "value": (_vm.filters.SurveyInstanceInfo)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "SurveyInstanceInfo", $event.target.value)
      }, function($event) {
        return _vm.doDebouncedFiltering()
      }]
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.LocationAdditionalInfo),
      expression: "filters.LocationAdditionalInfo"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SL0027
    },
    domProps: {
      "value": (_vm.filters.LocationAdditionalInfo)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "LocationAdditionalInfo", $event.target.value)
      }, function($event) {
        return _vm.doDebouncedFiltering()
      }]
    }
  })])]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.globals.isSurveyCodeUser),
      expression: "!globals.isSurveyCodeUser"
    }],
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.SurveyInstanceTotalPayment),
      expression: "filters.SurveyInstanceTotalPayment"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SL0027
    },
    domProps: {
      "value": (_vm.filters.SurveyInstanceTotalPayment)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "SurveyInstanceTotalPayment", $event.target.value)
      }, function($event) {
        return _vm.doDebouncedFiltering()
      }]
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.SurveyInstanceProgress),
      expression: "filters.SurveyInstanceProgress"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SL0027
    },
    domProps: {
      "value": (_vm.filters.SurveyInstanceProgress)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "SurveyInstanceProgress", $event.target.value)
      }, function($event) {
        return _vm.doDebouncedFiltering()
      }]
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.SurveyInstanceShopperSubmittedAt),
      expression: "filters.SurveyInstanceShopperSubmittedAt"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SL0027
    },
    domProps: {
      "value": (_vm.filters.SurveyInstanceShopperSubmittedAt)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "SurveyInstanceShopperSubmittedAt", $event.target.value)
      }, function($event) {
        return _vm.doDebouncedFiltering()
      }]
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.SurveyInstanceUntil),
      expression: "filters.SurveyInstanceUntil"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SL0027
    },
    domProps: {
      "value": (_vm.filters.SurveyInstanceUntil)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "SurveyInstanceUntil", $event.target.value)
      }, function($event) {
        return _vm.doDebouncedFiltering()
      }]
    }
  })])])]) : _vm._e()]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar"
  }, _vm._l((_vm.surveysOnCurrentPage), function(survey) {
    return _c('tr', {
      key: survey.SurveyInstanceId,
      staticClass: "text-center",
      class: {
        info: survey.SurveyInstanceId === _vm.selectedSurveyInstanceId,
          'text-red': survey.SurveyInstanceIsExpired,
          'text-grey': survey.SurveyInstanceIsInactive,
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          (_vm.selectedSurveyInstanceId = survey.SurveyInstanceId),
          (_vm.selectedSurveyInstance = survey)
        },
        "dblclick": function($event) {
          !_vm.globals.isAccessAllowed(
            'LoopOp_SurveyInstancesAnswers_Read'
          ) || _vm.openSelectedSurveyInstance()
        }
      }
    }, [_c('td', {
      attrs: {
        "id": "materialIconCell"
      }
    }, [(survey.SurveyInstanceStatusId == 100) ? _c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("add_circle_outline")]) : _vm._e(), _vm._v(" "), (survey.SurveyInstanceStatusId == 110) ? _c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("autorenew")]) : _vm._e(), _vm._v(" "), (survey.SurveyInstanceStatusId == 120) ? _c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("check_circle")]) : _vm._e(), _vm._v(" "), (survey.SurveyInstanceStatusId == 130) ? _c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("help_outline")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "word-break"
    }, [_vm._v(_vm._s(survey.SurveyTitle))])]), _vm._v(" "), _c('td', {
      class: {
        hidden: _vm.isSmallScreen
      }
    }, [_c('span', [_vm._v(_vm._s(survey.SurveyInstanceId))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(survey.LocationName))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(survey.LocationAddress))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(survey.ScenarioName))])]), _vm._v(" "), _c('td', {
      class: {
        hidden: _vm.isSmallScreen
      }
    }, [_c('span', [_vm._v(_vm._s(survey.WaveName))])]), _vm._v(" "), _c('td', {
      class: {
        hidden: _vm.isSmallScreen
      }
    }, [_c('span', [_vm._v(_vm._s(survey.SurveyInstanceInfo))])]), _vm._v(" "), _c('td', {
      class: {
        hidden: _vm.isSmallScreen
      }
    }, [_c('span', {
      staticClass: "word-break"
    }, [_vm._v("\n                " + _vm._s(_vm.globals.truncateString(
      _vm.globals.getMarkupText(survey.LocationAdditionalInfo),
      40
    )))])]), _vm._v(" "), _c('td', {
      class: {
        hidden: _vm.isSmallScreen || _vm.globals.isSurveyCodeUser
      }
    }, [_c('span', [_vm._v(_vm._s(survey.SurveyInstanceTotalPayment ?
      _vm.globals.getCurrencyString(
        survey.SurveyInstanceTotalPayment,
        "EUR"
      ) :
      ""))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(survey.SurveyInstanceProgress) + "%")])]), _vm._v(" "), _c('td', {
      class: {
        hidden: _vm.isSmallScreen
      }
    }, [_c('span', [_vm._v(_vm._s(survey.SurveyInstanceShopperSubmittedAt))])]), _vm._v(" "), _c('td', {
      class: {
        hidden: _vm.isSmallScreen
      }
    }, [_c('span', [_vm._v(_vm._s(survey.SurveyInstanceUntil))])])])
  }), 0)])])])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])])
}]}

/***/ }),

/***/ 421:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "free-offer-top-panel"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.refreshEnabled
    },
    on: {
      "click": function($event) {
        return _vm.getFreeOffers()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("refresh")]), _vm._v(" "), (!_vm.isSmallScreen) ? [_c('br'), _vm._v("\n            " + _vm._s(_vm.lang.SFO000) + "\n          ")] : _vm._e()], 2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.selectedFreeOfferGuid
    },
    on: {
      "click": function($event) {
        return _vm.openFreeOfferDetailsDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("info_outline")]), _vm._v(" "), (!_vm.isSmallScreen) ? [_c('br'), _vm._v("\n            " + _vm._s(_vm.lang.SFO001) + "\n          ")] : _vm._e()], 2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    on: {
      "click": function($event) {
        return _vm.openFreeOfferFilterChecksDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("filter_list")]), _vm._v(" "), (!_vm.isSmallScreen) ? [_c('br'), _vm._v("\n            " + _vm._s(_vm.lang.SFO016) + "\n          ")] : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-xs-6 col-md-4"
  }, [_c('div', {
    staticClass: "form-group searchbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Search),
      expression: "filterStrings.Search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "id": "inputSearch",
      "placeholder": _vm.lang.SFO002
    },
    domProps: {
      "value": (_vm.filterStrings.Search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getFreeOffers()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Search", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-2"
  }, [(_vm.filterOptions.CurrentLocation) ? _c('a', {
    staticClass: "btn",
    attrs: {
      "role": "button",
      "id": "orderByDistanceButton"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('Distance')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.SFO025) + "\n          "), (_vm.showSortArrow('Distance', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : (_vm.showSortArrow('Distance', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _c('span', {
    staticClass: "glyphicon glyphicon-sort"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-xs-12 nopadding"
  }, [_c('ul', {
    staticClass: "pagination-fonts pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdown",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SFO004))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 100
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 200
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 500
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 500)
      }
    }
  }, [_vm._v("500")])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: _vm.selectedPage == 1
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 0)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SFO005))])], 1), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage > 4) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getVisiblePages()), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.selectedPage == pageNumber
      },
      on: {
        "click": function($event) {
          return _vm.updatePaging(pageNumber, 0)
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage < _vm.pageCount - 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled: _vm.selectedPage == _vm.pageCount
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(_vm.pageCount, 0)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SFO006))])], 1), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "freeOfferTotalElementsCounter"
    }
  }, [_vm._v(_vm._s(_vm.checkCount))]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "freeOfferTotalElementsCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SFO024))])], 1)], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "freeofferstable"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "table-space main-table-scrollbar"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table"
  }, [_c('thead', [_c('tr', [(!_vm.isSmallScreen) ? _c('th', {
    staticClass: "text-center sticky-header",
    staticStyle: {
      "width": "8%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('SurveyInstanceId')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SFO008) + "\n                  "), (_vm.showSortArrow('SurveyInstanceId', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SurveyInstanceId', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header",
    style: (("width:" + (_vm.isSmallScreen ? '25' : '13') + "%;"))
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('SurveyTitle')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.isSmallScreen ? _vm.lang.SFO017 : _vm.lang.SFO012) + "\n                  "), (_vm.showSortArrow('SurveyTitle', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SurveyTitle', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), (!_vm.isSmallScreen) ? _c('th', {
    staticClass: "text-center sticky-header",
    staticStyle: {
      "width": "30%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('SurveyInstanceDescription')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SFO011) + "\n                  "), (_vm.showSortArrow('SurveyInstanceDescription', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SurveyInstanceDescription', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.isSmallScreen) ? _c('th', {
    staticClass: "text-center sticky-header",
    staticStyle: {
      "width": "15%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('LocationPostalCode')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SFO018) + "\n                  "), (_vm.showSortArrow('LocationPostalCode', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('LocationPostalCode', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.isSmallScreen) ? _c('th', {
    staticClass: "text-center sticky-header",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('LocationCity')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SFO018) + "\n                  "), (_vm.showSortArrow('LocationCity', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('LocationCity', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.isSmallScreen) ? _c('th', {
    staticClass: "text-center sticky-header",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('LocationPostalCode')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SFO022) + "\n                  "), (_vm.showSortArrow('LocationPostalCode', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('LocationPostalCode', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.isSmallScreen) ? _c('th', {
    staticClass: "text-center sticky-header",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('LocationCountry')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SFO023) + "\n                  "), (_vm.showSortArrow('LocationCountry', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('LocationCountry', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.isSmallScreen) ? _c('th', {
    staticClass: "text-center sticky-header",
    staticStyle: {
      "width": "8%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('ScenarioName')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SFO020) + "\n                  "), (_vm.showSortArrow('ScenarioName', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('ScenarioName', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header",
    staticStyle: {
      "width": "8%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('SurveyInstanceInfo')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SFO021) + "\n                  "), (_vm.showSortArrow('SurveyInstanceInfo', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SurveyInstanceInfo', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), (!_vm.isSmallScreen) ? _c('th', {
    staticClass: "text-center sticky-header",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('LocationAdditionalInfo')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SFO019) + "\n                  "), (_vm.showSortArrow('LocationAdditionalInfo', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('LocationAdditionalInfo', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header",
    style: (("width:" + (_vm.isSmallScreen ? '15' : '7') + "%;"))
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('SurveyInstanceSince')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SFO009) + "\n                  "), (_vm.showSortArrow('SurveyInstanceSince', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SurveyInstanceSince', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header",
    style: (("width:" + (_vm.isSmallScreen ? '15' : '7') + "%;"))
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('SurveyInstanceUntil')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SFO010) + "\n                  "), (_vm.showSortArrow('SurveyInstanceUntil', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SurveyInstanceUntil', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header",
    style: (("width:" + (_vm.isSmallScreen ? '15' : '8') + "%;"))
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('TotalPayment')
      }
    }
  }, [(!_vm.isSmallScreen) ? [_vm._v(_vm._s(_vm.lang.SFO013))] : _c('i', {
    staticClass: "material-icons md-20"
  }, [_vm._v("euro_symbol")]), _vm._v(" "), (_vm.showSortArrow('TotalPayment', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('TotalPayment', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()], 2)])]), _vm._v(" "), (_vm.globals.isLargeScreen()) ? _c('tr', {
    staticClass: "table-filters"
  }, [_c('th', {
    staticClass: "nopadding sticky-filter",
    staticStyle: {
      "width": "8%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceId),
      expression: "filterStrings.SurveyInstanceId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SFO003
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getFreeOffers()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter",
    staticStyle: {
      "width": "13%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyTitle),
      expression: "filterStrings.SurveyTitle"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SFO003
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyTitle)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getFreeOffers()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyTitle", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter",
    staticStyle: {
      "width": "14%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceDescription),
      expression: "filterStrings.SurveyInstanceDescription"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SFO003
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceDescription)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getFreeOffers()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceDescription", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationCity),
      expression: "filterStrings.LocationCity"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SFO003
    },
    domProps: {
      "value": (_vm.filterStrings.LocationCity)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getFreeOffers()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationCity", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationPostalCode),
      expression: "filterStrings.LocationPostalCode"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SFO003
    },
    domProps: {
      "value": (_vm.filterStrings.LocationPostalCode)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getFreeOffers()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationPostalCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter",
    staticStyle: {
      "width": "5%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationCountry),
      expression: "filterStrings.LocationCountry"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SFO003
    },
    domProps: {
      "value": (_vm.filterStrings.LocationCountry)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getFreeOffers()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationCountry", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter",
    staticStyle: {
      "width": "8%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ScenarioName),
      expression: "filterStrings.ScenarioName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SFO003
    },
    domProps: {
      "value": (_vm.filterStrings.ScenarioName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getFreeOffers()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ScenarioName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter",
    staticStyle: {
      "width": "8%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceInfo),
      expression: "filterStrings.SurveyInstanceInfo"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SFO003
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceInfo)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getFreeOffers()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceInfo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationAdditionalInfo),
      expression: "filterStrings.LocationAdditionalInfo"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SFO003
    },
    domProps: {
      "value": (_vm.filterStrings.LocationAdditionalInfo)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getFreeOffers()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationAdditionalInfo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter",
    staticStyle: {
      "width": "7%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceSince),
      expression: "filterStrings.SurveyInstanceSince"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SFO003
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceSince)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getFreeOffers()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceSince", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter",
    staticStyle: {
      "width": "7%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceUntil),
      expression: "filterStrings.SurveyInstanceUntil"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SFO003
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceUntil)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getFreeOffers()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceUntil", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter",
    staticStyle: {
      "width": "8%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.TotalPayment),
      expression: "filterStrings.TotalPayment"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SFO003
    },
    domProps: {
      "value": (_vm.filterStrings.TotalPayment)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getFreeOffers()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "TotalPayment", $event.target.value)
      }
    }
  })])])]) : _vm._e()]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar"
  }, _vm._l((_vm.freeOffers), function(freeOffer) {
    return _c('tr', {
      key: freeOffer.SurveyInstanceGuid,
      staticClass: "text-center",
      class: {
        info: freeOffer.SurveyInstanceGuid === _vm.selectedFreeOfferGuid,
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          _vm.selectedFreeOfferGuid = freeOffer.SurveyInstanceGuid
        },
        "dblclick": function($event) {
          return _vm.openFreeOfferDetailsDialog()
        }
      }
    }, [(!_vm.isSmallScreen) ? _c('td', {
      staticStyle: {
        "width": "8%"
      }
    }, [_vm._v("\n                " + _vm._s(freeOffer.SurveyInstanceId) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('td', {
      style: (("width:" + (_vm.isSmallScreen ? '25' : '13') + "%;"))
    }, [_vm._v("\n                " + _vm._s(freeOffer.SurveyTitle) + "\n                "), (freeOffer.LocationFree) ? _c('i', {
      staticClass: "material-icons",
      class: {
        'md-18': !_vm.isSmallScreen, 'md-24': _vm.isSmallScreen
      }
    }, [_vm._v("location_off")]) : _vm._e()]), _vm._v(" "), (!_vm.isSmallScreen) ? _c('td', {
      staticStyle: {
        "width": "16%"
      },
      attrs: {
        "id": "freeOfferDescription"
      }
    }, [_vm._v("\n                " + _vm._s(_vm.globals.truncateString(
      _vm.globals.getMarkupText(
        freeOffer.SurveyInstanceDescription
      ),
      50
    )) + "\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.isSmallScreen) ? _c('td', {
      staticStyle: {
        "width": "7%"
      }
    }, [_vm._v("\n                " + _vm._s(freeOffer.LocationCity) + "\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.isSmallScreen) ? _c('td', {
      staticStyle: {
        "width": "7%"
      }
    }, [_vm._v("\n                " + _vm._s(freeOffer.LocationPostalCode) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.isSmallScreen) ? _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v("\n                " + _vm._s(freeOffer.LocationPostalCode) + "\n                " + _vm._s(freeOffer.LocationCity) + "\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.isSmallScreen) ? _c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_vm._v("\n                " + _vm._s(freeOffer.LocationCountry) + "\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.isSmallScreen) ? _c('td', {
      staticStyle: {
        "width": "8%"
      }
    }, [_vm._v("\n                " + _vm._s(freeOffer.ScenarioName) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "8%"
      }
    }, [_vm._v("\n                " + _vm._s(freeOffer.SurveyInstanceInfo) + "\n              ")]), _vm._v(" "), (!_vm.isSmallScreen) ? _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v("\n                " + _vm._s(_vm.globals.truncateString(
      _vm.globals.getMarkupText(freeOffer.LocationAdditionalInfo),
      50
    )) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('td', {
      style: (("width:" + (_vm.isSmallScreen ? '15' : '7') + "%;"))
    }, [_vm._v("\n                " + _vm._s(freeOffer.SurveyInstanceSince) + "\n              ")]), _vm._v(" "), _c('td', {
      style: (("width:" + (_vm.isSmallScreen ? '15' : '7') + "%;"))
    }, [_vm._v("\n                " + _vm._s(freeOffer.SurveyInstanceUntil) + "\n              ")]), _vm._v(" "), _c('td', {
      style: (("width:" + (_vm.isSmallScreen ? '15' : '8') + "%;"))
    }, [_vm._v("\n                " + _vm._s(_vm.globals.getCurrencyString(freeOffer.TotalPayment, "EUR")) + "\n              ")])])
  }), 0)])])])]), _vm._v(" "), _c('FreeOfferDetailsDialog', {
    attrs: {
      "showDialog": _vm.showFreeOfferDetailsDialog,
      "freeOffer": _vm.selectedFreeOffer
    },
    on: {
      "dialogClosed": _vm.closeFreeOfferDetailsDialog,
      "freeOfferAccepted": _vm.onFreeOfferAccepted
    }
  }), _vm._v(" "), _c('FreeOfferFilterChecksDialog', {
    attrs: {
      "showDialog": _vm.showFreeOfferFilterChecksDialog
    },
    on: {
      "dialogClosed": _vm.closeFreeOfferFilterChecksDialog,
      "filterChecks": _vm.onFilterChecks
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])])
}]}

/***/ }),

/***/ 422:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "step-billing-overview-notification"
  }, [_vm._v(_vm._s(_vm.lang.SET401))]), _vm._v(" "), _c('div', {
    staticClass: "step-billing-overview-title"
  }, [_vm._v(_vm._s(_vm.lang.SET400))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 billing-address-block"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.SET402))]), _vm._v(" "), _c('br'), _vm._v("\n      " + _vm._s(_vm.shopperBillingAddress.Name) + "\n      "), _c('br'), _vm._v("\n      " + _vm._s(_vm.shopperBillingAddress.Street) + "\n      "), _c('br'), _vm._v("\n      " + _vm._s(_vm.shopperBillingAddress.PLZCity) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 bank-details-block"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.SET403))]), _vm._v(" "), _c('br'), _vm._v("\n      " + _vm._s(_vm.lang.SET407) + ":\n      " + _vm._s(_vm.bankDetailsData.BankName) + "\n      "), _c('br'), _vm._v("\n      " + _vm._s(_vm.lang.SET409) + ":\n      " + _vm._s(_vm.bankDetailsData.SwiftCode) + "\n      "), _c('br'), _vm._v("\n      " + _vm._s(_vm.lang.SET408) + ":\n      " + _vm._s(_vm.bankDetailsData.AccountNumber) + "\n      "), _c('br'), _vm._v("\n      " + _vm._s(_vm.lang.SET410) + ":\n      " + _vm._s(_vm.bankDetailsData.AccountName) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.lang.SET404))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v(_vm._s(_vm.lang.SET405))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.lang.SET406))]), _vm._v(" "), (!_vm.vatNotMandatory) ? _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.SET412) + " (" + _vm._s(_vm.shopperCart.CartItems[0].VatRate * 100) + "%)\n            ")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.lang.SET413))])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.shopperCart.CartItems), function(cartItem) {
    return _c('tr', {
      key: cartItem.CartItemGuid
    }, [_c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(cartItem.SurveyInstanceId))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "40%"
      }
    }, [_vm._v(_vm._s(cartItem.SurveyTitle))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v("\n              " + _vm._s(_vm.globals.getCurrencyString(cartItem.Total, "EUR")) + "\n            ")]), _vm._v(" "), (!_vm.vatNotMandatory) ? _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v("\n              " + _vm._s(_vm.globals.getCurrencyString(cartItem.VatValue, "EUR")) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v("\n              " + _vm._s(_vm.globals.getCurrencyString(cartItem.PurchaseMoney, "EUR")) + "\n            ")])])
  }), _vm._v(" "), _c('tr', {
    staticClass: "total-background"
  }, [_c('td', {
    staticClass: "align-total-text format-total-text",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.SET411) + "\n            ")]), _vm._v(" "), _c('td', {
    staticClass: "format-total-text"
  }, [_vm._v("\n              " + _vm._s(_vm.globals.getCurrencyString(_vm.shopperCart.Total, "EUR")) + "\n            ")]), _vm._v(" "), (!_vm.vatNotMandatory) ? _c('td', {
    staticClass: "format-total-text"
  }, [_vm._v("\n              " + _vm._s(_vm.globals.getCurrencyString(_vm.shopperCart.TotalVatValue, "EUR")) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "format-total-text"
  }, [_vm._v("\n              " + _vm._s(_vm.globals.getCurrencyString(
    _vm.shopperCart.TotalPurchaseMoney,
    "EUR"
  )) + "\n            ")])]), _vm._v(" "), _c('tr', {
    staticClass: "payout-background"
  }, [_c('td', {
    staticClass: "align-total-text format-total-text",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.SET414) + "\n            ")]), _vm._v(" "), _c('td', {
    staticClass: "format-total-text",
    attrs: {
      "colspan": _vm.vatNotMandatory ? 2 : 3
    }
  }, [_vm._v("\n              " + _vm._s(_vm.globals.getCurrencyString(
    _vm.shopperCart.TotalWithVatAndPurchaseMoney,
    "EUR"
  )) + "\n            ")])])], 2)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 423:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.globals.currentUserRole > 0) ? _c('div', {
    attrs: {
      "id": "pageNotFoundComponent"
    }
  }, [_c('h1', [_vm._v("😕")]), _vm._v(" "), _c('h2', [_vm._v("Oh no! How did you get here?")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/surveyview"
    }
  }, [_vm._v("Click here to get back on track")])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 159,
	"./af.js": 159,
	"./ar": 166,
	"./ar-dz": 160,
	"./ar-dz.js": 160,
	"./ar-kw": 161,
	"./ar-kw.js": 161,
	"./ar-ly": 162,
	"./ar-ly.js": 162,
	"./ar-ma": 163,
	"./ar-ma.js": 163,
	"./ar-sa": 164,
	"./ar-sa.js": 164,
	"./ar-tn": 165,
	"./ar-tn.js": 165,
	"./ar.js": 166,
	"./az": 167,
	"./az.js": 167,
	"./be": 168,
	"./be.js": 168,
	"./bg": 169,
	"./bg.js": 169,
	"./bm": 170,
	"./bm.js": 170,
	"./bn": 171,
	"./bn.js": 171,
	"./bo": 172,
	"./bo.js": 172,
	"./br": 173,
	"./br.js": 173,
	"./bs": 174,
	"./bs.js": 174,
	"./ca": 175,
	"./ca.js": 175,
	"./cs": 176,
	"./cs.js": 176,
	"./cv": 177,
	"./cv.js": 177,
	"./cy": 178,
	"./cy.js": 178,
	"./da": 179,
	"./da.js": 179,
	"./de": 182,
	"./de-at": 180,
	"./de-at.js": 180,
	"./de-ch": 181,
	"./de-ch.js": 181,
	"./de.js": 182,
	"./dv": 183,
	"./dv.js": 183,
	"./el": 184,
	"./el.js": 184,
	"./en-SG": 185,
	"./en-SG.js": 185,
	"./en-au": 186,
	"./en-au.js": 186,
	"./en-ca": 187,
	"./en-ca.js": 187,
	"./en-gb": 188,
	"./en-gb.js": 188,
	"./en-ie": 189,
	"./en-ie.js": 189,
	"./en-il": 190,
	"./en-il.js": 190,
	"./en-nz": 191,
	"./en-nz.js": 191,
	"./eo": 192,
	"./eo.js": 192,
	"./es": 195,
	"./es-do": 193,
	"./es-do.js": 193,
	"./es-us": 194,
	"./es-us.js": 194,
	"./es.js": 195,
	"./et": 196,
	"./et.js": 196,
	"./eu": 197,
	"./eu.js": 197,
	"./fa": 198,
	"./fa.js": 198,
	"./fi": 199,
	"./fi.js": 199,
	"./fo": 200,
	"./fo.js": 200,
	"./fr": 203,
	"./fr-ca": 201,
	"./fr-ca.js": 201,
	"./fr-ch": 202,
	"./fr-ch.js": 202,
	"./fr.js": 203,
	"./fy": 204,
	"./fy.js": 204,
	"./ga": 205,
	"./ga.js": 205,
	"./gd": 206,
	"./gd.js": 206,
	"./gl": 207,
	"./gl.js": 207,
	"./gom-latn": 208,
	"./gom-latn.js": 208,
	"./gu": 209,
	"./gu.js": 209,
	"./he": 210,
	"./he.js": 210,
	"./hi": 211,
	"./hi.js": 211,
	"./hr": 212,
	"./hr.js": 212,
	"./hu": 213,
	"./hu.js": 213,
	"./hy-am": 214,
	"./hy-am.js": 214,
	"./id": 215,
	"./id.js": 215,
	"./is": 216,
	"./is.js": 216,
	"./it": 218,
	"./it-ch": 217,
	"./it-ch.js": 217,
	"./it.js": 218,
	"./ja": 219,
	"./ja.js": 219,
	"./jv": 220,
	"./jv.js": 220,
	"./ka": 221,
	"./ka.js": 221,
	"./kk": 222,
	"./kk.js": 222,
	"./km": 223,
	"./km.js": 223,
	"./kn": 224,
	"./kn.js": 224,
	"./ko": 225,
	"./ko.js": 225,
	"./ku": 226,
	"./ku.js": 226,
	"./ky": 227,
	"./ky.js": 227,
	"./lb": 228,
	"./lb.js": 228,
	"./lo": 229,
	"./lo.js": 229,
	"./lt": 230,
	"./lt.js": 230,
	"./lv": 231,
	"./lv.js": 231,
	"./me": 232,
	"./me.js": 232,
	"./mi": 233,
	"./mi.js": 233,
	"./mk": 234,
	"./mk.js": 234,
	"./ml": 235,
	"./ml.js": 235,
	"./mn": 236,
	"./mn.js": 236,
	"./mr": 237,
	"./mr.js": 237,
	"./ms": 239,
	"./ms-my": 238,
	"./ms-my.js": 238,
	"./ms.js": 239,
	"./mt": 240,
	"./mt.js": 240,
	"./my": 241,
	"./my.js": 241,
	"./nb": 242,
	"./nb.js": 242,
	"./ne": 243,
	"./ne.js": 243,
	"./nl": 245,
	"./nl-be": 244,
	"./nl-be.js": 244,
	"./nl.js": 245,
	"./nn": 246,
	"./nn.js": 246,
	"./pa-in": 247,
	"./pa-in.js": 247,
	"./pl": 248,
	"./pl.js": 248,
	"./pt": 250,
	"./pt-br": 249,
	"./pt-br.js": 249,
	"./pt.js": 250,
	"./ro": 251,
	"./ro.js": 251,
	"./ru": 252,
	"./ru.js": 252,
	"./sd": 253,
	"./sd.js": 253,
	"./se": 254,
	"./se.js": 254,
	"./si": 255,
	"./si.js": 255,
	"./sk": 256,
	"./sk.js": 256,
	"./sl": 257,
	"./sl.js": 257,
	"./sq": 258,
	"./sq.js": 258,
	"./sr": 260,
	"./sr-cyrl": 259,
	"./sr-cyrl.js": 259,
	"./sr.js": 260,
	"./ss": 261,
	"./ss.js": 261,
	"./sv": 262,
	"./sv.js": 262,
	"./sw": 263,
	"./sw.js": 263,
	"./ta": 264,
	"./ta.js": 264,
	"./te": 265,
	"./te.js": 265,
	"./tet": 266,
	"./tet.js": 266,
	"./tg": 267,
	"./tg.js": 267,
	"./th": 268,
	"./th.js": 268,
	"./tl-ph": 269,
	"./tl-ph.js": 269,
	"./tlh": 270,
	"./tlh.js": 270,
	"./tr": 271,
	"./tr.js": 271,
	"./tzl": 272,
	"./tzl.js": 272,
	"./tzm": 274,
	"./tzm-latn": 273,
	"./tzm-latn.js": 273,
	"./tzm.js": 274,
	"./ug-cn": 275,
	"./ug-cn.js": 275,
	"./uk": 276,
	"./uk.js": 276,
	"./ur": 277,
	"./ur.js": 277,
	"./uz": 279,
	"./uz-latn": 278,
	"./uz-latn.js": 278,
	"./uz.js": 279,
	"./vi": 280,
	"./vi.js": 280,
	"./x-pseudo": 281,
	"./x-pseudo.js": 281,
	"./yo": 282,
	"./yo.js": 282,
	"./zh-cn": 283,
	"./zh-cn.js": 283,
	"./zh-hk": 284,
	"./zh-hk.js": 284,
	"./zh-tw": 285,
	"./zh-tw.js": 285
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 541;

/***/ }),

/***/ 550:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_flatpickr_dist_themes_material_blue_css__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_flatpickr_dist_themes_material_blue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_flatpickr_dist_themes_material_blue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_design_icons_iconfont_material_icons_css__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_design_icons_iconfont_material_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_design_icons_iconfont_material_icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_typeface_roboto_index_css__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_typeface_roboto_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_typeface_roboto_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_snackbarjs__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_snackbarjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_snackbarjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_select2__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_select2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_select2_dist_css_select2_css__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_select2_dist_css_select2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_select2_dist_css_select2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_long_click__ = __webpack_require__(1085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_long_click___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_long_click__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_smoothscroll_polyfill__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_smoothscroll_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_smoothscroll_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__App__ = __webpack_require__(1047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__router__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__globals__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__feature__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_app_service__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_currency_input__ = __webpack_require__(1046);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.














var longClickInstance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vue_long_click__["longClickDirective"])({ delay: 800 });
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive("longclick", longClickInstance);


__WEBPACK_IMPORTED_MODULE_10_smoothscroll_polyfill___default.a.polyfill();






// Import JS services

Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype, "$appService", {
  value: __WEBPACK_IMPORTED_MODULE_15__services_app_service__["a" /* default */]
});


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_vue_currency_input__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.globals = __WEBPACK_IMPORTED_MODULE_13__globals__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.feature = __WEBPACK_IMPORTED_MODULE_14__feature__["a" /* default */];

// Send access token to service worker if requested.
var authChannel = new BroadcastChannel("authChannel");

authChannel.onmessage = function (event) {
  if (event.data === "getAuthTokenHeader") {
    authChannel.postMessage({
      authTokenHeader: "Bearer " + __WEBPACK_IMPORTED_MODULE_15__services_app_service__["a" /* default */].getAccessToken()
    });
  }
};

__WEBPACK_IMPORTED_MODULE_12__router__["a" /* default */].beforeEach(function (to, from, next) {
  if (to.name === "DirectToLoginCallback") {
    __WEBPACK_IMPORTED_MODULE_15__services_app_service__["a" /* default */].redirectAfterLoginCallback();
    return;
  }

  if (to.name === "DirectToLogoutCallback") {
    __WEBPACK_IMPORTED_MODULE_15__services_app_service__["a" /* default */].redirectAfterLogoutCallback();
    return;
  }

  if (to.name === "SurveyCodeLogin" || to.name === "SurveyCodeDirectLogin") {
    __WEBPACK_IMPORTED_MODULE_15__services_app_service__["a" /* default */].removeTokensFromStorage();
    __WEBPACK_IMPORTED_MODULE_15__services_app_service__["a" /* default */].directToLogin(true, to.params.sc);
    return;
  }

  if (!__WEBPACK_IMPORTED_MODULE_15__services_app_service__["a" /* default */].isUserAuthenticated()) {
    __WEBPACK_IMPORTED_MODULE_15__services_app_service__["a" /* default */].renewToken();
  }

  if (__WEBPACK_IMPORTED_MODULE_13__globals__["a" /* default */].isSurveyCodeUser && (to.name === "Settlement" || to.name === "FreeOffers")) {
    next("/surveyview");
    return;
  }

  next();
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: "#app",
  router: __WEBPACK_IMPORTED_MODULE_12__router__["a" /* default */],
  template: "<App/>",
  components: {
    App: __WEBPACK_IMPORTED_MODULE_11__App___default.a
  }
});

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(383)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(303),
  /* template */
  __webpack_require__(417),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 571:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_material_design_dist_css_bootstrap_material_design_min_css__ = __webpack_require__(998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_material_design_dist_css_bootstrap_material_design_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap_material_design_dist_css_bootstrap_material_design_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_material_design_dist_css_ripples_min_css__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_material_design_dist_css_ripples_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_material_design_dist_css_ripples_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_material_design_dist_js_material_min_js__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_material_design_dist_js_material_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bootstrap_material_design_dist_js_material_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_material_design_dist_js_ripples_min_js__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_material_design_dist_js_ripples_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_bootstrap_material_design_dist_js_ripples_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_flatpickr__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_flatpickr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_flatpickr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_flatpickr_dist_l10n__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_flatpickr_dist_l10n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_flatpickr_dist_l10n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Tools_gmaps__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_css_vars_ponyfill__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__package_json__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Tools_Dialogs_ConfirmationDialog__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Tools_Dialogs_ConfirmationDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Tools_Dialogs_ConfirmationDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Tools_Dialogs_NotificationDialog__ = __webpack_require__(1056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Tools_Dialogs_NotificationDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Tools_Dialogs_NotificationDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Tools_Dialogs_ErrorDialog__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Tools_Dialogs_ErrorDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_Tools_Dialogs_ErrorDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_ShopperProfile_ShopperProfile__ = __webpack_require__(1054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_ShopperProfile_ShopperProfile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_ShopperProfile_ShopperProfile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Tools_Dialogs_ChangePasswordDialog__ = __webpack_require__(1055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Tools_Dialogs_ChangePasswordDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Tools_Dialogs_ChangePasswordDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Tools_Dialogs_UploadProgressModal__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Tools_Dialogs_UploadProgressModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_Tools_Dialogs_UploadProgressModal__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Import CSS





// Import JavaScript




// Import flatpickr



// Google Maps






// import dialogs







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app",
  components: {
    ConfirmationDialog: __WEBPACK_IMPORTED_MODULE_14__components_Tools_Dialogs_ConfirmationDialog___default.a,
    NotificationDialog: __WEBPACK_IMPORTED_MODULE_15__components_Tools_Dialogs_NotificationDialog___default.a,
    ErrorDialog: __WEBPACK_IMPORTED_MODULE_16__components_Tools_Dialogs_ErrorDialog___default.a,
    ShopperProfile: __WEBPACK_IMPORTED_MODULE_17__components_ShopperProfile_ShopperProfile___default.a,
    ChangePasswordDialog: __WEBPACK_IMPORTED_MODULE_18__components_Tools_Dialogs_ChangePasswordDialog___default.a,
    UploadProgressModal: __WEBPACK_IMPORTED_MODULE_19__components_Tools_Dialogs_UploadProgressModal___default.a
  },
  beforeCreate: function beforeCreate() {
    $.material.init();

    if (this.feature.isAudiTarget) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_css_vars_ponyfill__["a" /* default */])({
        variables: {
          "color-primary": "rgb(245, 5, 55)",
          "color-primary-rgb": "245, 5, 55",
          "color-primary-input": "rgb(51, 51, 51)",
          "color-primary-input-rgb": "51, 51, 51",
          "color-primary-input-hover": "rgb(76, 76, 76)",
          "color-primary-input-hover-rgb": "76, 76, 76",
          "active-alpha": "0.2"
        }
      });
      $("head > title").text("Audi Loop");
      $("head > link[type='image/x-icon']").attr("href", "/static/favicon-audi.webp");
    } else if (this.feature.isDBTarget) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_css_vars_ponyfill__["a" /* default */])({
        variables: {
          "color-primary": "rgb(236, 0, 22)",
          "color-primary-rgb": "236, 0, 22",
          "color-primary-input": "rgb(79, 75, 65)",
          "color-primary-input-rgb": "79, 75, 65",
          "color-primary-input-hover": "rgb(116, 112, 103)",
          "color-primary-input-hover-rgb": "116, 112, 103",
          "active-alpha": "0.2"
        }
      });
      $("head > title").text("DB Loop");
      $("head > link[type='image/x-icon']").attr("href", "/static/DB_loop_logo.svg");
    } else if (this.feature.isPorscheTarget) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_css_vars_ponyfill__["a" /* default */])({
        variables: {
          "color-primary": "rgb(213, 0, 28)",
          "color-primary-rgb": "213, 0, 28",
          "color-primary-input": "rgb(79, 75, 65)",
          "color-primary-input-rgb": "79, 75, 65",
          "color-primary-input-hover": "rgb(116, 112, 103)",
          "color-primary-input-hover-rgb": "116, 112, 103",
          "active-alpha": "0.2"
        }
      });
      $("head > title").text("Porsche Loop");
      $("head > link[type='image/x-icon']").attr("href", "/static/Porsche_logo_favico.webp");
    } else __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_css_vars_ponyfill__["a" /* default */])();

    // Ensures that select2 and flatpickr can get input focus inside modal
    $.fn.modal.Constructor.prototype.enforceFocus = function () {};

    // Makes tooltips available for all rendered components
    $(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });

    $(document).on("show.bs.modal", ".modal", function () {
      var zIndex = 1040 + 10 * $(".modal:visible").length;
      $(this).css("z-index", zIndex);
      setTimeout(function () {
        $(".modal-backdrop").not(".modal-stack").css("z-index", zIndex - 1).addClass("modal-stack");
      }, 0);
    });
  },
  created: function created() {
    var _this = this;

    if (location.hash.indexOf("#/surveycode") > -1) return;

    var checkAccessToken = function checkAccessToken() {
      _this.isAccessTokenAvailable = !!_this.$appService.getAccessToken();
      if (!_this.isAccessTokenAvailable) {
        console.warn("No access token available");
      }
    };

    this.globals.$off("accessTokenChanged");
    this.globals.$on("accessTokenChanged", checkAccessToken);
    checkAccessToken();

    $(document).ajaxStart(function () {
      _this.globals.showSpinner();
    }).ajaxStop(function () {
      _this.globals.hideSpinner();
    });

    this.$appService.initializeGlobalAjaxEvents();

    this.globals.$off("openGlobalConfirmationDialog");
    this.globals.$on("openGlobalConfirmationDialog", function (confirmationDialogData) {
      _this.confirmationDialogData = confirmationDialogData;
      _this.openConfirmationDialog();
    });

    this.globals.$off("openGlobalNotificationDialog");
    this.globals.$on("openGlobalNotificationDialog", function (notificationDialogData) {
      _this.notificationDialogData = notificationDialogData;
      _this.openNotificationDialog();
    });

    this.globals.$off("openGlobalErrorDialog");
    this.globals.$on("openGlobalErrorDialog", function (errorDialogData) {
      _this.errorDialogData = errorDialogData;
      _this.openErrorDialog();
    });

    this.initGoogleApi();

    if (this.feature.isAudiTarget) this.mainOpHost = "projects.audi-mysteryshopping.com";else if (this.feature.isDBTarget) this.mainOpHost = "projects.qm-servicestoredb.de";else if (this.feature.isPorscheTarget) this.mainOpHost = "projects.sar-pag.de";
  },
  mounted: function mounted() {
    var _this2 = this;

    if (location.hash.indexOf("#/surveycode") > -1) return;

    // Gets executed right after rendering the component
    var userInfoCallback = function userInfoCallback() {
      _this2.setInitialRoute();
      _this2.nextLanguage = _this2.globals.selectedLanguage;
    };
    this.globals.getCurrentUserInfo(userInfoCallback);

    this.getLanguageList();
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
  },

  computed: {
    userLoginState: function userLoginState() {
      return this.globals.currentUserInfo ? true : false;
    },
    currentRouteHeaderTranslation: function currentRouteHeaderTranslation() {
      switch (this.$route.name) {
        case "SurveyView":
          return this.lang.A0014;
        case "Settlement":
          return this.lang.A0030;
        case "Imprint":
          return this.lang.A0018;
        case "DataProtection":
          return this.lang.A0017;
        case "FreeOffers":
          return this.lang.A0019;
        default:
          return "";
      }
    }
  },
  methods: {
    setInitialRoute: function setInitialRoute() {
      if (this.$route.name) return; // Route is already selected
      this.$router.push("surveyview");
    },


    // Opens the dialog to select a language
    openSelectLanguageDialog: function openSelectLanguageDialog() {
      if (!this.globals.isAccessAllowed("LoopOp_SecurityUsersLocalization_Update") || !this.globals.isAccessAllowed("LoopOp_Language_Read")) {
        this.showErrorMessage("Access denied", false);
        return;
      }

      $("#selectLanguageDialog").modal("show");
    },
    userLogout: function userLogout() {
      this.$appService.logout();
    },
    initGoogleApi: function initGoogleApi() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__components_Tools_gmaps__["a" /* default */])(_this3.globals.googleApiKey);

              case 3:
                _this3.globals.$emit("googleInitDone");
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);

                console.error(_context.t0);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[0, 6]]);
      }))();
    },
    showHelpMessage: function showHelpMessage() {
      //TODO: Localization
      var dialogData = {
        initiator: "appHelpMessage",
        notificationTitle: "Hilfe",
        colorRed: false,
        closeButtonText: "Schließen",
        htmlText: "<ul class=\"help-modal-list\">\n          <li>Bitte laden Sie hier das Handbuch herunter: <a href=\"https://projects.msmloop.com/api/Download/039a9062-0639-492b-9cc9-b044f87d61b0\" target=\"_blank\">Download Handbuch</a></li>\n          <br>\n          <li>Bei Fragen zum Projekt wenden Sie sich bitte an die Mail-Adresse aus dem Briefing bzw. der Auftragsmail</li>\n          <br>\n          <li>Bei Fragen zu Ihrer Abrechnung wenden Sie sich bitte an <a href=\"mailto:abrechnungen@msm-group.com\">abrechnungen@msm-group.com</a></li>\n          <br>\n          <li>Bei allgemeinen Fragen wenden Sie sich bitte an <a href=\"mailto:service@msm-group.com\">service@msm-group.com</a></li>\n          <br>\n          <li>Wenn Sie nicht mehr als Testkunde f\xFCr uns arbeiten wollen, wenden Sie sich bitte an <a href=\"mailto:abmelden@msm-group.com\">abmelden@msm-group.com</a></li>\n        </ul>"
      };
      this.globals.$emit("openGlobalNotificationDialog", dialogData);
    },
    showErrorMessage: function showErrorMessage(message, warning) {
      var dialogData = {};
      if (!this.showErrorDialog) {
        dialogData = {
          errorText: message,
          colorOrange: warning
        };
      } else {
        dialogData = {
          errorText: this.errorDialogData.errorText + " <br><br> " + message,
          colorOrange: warning && this.errorDialogData.colorOrange
        };
      }

      this.globals.$emit("openGlobalErrorDialog", dialogData);
    },


    // Closes the language selection dialog
    closeSelectLanguageDialog: function closeSelectLanguageDialog() {
      $("#selectLanguageDialog").modal("hide");
    },


    // Requests a list of available languages from the server
    getLanguageList: function getLanguageList() {
      var _this4 = this;

      $.ajax({
        method: "GET",
        url: "api/Language",
        success: function success(data) {
          // this.languageList = data;
          //TODO: Only show german and english in production
          _this4.languageList = {
            de: data.de,
            en: data.en
          };
          if (["china", "dsinux", "local"].indexOf(_this4.feature.currentTarget) > -1) _this4.languageList.zh = data.zh;
        },
        error: function error() {
          console.error("Language data access failed in getLanguageList()");
          // this.globals.$emit("openGlobalErrorDialog", {errorText: "Language data access failed", colorOrange: false});
        }
      });
    },
    changeSelectedLanguage: function changeSelectedLanguage() {
      var _this5 = this;

      if (this.nextLanguage === this.globals.selectedLanguage) return;
      var query = "api/SecurityUsers/Localization?LanguageCode=" + this.nextLanguage.substring(0, 2);

      $.ajax({
        method: "PUT",
        url: query,
        dataType: "text",
        success: function success(data) {
          _this5.globals.selectedLanguage = _this5.nextLanguage;
          _this5.globals.showSuccessSnackbar("Language switched to: " + _this5.globals.selectedLanguage);
        },
        error: function error() {
          console.error("Error on PUT in changeSelectedLanguage()");
          _this5.showErrorMessage("Language update failed", true);
        }
      });
    },
    openConfirmationDialog: function openConfirmationDialog() {
      this.confirmationDialogId = this.confirmationDialogData.initiator + "Confirmation";
      this.showConfirmationDialog = true;
    },
    onYesConfirmation: function onYesConfirmation() {
      this.globals.$emit(this.confirmationDialogData.initiator + "YesConfirmation");
      this.showConfirmationDialog = false;
    },
    onNoConfirmation: function onNoConfirmation() {
      this.globals.$emit(this.confirmationDialogData.initiator + "NoConfirmation");
      this.showConfirmationDialog = false;
    },
    onConfirmationDialogClosed: function onConfirmationDialogClosed() {
      this.globals.$emit(this.confirmationDialogData.initiator + "DialogClosed");
      this.showConfirmationDialog = false;
    },
    openNotificationDialog: function openNotificationDialog() {
      this.notificationDialogId = this.notificationDialogData.initiator + "Notification";
      this.showNotificationDialog = true;
    },
    onCloseNotificationDialog: function onCloseNotificationDialog() {
      this.globals.$emit(this.notificationDialogData.initiator + "CloseDialog");
    },
    onNotificationDialogClosed: function onNotificationDialogClosed() {
      this.globals.$emit(this.notificationDialogData.initiator + "DialogClosed");
      this.showNotificationDialog = false;
    },
    openErrorDialog: function openErrorDialog() {
      this.errorDialogId = this.errorDialogData.initiator + "Error";
      this.showErrorDialog = true;
    },
    onErrorDialogClosed: function onErrorDialogClosed() {
      this.globals.$emit(this.errorDialogData.initiator + "DialogClosed");
      this.showErrorDialog = false;
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  data: function data() {
    // Global data inside the component is stored here
    return {
      appVersion: __WEBPACK_IMPORTED_MODULE_13__package_json__["version"],
      mainOpHost: "projects.msmloop.com",
      isAccessTokenAvailable: false,
      nextLanguage: "en",
      languageList: [], // Stores a list of all available languages
      // updateToken: false,
      lang: {
        // Contains localization strings for the selected language
        A0003: "Log Out",
        A0004: "Edit profile",
        A0006: "Language",
        A0007: "Select a language",
        A0009: "Accept",
        A0014: "Checks",
        A0015: "Survey View",
        A0017: "Data Protection",
        A0018: "Imprint",
        A0019: "Free Offers",
        A0021: "Support",
        A0022: "Help",
        A0030: "Invoice",
        A0031: "Change password"
      },
      confirmationDialogData: {},
      showConfirmationDialog: false,
      notificationDialogData: {},
      showNotificationDialog: false,
      errorDialogData: {},
      showErrorDialog: false,
      confirmationDialogId: "confirmationDialog",
      notificationDialogId: "notificationDialog",
      errorDialogId: "errorDialog",
      showShopperProfileModal: false,
      showChangePasswordDialog: false
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),

/***/ 572:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormComponents_IntegerInput__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormComponents_IntegerInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__FormComponents_IntegerInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FormComponents_TextInput__ = __webpack_require__(1053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FormComponents_TextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__FormComponents_TextInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormComponents_SingleSelectInput__ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormComponents_SingleSelectInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__FormComponents_SingleSelectInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormComponents_MultiSelectInput__ = __webpack_require__(1051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormComponents_MultiSelectInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__FormComponents_MultiSelectInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormComponents_CheckboxInput__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormComponents_CheckboxInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__FormComponents_CheckboxInput__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var uuidv4 = __webpack_require__(106);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CustomePropertiesForm",
  components: {
    IntegerInput: __WEBPACK_IMPORTED_MODULE_2__FormComponents_IntegerInput___default.a,
    TextInput: __WEBPACK_IMPORTED_MODULE_3__FormComponents_TextInput___default.a,
    SingleSelectInput: __WEBPACK_IMPORTED_MODULE_4__FormComponents_SingleSelectInput___default.a,
    MultiSelectInput: __WEBPACK_IMPORTED_MODULE_5__FormComponents_MultiSelectInput___default.a,
    CheckboxInput: __WEBPACK_IMPORTED_MODULE_6__FormComponents_CheckboxInput___default.a
  },
  data: function data() {
    return {
      propertiesFormSchema: [],
      guidRegex: RegExp(/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i)
    };
  },

  methods: {
    updateShopperValues: function updateShopperValues(property, valueGroup, value) {
      var valueObject = void 0;
      if (!valueGroup) valueObject = property.Values && property.Values[0];else {
        valueObject = _.find(valueGroup.Values, function (v) {
          return v.ShopperPropertyGuid === property.Guid;
        });
      }
      if (!valueObject) {
        valueObject = {
          ShopperPropertyGuid: property.Guid,
          ShopperValues: []
        };
        if (valueGroup) {
          if (!valueGroup.Values) valueGroup.Values = [];
          valueGroup.Values.push(valueObject);
        } else {
          if (!property.Values) property.Values = [];
          property.Values.push(valueObject);
        }
      }
      var newShopperValues = [{}];

      // Write current value to ShopperValues
      switch (property.PropertyType) {
        case "Text":
        case "Integer":
          newShopperValues[0].TextValue = value;
          break;
        case "Checkbox":
          if (typeof value === "boolean") newShopperValues[0].BitValue = value;
          break;
        case "SingleSelect":
          if (this.guidRegex.test(value)) newShopperValues[0].ListValueGuid = value;else newShopperValues[0].ListCustomValue = value;
          break;
        case "MultiSelect":
          for (var i = 0; i < value.length; i++) {
            if (!newShopperValues[i]) newShopperValues[i] = {};
            if (this.guidRegex.test(value[i])) newShopperValues[i].ListValueGuid = value[i];else newShopperValues[i].ListCustomValue = value[i];
          }
          break;
      }

      // Restore old ValueGuids
      for (var _i = 0; _i < valueObject.ShopperValues.length; _i++) {
        if (valueObject.ShopperValues[_i].ValueGuid && newShopperValues[_i]) newShopperValues[_i].ValueGuid = valueObject.ShopperValues[_i].ValueGuid;
      }

      valueObject.ShopperValues = newShopperValues;
      this.$forceUpdate();
    },
    getShopperValues: function getShopperValues(property, valueGroup) {
      var valueObject = void 0;
      if (!valueGroup) valueObject = property.Values && property.Values[0];else {
        valueObject = _.find(valueGroup.Values, function (v) {
          return v.ShopperPropertyGuid === property.Guid;
        });
      }
      var sv = valueObject && valueObject.ShopperValues;

      switch (property.PropertyType) {
        case "Text":
        case "Integer":
          if (!sv || !sv[0] || !sv[0].TextValue) return "";
          return sv[0].TextValue;
        case "Checkbox":
          return sv && sv[0] && sv[0].BitValue;
        case "SingleSelect":
          if (!sv || !sv[0]) return "";
          return sv[0].ListValueGuid || sv[0].ListCustomValue || "";
        case "MultiSelect":
          if (!sv || !sv[0]) return [];
          var result = [];
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(sv), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var el = _step.value;

              if (el.ListValueGuid) result.push(el.ListValueGuid);
              if (el.ListCustomValue) result.push(el.ListCustomValue);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          return result;
      }
    },
    addDynamicGroup: function addDynamicGroup(dynamicGroup) {
      if (!dynamicGroup.ValueGroups) dynamicGroup.ValueGroups = [];
      var newValueGroupsEntry = {
        ValueGroupGuid: uuidv4(),
        Values: []
      };

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(dynamicGroup.ChildProperties), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var prop = _step2.value;

          newValueGroupsEntry.Values.push({
            ShopperPropertyGuid: prop.Guid,
            ShopperValues: []
          });
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      dynamicGroup.ValueGroups.push(newValueGroupsEntry);
      this.$forceUpdate();
    },
    removeDynamicGroup: function removeDynamicGroup(groupObj, guid) {
      _.remove(groupObj.ValueGroups, function (vg) {
        return vg.ValueGroupGuid === guid;
      });
      this.$forceUpdate();
    },
    getPropertyStoreObject: function getPropertyStoreObject() {
      var result = {
        Properties: []
      };
      this.propertiesFormSchema.forEach(function (topic) {
        if (topic.ChildProperties) topic.ChildProperties.forEach(function (secondLevelProp) {
          if (secondLevelProp.ValueGroups) result.Properties.push({
            ValueGroups: secondLevelProp.ValueGroups
          });else if (secondLevelProp.Values) result.Properties.push({ Values: secondLevelProp.Values });
        });
      });
      return result;
    },
    getShopperProperties: function getShopperProperties(_success, _error) {
      var _this = this;

      this.propertiesFormSchema = [];
      var queryString = "shopper-api/ShopperProperty";

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this.propertiesFormSchema = !_.isEmpty(data) ? data.Properties : [];
          _success();
        },
        error: function error() {
          console.error("Error on GET in getShopperProperties()");
          _error();
        }
      });
    },
    saveShopperProperties: function saveShopperProperties(successCallback, errorCallback) {
      var queryString = "shopper-api/ShopperProperty";
      var payload = this.getPropertyStoreObject();

      $.ajax({
        method: "PUT",
        url: queryString,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          successCallback();
        },
        error: function error() {
          console.error("Error on PUT in saveShopperProperties()");
          errorCallback();
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),

/***/ 573:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CheckboxInput",
  props: {
    Title: String,
    Guid: String,
    Recommended: { type: Boolean, default: false },
    value: { type: Boolean, default: undefined }
  },
  methods: {
    updateValue: function updateValue() {
      var result = void 0;
      if (this.value === true) result = false;else if (this.value === false) result = undefined;else result = true;
      this.$emit("input", result);
    }
  }
});

/***/ }),

/***/ 574:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "IntegerInput",
  props: {
    Title: String,
    Guid: String,
    Recommended: { type: Boolean, default: false },
    value: { type: String, default: "" }
  },
  methods: {
    updateValue: function updateValue(event) {
      this.$emit("input", event.target.value);
    }
  }
});

/***/ }),

/***/ 575:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_Select2__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Tools_Select2__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "MultiSelectInput",
  components: { Select2: __WEBPACK_IMPORTED_MODULE_0__Tools_Select2___default.a },
  props: {
    Title: String,
    Guid: String,
    ListValues: { type: Array, default: function _default() {
        return [];
      } },
    Recommended: { type: Boolean, default: false },
    AllowCustomValues: { type: Boolean, default: false },
    value: { type: Array, default: function _default() {
        return [];
      } }
  },
  data: function data() {
    return {
      scrollPositionOk: false
    };
  },

  methods: {
    updateValue: function updateValue(newValue) {
      this.$emit("input", newValue);
    },
    selectClosed: function selectClosed() {
      $("#scrollOverflowBlock").hide("slow");
      this.scrollPositionOk = false;
    },
    scrollIntoViewMobile: function scrollIntoViewMobile(e) {
      if (!this.globals.isMobileBrowser) return;
      if (this.scrollPositionOk) return;else e.preventDefault();

      var currentOffsetTop = $(e.target.parentNode.parentNode).offset().top;
      if (currentOffsetTop < 100) {
        // Select already at top of the screen
        this.scrollPositionOk = true;
        $(e.target).select2("open");
        return;
      }

      var modal = $(e.target).closest(".modal");
      if (modal[0].scrollHeight - modal.scrollTop() - modal.outerHeight() < 1) {
        // reached lowest scroll position
        if (!this.globals.isSafariBrowser && $("#scrollOverflowBlock").is(":hidden")) {
          $("#scrollOverflowBlock").css("display", "block");
          e.target.parentNode.parentNode.scrollIntoView();
        }
        this.scrollPositionOk = true;
        $(e.target).select2("open");
        return;
      }

      e.target.parentNode.parentNode.scrollIntoView({ behavior: "smooth" });
      setTimeout(function () {
        $(e.target).select2("open");
      }, 500);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),

/***/ 576:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_Select2__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Tools_Select2__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SingleSelectInput",
  components: { Select2: __WEBPACK_IMPORTED_MODULE_0__Tools_Select2___default.a },
  props: {
    Title: String,
    Guid: String,
    ListValues: { type: Array, default: function _default() {
        return [];
      } },
    Recommended: { type: Boolean, default: false },
    AllowCustomValues: { type: Boolean, default: false },
    value: { type: String, default: "" }
  },
  data: function data() {
    return {
      scrollPositionOk: false
    };
  },

  methods: {
    updateValue: function updateValue(newValue) {
      this.$emit("input", newValue);
    },
    selectClosed: function selectClosed() {
      $("#scrollOverflowBlock").hide("slow");
      this.scrollPositionOk = false;
    },
    scrollIntoViewMobile: function scrollIntoViewMobile(e) {
      if (!this.globals.isMobileBrowser) return;
      if (this.scrollPositionOk) return;else e.preventDefault();

      var currentOffsetTop = $(e.target.parentNode.parentNode).offset().top;
      if (currentOffsetTop < 100) {
        // Select already at top of the screen
        this.scrollPositionOk = true;
        $(e.target).select2("open");
        return;
      }

      var modal = $(e.target).closest(".modal");
      if (modal[0].scrollHeight - modal.scrollTop() - modal.outerHeight() < 1) {
        // reached lowest scroll position
        if (!this.globals.isSafariBrowser && $("#scrollOverflowBlock").is(":hidden")) {
          $("#scrollOverflowBlock").css("display", "block");
          e.target.parentNode.parentNode.scrollIntoView();
        }
        this.scrollPositionOk = true;
        $(e.target).select2("open");
        return;
      }

      e.target.parentNode.parentNode.scrollIntoView({ behavior: "smooth" });
      setTimeout(function () {
        $(e.target).select2("open");
      }, 500);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),

/***/ 577:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "TextInput",
  props: {
    Title: String,
    Guid: String,
    Recommended: { type: Boolean, default: false },
    value: { type: String, default: "" },
    index: { type: Number, default: -1 }
  },
  methods: {
    updateValue: function updateValue(event) {
      this.$emit("input", event.target.value);
    }
  }
});

/***/ }),

/***/ 578:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tools_Select2__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Tools_Select2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CustomPropertiesForm__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CustomPropertiesForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CustomPropertiesForm__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var ibantools = __webpack_require__(392);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ShopperProfileModal",
  components: {
    Select2: __WEBPACK_IMPORTED_MODULE_1__Tools_Select2___default.a,
    CustomPropertiesForm: __WEBPACK_IMPORTED_MODULE_2__CustomPropertiesForm___default.a
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
      this.globals.getOccupationalGroupList(function (callbackData) {
        _this.occupationalGroupList = callbackData;
      });
      this.globals.getCountryList();
      this.globals.getRegionsList(function (data) {
        return _this.regions = data;
      });
      this.fpBirthdate = flatpickr("#inputShopperBirthdate", this.globals.flatpickrDateConfig);
    }

    $("#shopperProfileModal").on("hide.bs.modal", function (e) {
      _this.$emit("modalClosed");
    });

    if (this.globals.isMobileBrowser && !this.globals.isSafariBrowser) {
      $('#shopperProfileModal input[type="text"]').on("focus", function () {
        var _this2 = this;

        // Timeout to wait for keyboard
        setTimeout(function () {
          _this2.parentNode.parentNode.scrollIntoView({ behavior: "smooth" });
        }, 500);
      });
    }
  },
  destroyed: function destroyed() {
    if (this.fpBirthdate) this.fpBirthdate.destroy();
  },

  props: ["showDialog"],
  computed: {
    regionsOfSelectedCountry: function regionsOfSelectedCountry() {
      var _this3 = this;

      if (!this.shopperProfileData.CountryCode) return [];
      var resultObj = this.regions.filter(function (country) {
        return country.CountryCode === _this3.shopperProfileData.CountryCode;
      });
      var regions = resultObj[0] && resultObj[0].Regions || [];

      if (this.shopperProfileData.RegionGuid && _.findIndex(regions, function (r) {
        return r.RegionGuid === _this3.shopperProfileData.RegionGuid;
      }) < 0) this.shopperProfileData.RegionGuid = "";

      return regions;
    }
  },
  watch: {
    showDialog: function showDialog(newVal) {
      newVal ? this.openEditShopperDialog() : this.closeEditShopperDialog();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      var _this4 = this;

      this.globals.getLanguageStrings(this);
      this.globals.getCountryList();
      this.globals.getRegionsList(function (data) {
        return _this4.regions = data;
      });
      this.globals.getOccupationalGroupList(function (callbackData) {
        _this4.occupationalGroupList = callbackData;
      });

      if (this.fpBirthdate) this.fpBirthdate.destroy();
      this.$nextTick(function () {
        _this4.fpBirthdate = flatpickr("#inputShopperBirthdate", _this4.globals.flatpickrDateConfig);
      });
    }
  },
  data: function data() {
    return {
      invalidInputIds: [],
      fpBirthdate: null,
      profilePictureFileObject: {},
      occupationalGroupList: {},
      shopperPicture: {
        fileGuid: "",
        fileName: ""
      },
      regions: [],
      shopperProfileData: {
        Salutation: "",
        FirstName: "",
        LastName: "",
        Address1: "",
        PostalCode: "",
        City: "",
        CountryCode: "",
        RegionGuid: "",
        Birthdate: "",
        Email: "",
        Phone1: "",
        Phone2: "",
        OccupationalGroupGuid: "", // Berufsgruppe
        Occupation: "", // Tätig als
        Employer: "", // Tätig bei
        Gender: "",
        VatNo: "",
        ProfilePictureGuid: ""
      },
      bankDetailsData: {},
      // shopperProperties: {},
      propertiesFormData: {},
      lang: {
        SP1000: "Bank Details",
        SP1001: "User Profile",
        SP1002: "General",
        SP1003: "Salutation", // form of adress
        SP1004: "Please select...",
        SP1005: "Madam",
        SP1006: "Monsieur",
        SP1007: "Close",
        SP1008: "Save",
        SP1009: "This is a required entry!",
        SP1010: "First name",
        SP1011: "Last name",
        SP1012: "Street",
        SP1013: "Postal Code",
        SP1014: "City",
        SP1015: "Country",
        SP1016: "Birthday",
        SP1017: "Email",
        SP1018: "Phone",
        SP1019: "Alternative Phone",
        SP1020: "Career",
        SP1021: "Active as",
        SP1022: "Active by",
        SP1023: "Bank name",
        SP1024: "Picture",
        SP1025: "Please choose a picture...",
        SP1026: "Choose picture",
        SP1027: "Download picture",
        SP1028: "Delete picture",
        SP1029: "Gender",
        SP1030: "Male",
        SP1031: "Female",
        SP1032: "VAT No.",
        SP1033: "Divers",
        SP1034: "BIC",
        SP1035: "IBAN",
        SP1036: "Account owner",
        SP1037: "Form validation failed",
        SP1038: "Profile data request failed",
        SP1039: "Profile data update successful",
        SP1040: "Profile data update failed",
        SP1041: "Invalid file type",
        SP1042: "Upload successful",
        SP1043: "Upload failed",
        SP1044: "Profile information",
        SP1045: "VAT not mandatory",
        SP1046: "Social security number",
        SP1047: "Invalid IBAN",
        SP1048: "Invalid BIC",
        SP1049: "Region"
      }
    };
  },

  methods: {
    // Triggers input validation and ensures further progress if validation was successful
    validateBeforeSubmit: function validateBeforeSubmit(dialog) {
      var result = true;
      var elements = $("#" + dialog).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) result = this.validateInput(elements[i].id) && result; // If only one input is invalid, the whole form is invalid
      }
      if (dialog === "shopperProfileModal") {
        if (!result) {
          this.globals.$emit("openGlobalErrorDialog", { errorText: this.lang.SP1037, colorOrange: false });
          return;
        }
        this.saveProfileData();
      }
    },

    // Validates an input with the given id, changes the input color depending on the validation result and returns the result
    validateInput: function validateInput(id) {
      // Checks validation depending on the input type or a given pattern in the template
      var result = id === "inputShopperBirthday" ? $("#" + id)[0].value !== "" : $("#" + id)[0].checkValidity();
      if (result) {
        $("#" + id).parent().parent().removeClass("has-error"); // has-error has to be added to the form-group element
        var idx = this.invalidInputIds.indexOf(id);
        if (idx > -1) {
          this.invalidInputIds.splice(idx, 1); // Remove from list, if valid
        }
      } else {
        $("#" + id).parent().parent().addClass("has-error");
        if (this.invalidInputIds.indexOf(id) < 0) this.invalidInputIds.push(id); // Add to list, if invalid
      }
      return result;
    },

    // Returns true if an input has a validation error, otherwise false
    inputHasError: function inputHasError(id) {
      return this.invalidInputIds.indexOf(id) > -1 ? true : false;
    },

    // Resets all validation errors for the given dialog
    resetValidationErrors: function resetValidationErrors(dialog) {
      var elements = $("#" + dialog).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) $("#" + elements[i].id).parent().parent().removeClass("has-error");
      }
      this.invalidInputIds = [];
    },
    openEditShopperDialog: function openEditShopperDialog() {
      var _this5 = this;

      var requestCount = 3;
      var successCallback = function successCallback() {
        if (--requestCount < 1) {
          $("#shopperProfileModal").modal("show");
          _this5.resetValidationErrors("shopperProfileModal");
        }
      };
      var errorCallback = function errorCallback() {
        _this5.globals.$emit("openGlobalErrorDialog", { errorText: _this5.lang.SP1038, colorOrange: false });
        _this5.$emit("modalClosed");
      };
      this.getProfileData(successCallback, errorCallback);
      this.getBankDetails(successCallback, errorCallback);
      this.$refs.customPropertiesForm.getShopperProperties(successCallback, errorCallback);
    },
    closeEditShopperDialog: function closeEditShopperDialog() {
      $("#shopperProfileModal").modal("hide");
    },
    vatNotMandatoryChanged: function vatNotMandatoryChanged() {
      var _this6 = this;

      delete this.shopperProfileData.VatNo;
      this.$nextTick(function () {
        _this6.validateInput("inputShopperVatNo");
      });
    },
    getProfileData: function getProfileData(_success, _error) {
      var _this7 = this;

      var queryString = "shopper-api/Profile";

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this7.shopperProfileData = data;
          if (_this7.shopperProfileData.Birthdate) _this7.fpBirthdate.setDate(_this7.shopperProfileData.Birthdate);
          if (_this7.$refs.inputShopperRegionGuid) _this7.$refs.inputShopperRegionGuid.updateValue();
          _success();
        },
        error: function error() {
          console.error("Error on GET in getProfileData()");
          _error();
        }
      });
    },
    saveProfileData: function saveProfileData() {
      var _this8 = this;

      if (!this.validateBankDetails()) return;

      var requestCount = 3;
      var successCallback = function successCallback() {
        if (--requestCount < 1) {
          _this8.globals.showSuccessSnackbar(_this8.lang.SP1039);
          _this8.closeEditShopperDialog();
          _this8.$emit("dialogDataSaved");
        }
      };
      var errorCallback = function errorCallback() {
        _this8.globals.$emit("openGlobalErrorDialog", { errorText: _this8.lang.SP1040, colorOrange: false });
      };

      this.saveBankDetails(successCallback, errorCallback);
      this.$refs.customPropertiesForm.saveShopperProperties(successCallback, errorCallback);

      var queryString = "shopper-api/Profile";
      if (!this.shopperProfileData.ProfilePictureGuid) delete this.shopperProfileData.ProfilePictureGuid;
      if (!this.shopperProfileData.RegionGuid) delete this.shopperProfileData.RegionGuid;

      $.ajax({
        method: "PUT",
        url: queryString,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.shopperProfileData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          successCallback();
        },
        error: function error() {
          console.error("Error on PUT in saveProfileData()");
          errorCallback();
        }
      });
    },
    onShopperProfilePictureFileChange: function onShopperProfilePictureFileChange(e) {
      var _this9 = this;

      var files = e.target.files || e.dataTransfer.files;
      if (!files.length || !files[0].name) {
        this.shopperProfileData.ProfilePictureGuid = "";
        this.profilePictureFileObject = {};
        return;
      }
      this.profilePictureFileObject = files[0];
      if (this.profilePictureFileObject.type.indexOf("image/") < 0) {
        this.globals.$emit("openGlobalErrorDialog", { errorText: this.lang.SP1041, colorOrange: false });
        e.target.value = null;
        return;
      }

      var callback = function callback() {
        var uploadSuccess = function uploadSuccess(data) {
          _this9.shopperProfileData.ProfilePictureGuid = data[0].DownloadId;
          _this9.shopperProfileData.ProfilePictureName = _this9.profilePictureFileObject.name;
          _this9.globals.showSuccessSnackbar(_this9.lang.SP1042);
          _this9.$forceUpdate();
        };

        _this9.globals.uploadFile(_this9.profilePictureFileObject, false, uploadSuccess
        // () => this.globals.$emit("openGlobalErrorDialog", {errorText: this.lang.SP1043, colorOrange: false});
        );
        e.target.value = null;
      };

      this.profilePictureFileObject.imageUrl = URL.createObjectURL(this.profilePictureFileObject);
      callback();
    },
    removeShopperProfilePictureFile: function removeShopperProfilePictureFile() {
      $("#inputShopperProfilePictureFile")[0].value = null;
      this.shopperProfileData.ProfilePictureGuid = "";
      this.shopperProfileData.ProfilePictureName = "";
      this.profilePictureFileObject = {};
      this.$forceUpdate();
    },
    getBankDetails: function getBankDetails(_success2, _error2) {
      var _this10 = this;

      var queryString = "shopper-api/Profile/BankDetails";

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (data) {
            if (!_.isEmpty(data)) {
              _this10.bankDetailsData = data[0];
            } else {
              _this10.bankDetailsData = {};
            }
            _success2();
          } else _error2();
        },
        error: function error() {
          console.error("Error on GET in getBankDetails()");
          _this10.bankDetailsData = {};
          _error2();
        }
      });
    },
    saveBankDetails: function saveBankDetails(_success3, _error3) {
      var _this11 = this;

      var queryString = "shopper-api/Profile/BankDetails";
      var reqMethod = "POST";
      if (this.bankDetailsData.BankDetailsGuid) {
        queryString += "/" + this.bankDetailsData.BankDetailsGuid;
        reqMethod = "PUT";
      }

      $.ajax({
        method: reqMethod,
        url: queryString,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.bankDetailsData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data && !_.isEmpty(data)) {
            _this11.bankDetailsData = data;
          }
          _success3();
        },
        error: function error() {
          console.error("Error on PUT in saveProfileData()");
          _error3();
        }
      });
    },
    validateBankDetails: function validateBankDetails() {
      if (this.bankDetailsData.AccountNumber) {
        this.bankDetailsData.AccountNumber = this.bankDetailsData.AccountNumber.replace(/ /g, "");
        if (!ibantools.isValidIBAN(this.bankDetailsData.AccountNumber)) {
          this.globals.$emit("openGlobalErrorDialog", { errorText: this.lang.SP1047, colorOrange: false });
          return false;
        }
      }
      if (this.bankDetailsData.SwiftCode) {
        this.bankDetailsData.SwiftCode = this.bankDetailsData.SwiftCode.replace(/ /g, "");
        if (!ibantools.isValidBIC(this.bankDetailsData.SwiftCode)) {
          this.globals.$emit("openGlobalErrorDialog", { errorText: this.lang.SP1048, colorOrange: false });
          return false;
        }
      }
      return true;
    },
    openFileSelector: function openFileSelector() {
      $("#inputShopperProfilePictureFile").click();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),

/***/ 579:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ChangePasswordDialog",
  props: {
    showDialog: {
      default: false,
      type: Boolean
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#changePasswordDialog" + this._uid).on("hide.bs.modal", function (e) {
      _this.$emit("dialogClosed");
    });
    this.globals.getPasswordPolicyList(function (callbackData) {
      _this.passwordPolicy = callbackData;
    });
    this.debouncedCheckPasswordValidity = _.debounce(this.validatePassword, 500);
  },

  watch: {
    showDialog: function showDialog() {
      this.showDialog ? this.openChangePasswordDialog() : this.closeChangePasswordDialog();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  data: function data() {
    return {
      passwordsMatch: false,
      isPasswordValid: false,
      passwordPolicy: [],
      passwordValidity: {},
      passwords: {
        oldPassword: "",
        newPassword: "",
        newPasswordRepeat: ""
      },
      lang: {
        PW0000: "Reset password",
        PW0001: "New password",
        PW0002: "Change new password",
        PW0003: "Password policies",
        PW0004: "at least",
        PW0005: "letters",
        PW0006: "capital letter(s)",
        PW0007: "small letter(s)",
        PW0008: "numeral(s)",
        PW0009: "special character(s)",
        PW0010: "Cancel",
        PW0011: "Save",
        PW0012: "Passwords match",
        PW0013: "Old password",
        PW0014: "Change password",
        PW0015: "Old password missing",
        PW0016: "Password changed"
      }
    };
  },

  methods: {
    openChangePasswordDialog: function openChangePasswordDialog() {
      $("#changePasswordDialog" + this._uid).modal("show");
      this.initChangePasswordDialog();
    },
    closeChangePasswordDialog: function closeChangePasswordDialog() {
      $("#changePasswordDialog" + this._uid).modal("hide");
    },
    initChangePasswordDialog: function initChangePasswordDialog() {
      this.passwordsMatch = false;
      this.isPasswordValid = false;
      this.passwordValidity = {};
      this.passwords = {
        oldPassword: "",
        newPassword: "",
        newPasswordRepeat: ""
      };
    },
    doCheckIfPasswordIsValid: function doCheckIfPasswordIsValid() {
      if (this.debouncedCheckPasswordValidity) this.debouncedCheckPasswordValidity();
    },
    validatePassword: function validatePassword() {
      var _this2 = this;

      var passwordToCheck = {
        Password: this.passwords.newPassword
      };
      $.ajax({
        method: "POST",
        url: "api/Password/ValidatePassword",
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(passwordToCheck),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this2.passwordValidity = data;
          _this2.checkPasswordValidity();
        },
        error: function error() {
          console.error("Error on POST in validatePassword()");
          _this2.globals.$emit("openGlobalErrorDialog", { errorText: "Password validation failed", colorOrange: false });
        }
      });
    },
    checkIfPasswordsMatch: function checkIfPasswordsMatch() {
      this.passwordsMatch = !!this.passwords.newPassword && !!this.passwords.newPasswordRepeat ? this.passwords.newPassword === this.passwords.newPasswordRepeat : false;
    },
    checkPasswordValidity: function checkPasswordValidity() {
      this.isPasswordValid = _.filter(this.passwordValidity, function (value) {
        return !value;
      }).length === 0;
    },
    checkIfNewPasswordPassed: function checkIfNewPasswordPassed() {
      if (this.isPasswordValid && this.passwordsMatch) this.saveNewPassword();
    },
    saveNewPassword: function saveNewPassword() {
      var _this3 = this;

      var request = "api/Password/ChangePassword";

      if (!this.passwords.oldPassword) {
        this.globals.$emit("openGlobalErrorDialog", { errorText: this.lang.PW0015, colorOrange: false });
        return;
      }
      var passwordData = {
        Password: this.passwords.newPassword,
        OldPassword: this.passwords.oldPassword
      };

      $.ajax({
        method: "PATCH",
        url: request,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(passwordData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            _this3.globals.$emit("openGlobalErrorDialog", { errorText: data.Error, colorOrange: false });
            return;
          }
          _this3.globals.showSuccessSnackbar(_this3.lang.PW0016);
          _this3.closeChangePasswordDialog();
        },
        error: function error() {
          console.error("Error on PUT in saveNewPassword()");
          _this3.globals.$emit("openGlobalErrorDialog", { errorText: "Password update failed", colorOrange: false });
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),

/***/ 58:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__requestBase__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LocalDatabase_StoreNames__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__LocalDatabase_GetLocalDB__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_uuid_v4__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_uuid_v4__);











var UploadFilesService = function () {
  function UploadFilesService() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, UploadFilesService);

    __WEBPACK_IMPORTED_MODULE_8__LocalDatabase_GetLocalDB__["a" /* default */].then(function (result) {
      _this.localDB = result;
    });
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(UploadFilesService, [{
    key: "saveFilesToDeleteOffline",
    value: function saveFilesToDeleteOffline(files) {
      this.localDB.saveObject("app", "filesToDelete", files);
    }
  }, {
    key: "getFilesToDelete",
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.localDB.getObject("app", "filesToDelete");

              case 3:
                return _context.abrupt("return", _context.sent);

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", []);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 6]]);
      }));

      function getFilesToDelete() {
        return _ref.apply(this, arguments);
      }

      return getFilesToDelete;
    }()
  }, {
    key: "getOfflineKeys",
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.localDB.getObject("app", "offlineFileKeys");

              case 3:
                return _context2.abrupt("return", _context2.sent);

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", []);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 6]]);
      }));

      function getOfflineKeys() {
        return _ref2.apply(this, arguments);
      }

      return getOfflineKeys;
    }()
  }, {
    key: "clearCachedFilesExcept",
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3(fileGuid) {
        var keys, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                fileGuid = fileGuid.map(function (v) {
                  if (Array.isArray(v)) {
                    v.forEach(function (element) {
                      element.toUpperCase();
                    });
                  } else {
                    v.toUpperCase();
                  }
                });
                _context3.next = 3;
                return this.getCachedKeys();

              case 3:
                _context3.t0 = function (v) {
                  fileGuid.indexOf(v) === -1;
                };

                keys = _context3.sent.filter(_context3.t0);
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context3.prev = 8;
                _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(keys);

              case 10:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context3.next = 17;
                  break;
                }

                key = _step.value;
                _context3.next = 14;
                return this.uncacheFile(key);

              case 14:
                _iteratorNormalCompletion = true;
                _context3.next = 10;
                break;

              case 17:
                _context3.next = 23;
                break;

              case 19:
                _context3.prev = 19;
                _context3.t1 = _context3["catch"](8);
                _didIteratorError = true;
                _iteratorError = _context3.t1;

              case 23:
                _context3.prev = 23;
                _context3.prev = 24;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 26:
                _context3.prev = 26;

                if (!_didIteratorError) {
                  _context3.next = 29;
                  break;
                }

                throw _iteratorError;

              case 29:
                return _context3.finish(26);

              case 30:
                return _context3.finish(23);

              case 31:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[8, 19, 23, 31], [24,, 26, 30]]);
      }));

      function clearCachedFilesExcept(_x) {
        return _ref3.apply(this, arguments);
      }

      return clearCachedFilesExcept;
    }()
  }, {
    key: "getFullCacheRelatedKeys",
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var keys;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.getCachedKeys();

              case 2:
                keys = _context4.sent;

                if (keys.length > 0) {
                  keys = keys.map(function (v) {
                    return "FILES_" + v;
                  });
                  keys.push("__CACHEDFILEKEYS");
                }
                return _context4.abrupt("return", keys);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getFullCacheRelatedKeys() {
        return _ref4.apply(this, arguments);
      }

      return getFullCacheRelatedKeys;
    }()
  }, {
    key: "saveOfflineKeys",
    value: function saveOfflineKeys(offlineFileKeys) {
      this.localDB.saveObject("app", "offlineFileKeys", offlineFileKeys);
    }
  }, {
    key: "getCachedKeys",
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return this.localDB.getObject("app", "cachedFileKeys");

              case 3:
                return _context5.abrupt("return", _context5.sent);

              case 6:
                _context5.prev = 6;
                _context5.t0 = _context5["catch"](0);
                return _context5.abrupt("return", []);

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 6]]);
      }));

      function getCachedKeys() {
        return _ref5.apply(this, arguments);
      }

      return getCachedKeys;
    }()
  }, {
    key: "saveCachedKeys",
    value: function saveCachedKeys(cachedFileKeys) {
      this.localDB.saveObject("app", "cachedFileKeys", cachedFileKeys);
    }
    /**
     *
     * @param {File} file The file you want to Upload
     * @param {Function} progresscallback - optional callback for Progress event
     * @returns {Promise<R>} - returns the response in a Promise
     */

  }, {
    key: "uploadOnline",
    value: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6(file) {
        var onUploadProgress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (r) {};
        var formData, response, id;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                formData = new FormData();


                formData.append("file", file);
                _context6.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6__requestBase__["a" /* default */].post("api/Upload", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  },
                  onUploadProgress: onUploadProgress
                });

              case 4:
                response = _context6.sent;
                id = response.data[0].DownloadId;
                _context6.prev = 6;
                _context6.next = 9;
                return this.cacheFile(id, file);

              case 9:
                _context6.next = 13;
                break;

              case 11:
                _context6.prev = 11;
                _context6.t0 = _context6["catch"](6);

              case 13:
                return _context6.abrupt("return", id);

              case 14:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[6, 11]]);
      }));

      function uploadOnline(_x2) {
        return _ref6.apply(this, arguments);
      }

      return uploadOnline;
    }()

    /**
     *
     * @param {String} baseKey The first part of the local key
     * @param {File} file The file you want to Upload
     * @returns {Promise<R>} - returns the response in a Promise
     */

  }, {
    key: "uploadOffline",
    value: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7(baseKey, file) {
        var key, offlineFileKeys;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                key = baseKey + "_" + __WEBPACK_IMPORTED_MODULE_9_uuid_v4___default()();
                _context7.next = 3;
                return this.localDB.saveFile(__WEBPACK_IMPORTED_MODULE_7__LocalDatabase_StoreNames__["a" /* FILES_STORE_NAME */], key, file);

              case 3:
                _context7.next = 5;
                return this.getOfflineKeys();

              case 5:
                offlineFileKeys = _context7.sent;

                offlineFileKeys.push(key);
                this.saveOfflineKeys(offlineFileKeys);
                return _context7.abrupt("return", key);

              case 9:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function uploadOffline(_x4, _x5) {
        return _ref7.apply(this, arguments);
      }

      return uploadOffline;
    }()

    /**
     *
     * @param {String} key The file key
     * @param {File} file The file you want to Upload
     * @returns {Promise<R>} - returns the response in a Promise
     */

  }, {
    key: "cacheFile",
    value: function () {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8(key, file) {
        var cachedFileKeys;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.isCachedKey(key);

              case 2:
                if (_context8.sent) {
                  _context8.next = 10;
                  break;
                }

                _context8.next = 5;
                return this.localDB.saveFile(__WEBPACK_IMPORTED_MODULE_7__LocalDatabase_StoreNames__["a" /* FILES_STORE_NAME */], key, file);

              case 5:
                _context8.next = 7;
                return this.getCachedKeys();

              case 7:
                cachedFileKeys = _context8.sent;

                cachedFileKeys.push(key);
                this.saveCachedKeys(cachedFileKeys);

              case 10:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function cacheFile(_x6, _x7) {
        return _ref8.apply(this, arguments);
      }

      return cacheFile;
    }()

    /**
     *
     * @param {String} key The file key
     * @returns {Promise<R>} - returns the response in a Promise
     */

  }, {
    key: "uncacheFile",
    value: function () {
      var _ref9 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee9(key) {
        var cachedFileKeys, newCachedFileKeys, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, item;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.getCachedKeys();

              case 2:
                cachedFileKeys = _context9.sent;
                newCachedFileKeys = [];
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context9.prev = 7;

                for (_iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(cachedFileKeys); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  item = _step2.value;

                  if (item === key) {
                    this.localDB.remove(__WEBPACK_IMPORTED_MODULE_7__LocalDatabase_StoreNames__["a" /* FILES_STORE_NAME */], key);
                  } else {
                    newCachedFileKeys.push(item);
                  }
                }
                _context9.next = 15;
                break;

              case 11:
                _context9.prev = 11;
                _context9.t0 = _context9["catch"](7);
                _didIteratorError2 = true;
                _iteratorError2 = _context9.t0;

              case 15:
                _context9.prev = 15;
                _context9.prev = 16;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 18:
                _context9.prev = 18;

                if (!_didIteratorError2) {
                  _context9.next = 21;
                  break;
                }

                throw _iteratorError2;

              case 21:
                return _context9.finish(18);

              case 22:
                return _context9.finish(15);

              case 23:
                this.saveCachedKeys(newCachedFileKeys);

              case 24:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[7, 11, 15, 23], [16,, 18, 22]]);
      }));

      function uncacheFile(_x8) {
        return _ref9.apply(this, arguments);
      }

      return uncacheFile;
    }()

    /**
     * @description Upload file that was saved in offline mode to the backend and return the new key (offline files are assigned bad GUIDs to mark them)
     * @param {String} key The file key
     * @returns {Promise<R>} - returns the response in a Promise
     */

  }, {
    key: "uploadOfflineFile",
    value: function () {
      var _ref10 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee10(key) {
        var file, newKey, offlineFileKeys;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.getLocalFile(key);

              case 2:
                file = _context10.sent;
                _context10.next = 5;
                return this.uploadOnline(file);

              case 5:
                newKey = _context10.sent;
                _context10.next = 8;
                return this.getOfflineKeys();

              case 8:
                offlineFileKeys = _context10.sent;

                this.localDB.saveObject("app", "offlineFileKeys", offlineFileKeys.filter(function (v) {
                  return v != key;
                }));
                return _context10.abrupt("return", { oldKey: key, newKey: newKey });

              case 11:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function uploadOfflineFile(_x9) {
        return _ref10.apply(this, arguments);
      }

      return uploadOfflineFile;
    }()

    /**
     * @description Upload mulitple files that were saved in offline mode to the backend and return the new keys (offline files are assigned bad GUIDs to mark them)
     * @param {Array<String>} keys The list of keys to upload
     * @returns {Promise<Array<Object>>} - returns the response with array with new files keys
     */

  }, {
    key: "uploadOfflineFiles",
    value: function () {
      var _ref11 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee11(keys) {
        var newKeys, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, key;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                newKeys = [];
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context11.prev = 4;
                _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(keys);

              case 6:
                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                  _context11.next = 22;
                  break;
                }

                key = _step3.value;
                _context11.next = 10;
                return this.isOfflineKey(key);

              case 10:
                if (!_context11.sent) {
                  _context11.next = 18;
                  break;
                }

                _context11.t0 = newKeys;
                _context11.next = 14;
                return this.uploadOfflineFile(key);

              case 14:
                _context11.t1 = _context11.sent;

                _context11.t0.push.call(_context11.t0, _context11.t1);

                _context11.next = 19;
                break;

              case 18:
                newKeys.push({ oldKey: key, newKey: key });

              case 19:
                _iteratorNormalCompletion3 = true;
                _context11.next = 6;
                break;

              case 22:
                _context11.next = 28;
                break;

              case 24:
                _context11.prev = 24;
                _context11.t2 = _context11["catch"](4);
                _didIteratorError3 = true;
                _iteratorError3 = _context11.t2;

              case 28:
                _context11.prev = 28;
                _context11.prev = 29;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 31:
                _context11.prev = 31;

                if (!_didIteratorError3) {
                  _context11.next = 34;
                  break;
                }

                throw _iteratorError3;

              case 34:
                return _context11.finish(31);

              case 35:
                return _context11.finish(28);

              case 36:
                return _context11.abrupt("return", newKeys);

              case 37:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[4, 24, 28, 36], [29,, 31, 35]]);
      }));

      function uploadOfflineFiles(_x10) {
        return _ref11.apply(this, arguments);
      }

      return uploadOfflineFiles;
    }()
    /**
     * @description Get the file from local database if it was saved offline or download it from backend
     * NOTE: Caching does not make sense here since pictures aren't reused or downloaded multiple times
     * @param {String} key The file key (id)
     * @returns {blob} - returns the file as a blob
     */

  }, {
    key: "getFileById",
    value: function () {
      var _ref12 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee12(key) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (key) {
                  _context12.next = 3;
                  break;
                }

                console.debug("getFileById: !key");
                return _context12.abrupt("return");

              case 3:
                _context12.next = 5;
                return this.isOfflineKey(key);

              case 5:
                _context12.t0 = _context12.sent;

                if (_context12.t0) {
                  _context12.next = 10;
                  break;
                }

                _context12.next = 9;
                return this.isCachedKey(key);

              case 9:
                _context12.t0 = _context12.sent;

              case 10:
                if (!_context12.t0) {
                  _context12.next = 14;
                  break;
                }

                _context12.next = 13;
                return this.getLocalFile(key);

              case 13:
                return _context12.abrupt("return", _context12.sent);

              case 14:
                _context12.next = 16;
                return __WEBPACK_IMPORTED_MODULE_6__requestBase__["a" /* default */].get("/api/Download/" + key, {
                  responseType: "blob"
                });

              case 16:
                response = _context12.sent;
                return _context12.abrupt("return", response.data);

              case 18:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getFileById(_x11) {
        return _ref12.apply(this, arguments);
      }

      return getFileById;
    }()

    /**
     *
     * @param {String} key The file key (id)
     * @returns {Promise<String>} - returns the response in a Promise
     */

  }, {
    key: "getFileURLById",
    value: function () {
      var _ref13 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee13(key) {
        var blob;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this.getFileById(key);

              case 2:
                blob = _context13.sent;

                if (!(blob && blob.size > 0)) {
                  _context13.next = 5;
                  break;
                }

                return _context13.abrupt("return", URL.createObjectURL(blob));

              case 5:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function getFileURLById(_x12) {
        return _ref13.apply(this, arguments);
      }

      return getFileURLById;
    }()

    /**
     * @description Check if the given file key belongs to a cached file
     * @param {String} key The file key
     * @returns {Promise<Boolean>} - returns if the key belongs to a cached file
     */

  }, {
    key: "isCachedKey",
    value: function () {
      var _ref14 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee14(key) {
        var isCached;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                isCached = false;
                _context14.next = 3;
                return this.getCachedKeys();

              case 3:
                _context14.t0 = key;
                _context14.t1 = _context14.sent.indexOf(_context14.t0);
                _context14.t2 = -1;
                isCached = _context14.t1 > _context14.t2;
                return _context14.abrupt("return", isCached);

              case 8:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function isCachedKey(_x13) {
        return _ref14.apply(this, arguments);
      }

      return isCachedKey;
    }()

    /**
     * @description Check if the given file key (GUID or GUID with accessoires likes questioname) belongs to a file that was saved in offline mode (offline files are assigned bad GUIDs to mark them)
     * @param {String} key The file key
     * @returns {Promise<Boolean>} - returns if the key belongs to offline file
     */

  }, {
    key: "isOfflineKey",
    value: function () {
      var _ref15 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee15(key) {
        var isOffline, isOfflineRegex;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                isOffline = false;
                _context15.next = 3;
                return this.getOfflineKeys();

              case 3:
                _context15.t0 = key;
                _context15.t1 = _context15.sent.indexOf(_context15.t0);
                _context15.t2 = -1;
                isOffline = _context15.t1 > _context15.t2;

                if (!isOffline) {
                  // guid regex = [0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}
                  // question number regex = q[0-9]{5}
                  // values for offline keys: guid_guid (Ticket Uploads) or questionNumber_guid (Question Uploads), so we just look for .*_guid

                  isOfflineRegex = /.*_[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

                  isOffline = isOfflineRegex.test(key);
                }
                return _context15.abrupt("return", isOffline);

              case 9:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function isOfflineKey(_x14) {
        return _ref15.apply(this, arguments);
      }

      return isOfflineKey;
    }()

    /**
     * @description Get a file that was saved in offline mode from local browser database
     * @param {String} key The offline file key
     * @returns {Promise<blob>} - returns the file as a blob
     */

  }, {
    key: "getLocalFile",
    value: function () {
      var _ref16 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee16(key) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return this.localDB.getFile(__WEBPACK_IMPORTED_MODULE_7__LocalDatabase_StoreNames__["a" /* FILES_STORE_NAME */], key);

              case 2:
                return _context16.abrupt("return", _context16.sent);

              case 3:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function getLocalFile(_x15) {
        return _ref16.apply(this, arguments);
      }

      return getLocalFile;
    }()

    /**
     *
     * @param  {Array<SurveyInstanceAnswerFile>}files JSON of files like saved for SurveyInstanceAnswer
     * @returns
     */

  }, {
    key: "delete",
    value: function _delete(files) {
      var _this2 = this;

      files = files.filter(function (file) {
        return !_this2.isOfflineKey(file);
      });
      return __WEBPACK_IMPORTED_MODULE_6__requestBase__["a" /* default */].post("api/Download/Delete", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(files));
    }
  }]);

  return UploadFilesService;
}();

/* harmony default export */ __webpack_exports__["a"] = (new UploadFilesService());

/***/ }),

/***/ 580:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "NotificationDialog",
  props: {
    dialogId: {
      type: String,
      default: "notificationDialog"
    },
    notificationTitle: {
      type: String,
      default: ""
    },
    closeButtonText: {
      type: String,
      default: "Close"
    },
    showDialog: {
      type: Boolean,
      default: false
    },
    colorRed: {
      type: Boolean,
      default: false
    },
    htmlText: {
      type: String,
      default: ""
    }
  },
  methods: {
    openNotificationDialog: function openNotificationDialog() {
      var _this = this;

      this.$nextTick(function () {
        $("#" + _this.dialogId).modal("show");
      });
    },
    closeNotificationDialog: function closeNotificationDialog() {
      $("#" + this.dialogId).modal("hide");
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    $("#" + this.dialogId).on("hide.bs.modal", function (e) {
      return _this2.$emit("closeDialog");
    });
    $("#" + this.dialogId).on("hidden.bs.modal", function (e) {
      _this2.$emit("dialogClosed");
    });
  },

  watch: {
    showDialog: function showDialog() {
      if (this.showDialog) {
        this.openNotificationDialog();
      } else {
        this.closeNotificationDialog();
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),

/***/ 591:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

var resolveInitPromise = void 0;
var rejectInitPromise = void 0;
// This promise handles the initialization
// status of the google maps script.
var initPromise = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
  resolveInitPromise = resolve;
  rejectInitPromise = reject;
});

function init(apiKey) {
  // If Google Maps already is initialized
  // the `initPromise` should get resolved
  // eventually.
  if (!!window.google) return initPromise;

  // The callback function is called by
  // the Google Maps script if it is
  // successfully loaded.
  window["gmapsCallback"] = function () {
    return resolveInitPromise(window.google);
  };

  // We inject a new script tag into
  // the `<head>` of our HTML to load
  // the Google Maps script.
  var script = document.createElement("script");
  script.async = true;
  script.defer = true;
  script.src = "https://maps.googleapis.com/maps/api/js?key=" + apiKey + "&callback=gmapsCallback&libraries=places";
  script.onerror = rejectInitPromise;
  document.querySelector("head").appendChild(script);
  return initPromise;
}

/***/ }),

/***/ 74:
/***/ (function(module, exports) {

module.exports = {"name":"msm_loop_v2","version":"2.4.9.1","description":"MSM Loop v2","author":"Marc Stöckel","private":true,"scripts":{"local":"node build/dev-server.js config=localhost","dev":"node build/dev-server.js","dev-msm":"node build/dev-server.js config=dev.shopper.msmloop.com","dev-porsche":"node build/dev-server.js config=dev.shopper.sar-pag.de","dev-db":"node build/dev-server.js config=dev.shopper.qm-servicestoredb.de","dev-audi":"node build/dev-server.js config=dev.shopper.audi-mysteryshopping.com","start":"node build/dev-server.js","build":"node build/build.js","test":"jest"},"googleApiKeys":{"dev":"AIzaSyAYTZ_Xy5ho5kkg8hr91JiSYdoXY16JgqI","msm":"AIzaSyANcvr9_qvJu0_Qj4DqcWPygtQALed9pRQ","audi":"AIzaSyANXa3eXWwvDKV4fU94IJAsYDdhQTqe3lo"},"jest":{"setupFiles":["./src/setup-jest.js"],"reporters":["default","jest-junit"],"moduleFileExtensions":["js","json","vue"],"moduleNameMapper":{"^@[/](.+)":"<rootDir>/src/$1","^components[/](.+)":"<rootDir>/src/components/$1","src/components/([^\\.]*)$":"<rootDir>/src/components/$1.vue","^vue$":"vue/dist/vue.common.js","src/([^\\.]*)$":"<rootDir>/src/$1.vue","\\.(css|less|scss|sass)$":"identity-obj-proxy"},"transform":{".*\\.(vue)$":"vue-jest",".+\\.(css|styl|less|sass|scss|png|jpg|ttf|woff|woff2)$":"jest-transform-stub","^.+\\.js$":"<rootDir>/node_modules/babel-jest"},"transformIgnorePatterns":["<rootDir>/node_modules/(?!(cropperjs)/)"],"collectCoverage":false,"collectCoverageFrom":["src/components/**/*.{js,vue}","!**/node_modules/**"],"coverageReporters":["html","text-summary"]},"dependencies":{"axios":"^0.21.1","b64-to-blob":"^1.2.19","base64url":"3.0.1","bootstrap":"3.3.7","bootstrap-material-design":"0.5.10","bootstrap-vue":"2.0.0-rc.11","bootstrap4":"npm:bootstrap@4.5.2","compress.js":"^1.1.2","css-vars-ponyfill":"2.2.1","flatpickr":"4.6.3","ibantools":"2.2.0","inputmask":"4.0.8","jquery":"3.3.1","localforage":"^1.9.0","lodash":"4.17.11","material-design-icons":"3.0.1","moment":"2.24.0","rxjs":"5.5.12","select2":"4.0.10","smoothscroll-polyfill":"0.4.4","snackbarjs":"1.1.0","survey-vue":"1.8.45","text-encoding-shim":"1.0.5","typeface-roboto":"0.0.54","v-tooltip":"2.0.3","vue":"2.6.12","vue-click-outside":"1.0.7","vue-connection-listener":"^1.0.2","vue-cropperjs":"3.0.0","vue-currency-input":"1.14.3","vue-loading-overlay":"^4.0.3","vue-long-click":"0.0.4","vue-router":"3.0.1","vuex":"^3.6.2","vuex-persist":"^3.1.3"},"devDependencies":{"@types/lodash":"^4.14.168","@vue/test-utils":"1.0.0-beta.27","autoprefixer":"^6.7.2","babel-core":"^6.22.1","babel-jest":"23.6.0","babel-loader":"^6.2.10","babel-plugin-transform-es2015-for-of":"^6.23.0","babel-plugin-transform-runtime":"^6.22.0","babel-polyfill":"^6.26.0","babel-preset-env":"^1.3.2","babel-preset-stage-2":"^6.22.0","babel-register":"^6.22.0","chalk":"^1.1.3","connect-history-api-fallback":"^1.3.0","copy-webpack-plugin":"^4.0.1","css-loader":"^0.28.0","eventsource-polyfill":"^0.9.6","execa":"^1.0.0","express":"^4.14.1","extract-text-webpack-plugin":"^2.0.0","file-loader":"^0.11.1","friendly-errors-webpack-plugin":"^1.1.3","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.19.1","identity-obj-proxy":"^3.0.0","jest":"23.6.0","jest-junit":"^13.0.0","jest-transform-stub":"^2.0.0","jsdoc-tsimport-plugin":"^1.0.4","node-sass":"^7.0.0","npm":"^6.4.1","opn":"^4.0.2","optimize-css-assets-webpack-plugin":"^1.3.0","ora":"^1.2.0","rimraf":"^2.6.0","sass-loader":"6.0.6","semver":"^5.3.0","shelljs":"^0.8.5","url-loader":"^1.0.1","vue-jest":"3.0.0","vue-loader":"^12.1.0","vue-style-loader":"^3.0.1","vue-template-compiler":"2.6.12","webpack":"^2.6.1","webpack-bundle-analyzer":"^2.2.1","webpack-dev-middleware":"^1.10.0","webpack-hot-middleware":"^2.18.0","webpack-merge":"^4.1.0","webpack-version-file-plugin":"^0.3.3","ws":"3.3.2"},"engines":{"node":"16.x.x","npm":">= 3.0.0"},"browserslist":["> 1%","last 2 versions","not ie <= 8"]}

/***/ }),

/***/ 75:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ticketMut; });
/* unused harmony export indexdblMut */
/* unused harmony export cacheMut */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex_persist__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_ticketStore__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_surveyStore__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_cacheStore__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_AnswerHistoryStore__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_localforage__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_localforage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_helper__ = __webpack_require__(129);










__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var plugins = [];

var DB_NAME = "MSM_LOOPDB";

var ticketMut = ["addTicket", "replaceTicketList", "removeInactiveTickets", "updateTicket", "updateTicketFiles"];

var indexdblMut = ["addSurveyInstance", "changeQuestion"];
var cacheMut = ["buildCache", "flushCache"];

if (true) {
  __WEBPACK_IMPORTED_MODULE_7_localforage___default.a.config({
    driver: [__WEBPACK_IMPORTED_MODULE_7_localforage___default.a.WEBSQL, __WEBPACK_IMPORTED_MODULE_7_localforage___default.a.INDEXEDDB, __WEBPACK_IMPORTED_MODULE_7_localforage___default.a.LOCALSTORAGE], // Use IndexDB if supported
    name: "vuex_MSM",
    version: 1.0,
    storeName: "VuexStore", // Should be alphanumeric, with underscores.
    description: "persitent Vuex store"
  });
  __WEBPACK_IMPORTED_MODULE_7_localforage___default.a.ready().then(function () {
    // This code runs once localforage
    // has fully initialized the selected driver.
    console.debug("Modul: " + __WEBPACK_IMPORTED_MODULE_7_localforage___default.a.driver());
  }).catch(function (e) {
    console.error(e); // `No available storage method found.`
    // One of the cases that `ready()` rejects,
    // is when no usable storage driver is found
  });
  //console.log("Mode:" + localforage.driver());

  var vuexLocal = new __WEBPACK_IMPORTED_MODULE_0_vuex_persist__["a" /* default */]({
    storage: window.localStorage,
    modules: ["tickets", "cacheFlags"]
  });
  plugins.push(vuexLocal.plugin);

  /** 
   not working due to indexdb being async 
   https://github.com/championswimmer/vuex-persist#note-on-localforage-and-async-stores
   */
  var vuexdb = new __WEBPACK_IMPORTED_MODULE_0_vuex_persist__["a" /* default */]({
    storage: __WEBPACK_IMPORTED_MODULE_7_localforage___default.a,
    asyncStorage: true,
    modules: ["surveyAnswers"]
  });
  plugins.push(vuexdb.plugin);
}

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    tickets: __WEBPACK_IMPORTED_MODULE_3__modules_ticketStore__["a" /* default */],
    surveyAnswers: __WEBPACK_IMPORTED_MODULE_4__modules_surveyStore__["a" /* default */],
    cacheFlags: __WEBPACK_IMPORTED_MODULE_5__modules_cacheStore__["a" /* default */],
    AnswerHistory: __WEBPACK_IMPORTED_MODULE_6__modules_AnswerHistoryStore__["a" /* default */]
  },

  mutations: {},
  actions: {},
  plugins: plugins
});

/***/ }),

/***/ 93:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__package_json__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_uploadService__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_Language__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_Imagecompressions__ = __webpack_require__(304);








var _methods;








var Compress = __webpack_require__(474);
var uuidv4 = __webpack_require__(106);

var globals = new __WEBPACK_IMPORTED_MODULE_7_vue__["default"]({
  name: "globals",
  computed: {
    currentUserRole: function currentUserRole() {
      if (this.currentUserInfo && this.currentUserInfo.UserTypeId) return this.currentUserInfo.UserTypeId;
      return -1;
    },
    currentDateFormatForInputMask: function currentDateFormatForInputMask() {
      var dateFormat = "yyyy-mm-dd";
      switch (this.currentLocale) {
        case "de":
          dateFormat = "dd.mm.yyyy";
          break;
        case "fr":
        case "es":
          dateFormat = "dd/mm/yyyy";
          break;
        default:
          dateFormat = "yyyy-mm-dd";
      }
      return dateFormat;
    },
    currentDateFormatForMoment: function currentDateFormatForMoment() {
      var dateFormat = "YYYY-MM-DD";
      switch (this.currentLocale) {
        case "de":
          dateFormat = "DD.MM.YYYY";
          break;
        case "fr":
        case "es":
          dateFormat = "DD/MM/YYYY";
          break;
        default:
          dateFormat = "YYYY-MM-DD";
      }
      return dateFormat;
    },
    currentDateTimeFormatForMoment: function currentDateTimeFormatForMoment() {
      return this.currentDateFormatForMoment + " - HH:mm:ss";
    },
    isMobileBrowser: function isMobileBrowser() {
      // Recommended by MDN: https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent
      if (navigator.userAgent.indexOf("Mobi") > -1) return true;
      return false;
    },
    isChromeBrowser: function isChromeBrowser() {
      return !!window.chrome;
    },
    isSafariBrowser: function isSafariBrowser() {
      return navigator.vendor && navigator.vendor.indexOf("Apple") > -1;
    },
    isIEBrowser: function isIEBrowser() {
      var ua = window.navigator.userAgent;
      // IE 10 or older
      if (ua.indexOf("MSIE ") > 0) return true;
      // IE 11
      if (ua.indexOf("Trident/") > 0) return true;
      // Edge (IE 12+)
      if (ua.indexOf("Edge/") > 0) return true;
      // other browser
      return false;
    },
    currentLocale: function currentLocale() {
      return this.selectedLanguage.substring(0, 2);
    },
    googleApiKey: function googleApiKey() {
      if (_.includes("https://dev.shopper.qm-servicestoredb.de/#/", "msmloop.com")) return __WEBPACK_IMPORTED_MODULE_9__package_json__["googleApiKeys"].msm;
      if (_.includes("https://dev.shopper.qm-servicestoredb.de/#/", "audi-mysteryshopping")) return __WEBPACK_IMPORTED_MODULE_9__package_json__["googleApiKeys"].audi;
      return __WEBPACK_IMPORTED_MODULE_9__package_json__["googleApiKeys"].dev;
    }
  },
  methods: (_methods = {
    /**
     * Sets the language and datetime formate to the locale "loc"
     * Defaults to this.currentLocale
     * @param {string} [loc] - the target locale
     */
    localizeFlatpickrConfig: function localizeFlatpickrConfig() {
      var loc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.currentLocale;

      this.flatpickrDateConfig.locale = loc;
      this.flatpickrIsoDateConfig.locale = loc;
      this.flatpickrDatetimeConfig.locale = loc;

      var dateFormat = void 0;
      switch (loc) {
        case "de":
          dateFormat = "d.m.Y";
          break;
        case "fr":
        case "es":
          dateFormat = "d/m/Y";
          break;
        default:
          dateFormat = "Y-m-d";
      }
      this.flatpickrDateConfig.altFormat = dateFormat;
      this.flatpickrIsoDateConfig.altFormat = dateFormat;
      this.flatpickrDatetimeConfig.altFormat = dateFormat + " H:i";
    },

    /**
     * We used to manually toogle open(),but this broke support for mobile and is disabled at the moment
     * @param {String} inputId the Id of the input element
     */
    toggleFlatpickr: function toggleFlatpickr(inputId) {
      return;
      var el = document.getElementById(inputId);
      if (!el) return;
      var fp = el._flatpickr;
      if (!fp) return;
      fp.toggle();
    },
    showSpinner: function showSpinner(immediate) {
      var _this = this;

      if (!this.$debouncedShowSpinnerFunc) this.$debouncedShowSpinnerFunc = _.debounce(function () {
        return _this.spinnerVisible = true;
      }, 500);

      if (!this.$stackedSpinnerRequests) this.$stackedSpinnerRequests = 0;
      this.$stackedSpinnerRequests++;

      this.$debouncedShowSpinnerFunc();
      if (immediate) this.$debouncedShowSpinnerFunc.flush();
    },
    hideSpinner: function hideSpinner() {
      var clear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (--this.$stackedSpinnerRequests > 0 && !clear) return;

      this.$stackedSpinnerRequests = 0; // Avoid negative values
      if (this.$debouncedShowSpinnerFunc) {
        this.$debouncedShowSpinnerFunc.cancel();
      }
      this.spinnerVisible = false;
    },
    getCurrencyString: function getCurrencyString(value, currencyCode) {
      if (typeof value === "undefined" || isNaN(value) || value === null) return "";
      var result = value.toFixed(2);
      var currency = void 0;
      switch (currencyCode) {
        case "EUR":
          currency = {
            symbol: "€",
            prefix: false
          };
          break;
        case "USD":
          currency = {
            symbol: "$",
            prefix: true
          };
          break;
        case "CNY":
          currency = {
            symbol: "¥",
            prefix: false
          };
          break;
        default:
          currency = {
            symbol: "",
            prefix: false
          };
      }

      switch (this.currentLocale) {
        case "de":
          result = result.replace(".", ",").replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
          break;
        default:
          result = result.replace(",", ".").replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
      result = currency.prefix ? currency.symbol + " " + result : result + " " + currency.symbol;
      return result;
    },
    showSuccessSnackbar: function showSuccessSnackbar(text, timeout) {
      var options = _.cloneDeep(this.snackbarConfig);
      if (typeof timeout === "number" && timeout > 0) options.timeout = timeout;
      options.content = text || this.lang.G00023;
      options.style = "snackbar-success";
      options.id = "successSnackbar";
      options.onClose = function () {
        $("#successSnackbar > span").hide();
      };
      $.snackbar(options);
      $("#successSnackbar > span").show();
    },
    showDebugErrorSnackbar: function showDebugErrorSnackbar(text, timeout) {
      var options = _.cloneDeep(this.snackbarConfig);
      options.timeout += 5000;
      if (typeof timeout === "number" && timeout > 0) options.timeout = timeout;
      options.content = text || this.lang.G00024;
      options.style = "snackbar-error";
      options.id = "errorSnackbar2";
      options.onClose = function () {
        $("#errorSnackbar2 > span").hide();
      };
      $.snackbar(options);
      $("#errorSnackbar2 > span").show();
    },
    showErrorSnackbar: function showErrorSnackbar(text, timeout) {
      var options = _.cloneDeep(this.snackbarConfig);
      options.timeout += 5000;
      if (typeof timeout === "number" && timeout > 0) options.timeout = timeout;
      options.content = text || this.lang.G00024;
      options.style = "snackbar-error";
      options.id = "errorSnackbar";
      options.onClose = function () {
        $("#errorSnackbar > span").hide();
      };
      $.snackbar(options);
      $("#errorSnackbar > span").show();
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "showDebugErrorSnackbar", function showDebugErrorSnackbar(text, timeout) {
    var options = _.cloneDeep(this.snackbarConfig);
    options.timeout += 5000;
    if (typeof timeout === "number" && timeout > 0) options.timeout = timeout;
    options.content = text || this.lang.G00024;
    if ((typeof text === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(text)) === "object") {
      options.content = this.lang.G00024;
    }
    options.style = "snackbar-error";
    options.id = "debugerrorSnackbar";
    options.onClose = function () {
      $("#DebugerrorSnackbar > span").hide();
    };
    $.snackbar(options);
    $("#DebugerrorSnackbar > span").show();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "showWarningSnackbar", function showWarningSnackbar(text, timeout) {
    var hide = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var options = _.cloneDeep(this.snackbarConfig);
    options.timeout = 0;
    if (typeof timeout === "number" && timeout > 0) options.timeout = timeout;
    options.content = text || this.lang.G00024;
    if ((typeof text === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(text)) === "object") {
      options.content = this.lang.G00024;
    }
    options.style = "snackbar-warning";
    options.id = "warningSnackbar";
    options.onClose = function () {
      $("#warningSnackbar > span").hide();
    };
    $.snackbar(options);
    if (hide) {
      $("#warningSnackbar").hide();
    } else {
      $("#warningSnackbar").show();
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "downloadFile", function downloadFile(guid) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
      var fileBlob, docUrl;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_10__services_uploadService__["a" /* default */].getFileById(guid);

            case 2:
              fileBlob = _context.sent;
              docUrl = document.createElement("a");

              docUrl.href = window.URL.createObjectURL(fileBlob);
              docUrl.setAttribute("download", fileBlob.name);
              document.body.appendChild(docUrl);
              docUrl.click();
              docUrl.remove();

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "downloadFilewithName", function downloadFilewithName(guid, filename) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var FILE, docUrl;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_10__services_uploadService__["a" /* default */].getFileURLById(guid);

            case 2:
              FILE = _context2.sent;
              docUrl = document.createElement("a");

              docUrl.href = FILE;
              docUrl.setAttribute("download", filename);
              document.body.appendChild(docUrl);
              docUrl.click();
              docUrl.remove();

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this3);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "compressFile", function compressFile(file, size) {
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var compress = new Compress();
      compress.compress([file], {
        size: size,
        quality: 0.9,
        maxWidth: 1920,
        maxHeight: 1920,
        resize: true // default
      }).then(function (results) {
        var img1 = results[0];
        var base64str = img1.data;
        var imgExt = img1.ext;
        var compressedFile = Compress.convertBase64ToFile(base64str, imgExt);
        compressedFile.name = file.name;
        compressedFile.lastModifiedDate = new Date();
        resolve(new File([compressedFile], file.name));
      }).catch(function (err) {
        reject(err);
      });
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "uploadFile", function uploadFile(file) {
    var compress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var _success = arguments[2];

    var _this4 = this;

    var _error = arguments[3];
    var done = arguments[4];
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var uploadData, uploadGuid;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!compress) {
                _context3.next = 4;
                break;
              }

              _context3.next = 3;
              return _this4.compressFile(file, 1).catch(function (err) {
                console.error("Error while compressing");
                console.error(err);
                _this4.$emit("openGlobalErrorDialog", { errorText: _this4.lang.G00033, colorOrange: false });
              });

            case 3:
              file = _context3.sent;

            case 4:
              uploadData = new FormData();

              uploadData.append("file", file, file.name);
              uploadGuid = uuidv4();

              _this4.pendingUploads[uploadGuid] = {};
              _this4.pendingUploads[uploadGuid].request = $.ajax({
                method: "POST",
                url: "api/Upload",
                data: uploadData,
                dataType: "json",
                contentType: false,
                processData: false,
                global: false,
                xhr: function xhr() {
                  var xhr = $.xhr();
                  if (xhr.upload) {
                    _this4.pendingUploads[uploadGuid].sizes = [0, file.size, 0];

                    xhr.upload.addEventListener("progress", function (e) {
                      if (e.lengthComputable && _this4.pendingUploads[uploadGuid]) {
                        _this4.pendingUploads[uploadGuid].sizes = [e.loaded, e.total, e.loaded / e.total];
                        _this4.calculateUploadProgress();
                      }
                    }, false);
                  }
                  return xhr;
                },
                success: function success(data) {
                  if (_success) _success(data);
                },
                error: function error(err) {
                  if (err.statusText === "abort") {
                    console.error("Upload canceled by user");
                    _this4.globals.$emit("openGlobalErrorDialog", { errorText: _this4.lang.G00001, colorOrange: false });
                  } else {
                    console.error("Error on POST in uploadFile()");
                    _this4.globals.$emit("openGlobalErrorDialog", { errorText: _this4.lang.G00002, colorOrange: false });
                    delete _this4.pendingUploads[uploadGuid];
                  }
                  if (_error) _error();
                },
                complete: function complete() {
                  _this4.calculateUploadProgress();
                  if (done) done();
                }
              });

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this4);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "uploadFilesv2", function uploadFilesv2(files) {
    var _this5 = this;

    var compress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var compressedFiles, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, file, uploadProcesses;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!compress) {
                _context4.next = 31;
                break;
              }

              compressedFiles = [];
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context4.prev = 5;
              _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(files);

            case 7:
              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                _context4.next = 16;
                break;
              }

              file = _step.value;
              _context4.next = 11;
              return _this5.compressFile(file, 1).catch(function (err) {
                console.error("Error while compressing");
                console.error(err);
                _this5.globals.$emit("openGlobalErrorDialog", { errorText: _this5.lang.G00033, colorOrange: false });
              });

            case 11:
              file = _context4.sent;

              compressedFiles.push(file);

            case 13:
              _iteratorNormalCompletion = true;
              _context4.next = 7;
              break;

            case 16:
              _context4.next = 22;
              break;

            case 18:
              _context4.prev = 18;
              _context4.t0 = _context4["catch"](5);
              _didIteratorError = true;
              _iteratorError = _context4.t0;

            case 22:
              _context4.prev = 22;
              _context4.prev = 23;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 25:
              _context4.prev = 25;

              if (!_didIteratorError) {
                _context4.next = 28;
                break;
              }

              throw _iteratorError;

            case 28:
              return _context4.finish(25);

            case 29:
              return _context4.finish(22);

            case 30:
              files = compressedFiles;

            case 31:
              uploadProcesses = [];

              files.map(function (file) {
                uploadProcesses.push(__WEBPACK_IMPORTED_MODULE_10__services_uploadService__["a" /* default */].upload(file));
              });
              return _context4.abrupt("return", __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(uploadProcesses));

            case 34:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this5, [[5, 18, 22, 30], [23,, 25, 29]]);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "uploadFilesv3", function uploadFilesv3(files) {
    var compress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var _this6 = this;

    var offline = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var baseKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var compressedFiles, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, file, blob, f, uploadProcesses;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (!compress) {
                _context5.next = 38;
                break;
              }

              compressedFiles = [];
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context5.prev = 5;
              _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(files);

            case 7:
              if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                _context5.next = 23;
                break;
              }

              file = _step2.value;

              if (_this6.isImageType(file)) {
                _context5.next = 13;
                break;
              }

              compressedFiles.push(file);
              _context5.next = 20;
              break;

            case 13:
              _context5.next = 15;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__services_Imagecompressions__["a" /* reduceFileSize */])(file, 500 * 1024, 1920, 1920, 0.9);

            case 15:
              blob = _context5.sent;
              _context5.next = 18;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__services_Imagecompressions__["b" /* blobToFile */])(blob, file);

            case 18:
              f = _context5.sent;

              compressedFiles.push(f);

            case 20:
              _iteratorNormalCompletion2 = true;
              _context5.next = 7;
              break;

            case 23:
              _context5.next = 29;
              break;

            case 25:
              _context5.prev = 25;
              _context5.t0 = _context5["catch"](5);
              _didIteratorError2 = true;
              _iteratorError2 = _context5.t0;

            case 29:
              _context5.prev = 29;
              _context5.prev = 30;

              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }

            case 32:
              _context5.prev = 32;

              if (!_didIteratorError2) {
                _context5.next = 35;
                break;
              }

              throw _iteratorError2;

            case 35:
              return _context5.finish(32);

            case 36:
              return _context5.finish(29);

            case 37:
              files = compressedFiles;

            case 38:
              uploadProcesses = [];

              if (offline) {
                uploadProcesses = files.map(function (file) {
                  return __WEBPACK_IMPORTED_MODULE_10__services_uploadService__["a" /* default */].uploadOffline(baseKey, file);
                });
              } else {
                uploadProcesses = files.map(function (file) {
                  return __WEBPACK_IMPORTED_MODULE_10__services_uploadService__["a" /* default */].uploadOnline(file);
                });
              }
              return _context5.abrupt("return", __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(uploadProcesses));

            case 41:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this6, [[5, 25, 29, 37], [30,, 32, 36]]);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "uploadFilev3", function uploadFilev3(file) {
    var compress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var _this7 = this;

    var offline = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var baseKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var blob;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (!(compress && _this7.isImageType(file))) {
                _context6.next = 7;
                break;
              }

              _context6.next = 3;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__services_Imagecompressions__["a" /* reduceFileSize */])(file, 500 * 1024, 1920, 1920, 0.9);

            case 3:
              blob = _context6.sent;
              _context6.next = 6;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__services_Imagecompressions__["b" /* blobToFile */])(blob, file);

            case 6:
              file = _context6.sent;

            case 7:
              if (!offline) {
                _context6.next = 13;
                break;
              }

              _context6.next = 10;
              return __WEBPACK_IMPORTED_MODULE_10__services_uploadService__["a" /* default */].uploadOffline(baseKey, file);

            case 10:
              return _context6.abrupt("return", _context6.sent);

            case 13:
              _context6.next = 15;
              return __WEBPACK_IMPORTED_MODULE_10__services_uploadService__["a" /* default */].uploadOnline(file, function (progressEvent) {
                _this7.currentUploadProgress = parseInt(Math.round(progressEvent.loaded / progressEvent.total * 100));
              });

            case 15:
              return _context6.abrupt("return", _context6.sent);

            case 16:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this7);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "calculateUploadProgress", function calculateUploadProgress() {
    var sumLoaded = 0,
        sumTotal = 0,
        countDone = 0;
    var count = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.pendingUploads).length;

    for (var upload in this.pendingUploads) {
      sumLoaded += this.pendingUploads[upload].sizes[0];
      sumTotal += this.pendingUploads[upload].sizes[1];
      countDone += this.pendingUploads[upload].sizes[2];
    }

    if (count < 1 || countDone == count) {
      this.currentUploadProgress = 100;
      this.pendingUploads = {};
      return;
    }
    this.currentUploadProgress = Number((sumLoaded * 100 / sumTotal).toFixed(0));
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "cancelPendingUploads", function cancelPendingUploads() {
    var _this8 = this;

    this.$nextTick(function () {
      for (var guid in _this8.pendingUploads) {
        _this8.pendingUploads[guid].request.abort();
      }
      _this8.pendingUploads = {};
      // the modal automatically opens when progress is below 50 so set it higher
      _this8.currentUploadProgress = 100;
      //Stops the activ loading (Like clicking stop in the browser)
      window.stop();
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "isValidFileType", function isValidFileType(file, acceptedTypes) {
    if (!acceptedTypes) return true;
    var types = _.split(_.replace(acceptedTypes, / /g, ""), ",");

    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(types), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var type = _step3.value;

        if (type === "image/*" && _.startsWith(file.type, "image/") || type === "video/*" && _.startsWith(file.type, "video/") || type === "audio/*" && _.startsWith(file.type, "audio/")) return true;

        if (file.type === type) return true;

        if (_.startsWith(type, ".") && _.endsWith(file.name, type)) return true;
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    return false;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "getRegionsList", function getRegionsList(callback) {
    var _this9 = this;

    if (!_.isEmpty(this.regionsList)) {
      callback(this.regionsList);
      return;
    }

    var queryString = "api/Data/Regions";
    $.ajax({
      method: "GET",
      url: queryString,
      success: function success(data) {
        _this9.regionsList = data;
        callback(_this9.regionsList);
      },
      error: function error() {
        console.error("Error on GET in getRegionsList()");
        _this9.globals.$emit("openGlobalErrorDialog", { errorText: _this9.lang.G00009, colorOrange: false });
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "getLanguageStrings", function getLanguageStrings(that, success, error) {
    var _this10 = this;

    if (that.$options.name && this.langCache[that.$options.name]) {
      that.lang = this.langCache[that.$options.name];
      if (success) success();
      return;
    }
    var langKeys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(that.lang);

    __WEBPACK_IMPORTED_MODULE_11__services_Language__["a" /* default */].getTranslationfor(langKeys).then(function (_ref) {
      var data = _ref.data;

      var dataKeys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data);
      if (dataKeys.length == langKeys.length) that.lang = data;else {
        for (var i = 0; i < dataKeys.length; i++) {
          that.lang[dataKeys[i]] = data[dataKeys[i]];
        }
      }
      if (that.$options.name) _this10.langCache[that.$options.name] = that.lang;
      if (success) success();
    }).catch(function (err) {
      if (err.status === 0 || err.status === 401) return; // Request canceled or unauthorized
      console.error("Language data access failed in getLanguageStrings()", err);
      _this10.$emit("openGlobalErrorDialog", { errorText: _this10.lang.G00003, colorOrange: false });
      if (error) error(err);
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "getCurrentUserInfo", function getCurrentUserInfo(callback, errorCallback) {
    var _this11 = this;

    $.ajax({
      method: "GET",
      url: "api/SecurityUsers/Current",
      success: function success(data) {
        _this11.currentUserInfo = data;
        _this11.selectedLanguage = data.FrontendLanguageCode;
        _this11.$emit("currentUserInfoReceived");
        if (callback) callback();
      },
      error: function error() {
        console.error("Userdata access failed in getCurrentUserInfo()");
        _this11.currentUserInfo = null;
        if (errorCallback) errorCallback();
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "isAccessAllowed", function isAccessAllowed(policy) {
    if (!policy || !this.currentUserInfo || !this.currentUserInfo.Policies) return false;

    var idx = this.currentUserInfo.Policies.indexOf(policy);
    if (idx < 0) return false;
    return true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "getCountryList", function getCountryList(callback) {
    var _this12 = this;

    if (!_.isEmpty(this.countryList)) {
      if (callback) callback(this.countryList);
      return;
    }

    var queryString = "api/Data/Countries";
    $.ajax({
      method: "GET",
      url: queryString,
      success: function success(data) {
        _this12.countryList = data;
        if (callback) callback(_this12.countryList);
      },
      error: function error() {
        console.error("Error on GET in getCountryList()");
        _this12.globals.$emit("openGlobalErrorDialog", { errorText: _this12.lang.G00004, colorOrange: false });
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "getOccupationalGroupList", function getOccupationalGroupList(callback) {
    var _this13 = this;

    if (!_.isEmpty(this.occupationalGroupList)) {
      callback(this.occupationalGroupList);
      return;
    }

    var queryString = "api/Data/OccupationalGroup";
    $.ajax({
      method: "GET",
      url: queryString,
      success: function success(data) {
        _this13.occupationalGroupList = data;
        callback(_this13.occupationalGroupList);
      },
      error: function error() {
        console.error("Error on GET in getOccupationalGroupList()");
        _this13.globals.$emit("openGlobalErrorDialog", { errorText: _this13.lang.G00005, colorOrange: false });
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "getPasswordPolicyList", function getPasswordPolicyList(callback) {
    var _this14 = this;

    if (!_.isEmpty(this.passwordPolicyList)) {
      callback(this.passwordPolicyList);
      return;
    }

    var queryString = "api/Data/PasswordPolicy";
    $.ajax({
      method: "GET",
      url: queryString,
      success: function success(data) {
        _this14.passwordPolicyList = data;
        callback(_this14.passwordPolicyList);
      },
      error: function error() {
        console.error("Error on GET in getPasswordPolicyList()");
        _this14.globals.$emit("openGlobalErrorDialog", { errorText: _this14.lang.G00006, colorOrange: false });
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "getSettlementStatusList", function getSettlementStatusList(callback) {
    var _this15 = this;

    if (!_.isEmpty(this.settlementStatusList)) {
      callback(this.settlementStatusList);
      return;
    }

    var queryString = "api/Data/SettlementStatusses";
    $.ajax({
      method: "GET",
      url: queryString,
      success: function success(data) {
        _this15.settlementStatusList = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data).map(function (key) {
          return {
            SettlementStatusGuid: key,
            SettlementStatusText: data[key]
          };
        });
        callback(_this15.settlementStatusList);
      },
      error: function error() {
        console.error("Error on GET in getSettlementStatusList()");
        _this15.globals.$emit("openGlobalErrorDialog", { errorText: _this15.lang.G00007, colorOrange: false });
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "isLargeScreen", function isLargeScreen() {
    return $(window).width() > 1200;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "isMediumScreen", function isMediumScreen() {
    var width = $(window).width();
    return width <= 1200 && width > 1000;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "isSmallScreen", function isSmallScreen() {
    return $(window).width() <= 1000;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "isScreenOrientationLandscape", function isScreenOrientationLandscape() {
    return $(window).width() > $(window).height() * (13 / 9);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "getLocalizedDateFromIsoTimestamp", function getLocalizedDateFromIsoTimestamp(isoTimestamp) {
    return __WEBPACK_IMPORTED_MODULE_8_moment___default()(isoTimestamp).format(this.currentDateFormatForMoment);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "getLocalizedDateTimeFromIsoTimestamp", function getLocalizedDateTimeFromIsoTimestamp(isoTimestamp) {
    return __WEBPACK_IMPORTED_MODULE_8_moment___default()(isoTimestamp).format(this.currentDateTimeFormatForMoment);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "getLocalizedDateTimeFromUtcIsoTimestamp", function getLocalizedDateTimeFromUtcIsoTimestamp(isoTimestamp) {
    return __WEBPACK_IMPORTED_MODULE_8_moment___default.a.utc(isoTimestamp).local().format(this.currentDateTimeFormatForMoment);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "getImageOrientation", function getImageOrientation(image, callback) {
    if (!image) return;

    var reader = new FileReader();

    reader.onload = function (event) {
      var view = new DataView(event.target.result);

      if (view.getUint16(0, false) != 0xffd8) return callback(-2);

      var length = view.byteLength,
          offset = 2;

      while (offset < length) {
        var marker = view.getUint16(offset, false);
        offset += 2;

        if (marker == 0xffe1) {
          if (view.getUint32(offset += 2, false) != 0x45786966) {
            return callback(-1);
          }
          var little = view.getUint16(offset += 6, false) == 0x4949;
          offset += view.getUint32(offset + 4, little);
          var tags = view.getUint16(offset, little);
          offset += 2;

          for (var i = 0; i < tags; i++) {
            if (view.getUint16(offset + i * 12, little) == 0x0112) return callback(view.getUint16(offset + i * 12 + 8, little));
          }
        } else if ((marker & 0xff00) != 0xff00) break;else offset += view.getUint16(offset, false);
      }
      return callback(-1);
    };

    reader.readAsArrayBuffer(image.slice(0, 64 * 1024));
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "isImageType", function isImageType(img) {
    if (!img) return false;
    return _.startsWith(img.type, "image");
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "resetImageOrientation", function resetImageOrientation(srcImage, srcOrientation, callback) {
    var _this16 = this;

    if (srcOrientation === 1) {
      callback(srcImage);
      return;
    }

    var img = new Image();

    img.onload = function () {
      var width = img.width,
          height = img.height,
          canvas = document.createElement("canvas"),
          ctx = canvas.getContext("2d");

      // set proper canvas dimensions before transform & export
      if (4 < srcOrientation && srcOrientation < 9) {
        canvas.width = height;
        canvas.height = width;
      } else {
        canvas.width = width;
        canvas.height = height;
      }

      // transform context before drawing image
      switch (srcOrientation) {
        case 2:
          ctx.transform(-1, 0, 0, 1, width, 0);
          break;
        case 3:
          ctx.transform(-1, 0, 0, -1, width, height);
          break;
        case 4:
          ctx.transform(1, 0, 0, -1, 0, height);
          break;
        case 5:
          ctx.transform(0, 1, 1, 0, 0, 0);
          break;
        case 6:
          ctx.transform(0, 1, -1, 0, height, 0);
          break;
        case 7:
          ctx.transform(0, -1, -1, 0, height, width);
          break;
        case 8:
          ctx.transform(0, -1, 1, 0, 0, width);
          break;
        default:
          break;
      }

      // draw image
      ctx.drawImage(img, 0, 0);

      var file = _this16.dataURItoBlob(canvas.toDataURL(srcImage.type));
      file.name = srcImage.name;
      file.lastModifiedDate = new Date();

      // export base64
      callback(file);
    };

    img.src = srcImage.imageUrl;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "dataURItoBlob", function dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(",")[0].indexOf("base64") >= 0) byteString = atob(dataURI.split(",")[1]);else byteString = unescape(dataURI.split(",")[1]);
    // separate out the mime component
    var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ia], { type: mimeString });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "truncateString", function truncateString(str, maxLength) {
    if (!str || typeof str !== "string") return "";
    return _.truncate(str, {
      length: maxLength,
      separator: " "
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "toBase64", function toBase64(file) {
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        return resolve(reader.result);
      };
      reader.onerror = function (error) {
        return reject(error);
      };
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "getMarkupText", function getMarkupText(html) {
    if (!html || typeof html !== "string") return "";
    var container = document.createElement("DIV");
    container.innerHTML = html;
    return container.textContent || container.innerText || "";
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "isLocalizedDateTodayOrBefore", function isLocalizedDateTodayOrBefore(date) {
    var momentDate = __WEBPACK_IMPORTED_MODULE_8_moment___default()(date, this.currentDateFormatForMoment);
    return momentDate.isValid() && this.isISODateTodayOrBefore(momentDate);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "isISODateTodayOrBefore", function isISODateTodayOrBefore(date) {
    if (!date) return false;
    var momentDate = __WEBPACK_IMPORTED_MODULE_8_moment___default()(date);
    if (!momentDate.isValid()) return false;
    var today = __WEBPACK_IMPORTED_MODULE_8_moment___default()(new Date());
    return momentDate.isSameOrBefore(today, "day");
  }), _methods),
  watch: {
    selectedLanguage: function selectedLanguage(newLanguage) {
      if (newLanguage) {
        this.langCache = {};
        this.getLanguageStrings(this);
        this.localizeFlatpickrConfig();
        this.countryList = {};
        this.regionsList = [];
        this.occupationalGroupList = {};
      }
    }
  },
  data: function data() {
    return {
      progressInfos: [],
      isSurveyCodeUser: false,
      currentUserInfo: null,
      countryList: {},
      regionsList: [],
      occupationalGroupList: {},
      passwordPolicyList: [],
      settlementStatusList: [],
      selectedLanguage: "",
      spinnerVisible: false,
      tooltipDelay: {
        show: 500,
        hide: 100
      },
      /**
       * We used to have clickOpens: false,
       * This was to manually call open() ,but it breaks mobile views so we use the default onClick from flatpickr now
       */
      flatpickrDateConfig: {
        altInput: true,
        altFormat: "Y-m-d",
        dateFormat: "Y-m-d",
        defaultDate: [""],
        locale: "en"
      },
      flatpickrIsoDateConfig: {
        altInput: true,
        altFormat: "Y-m-d",
        dateFormat: "Z",
        defaultDate: [""],
        locale: "en"
      },
      flatpickrTimeConfig: {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
        locale: "en"
      },
      flatpickrDatetimeConfig: {
        altInput: true,
        altFormat: "Y-m-d H:i",
        enableTime: true,
        dateFormat: "Y-m-d H:i",
        time_24hr: true,
        locale: "en"
      },
      snackbarConfig: {
        content: "", // text of the snackbar
        style: "",
        timeout: 5000,
        htmlAllowed: false
      },
      pendingUploads: {},
      currentUploadProgress: 100,
      langCache: {},
      lang: {
        G00000: "No results found",
        G00001: "Upload canceled",
        G00002: "Upload failed",
        G00003: "Language data access failed",
        G00004: "Country data request failed",
        G00005: "Occupational group data request failed",
        G00006: "Password policy data request failed",
        G00007: "Invoice status list data request failed",
        G00009: "Region data request failed",
        G00023: "Success",
        G00024: "Error"
      }
    };
  }
});

/* harmony default export */ __webpack_exports__["a"] = (globals);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),

/***/ 94:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FILES_STORE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SURVEY_STORE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TICKETS_STORE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DB_NAME; });
var FILES_STORE_NAME = "Files";
var SURVEY_STORE_NAME = "SurveyInstances";
var TICKETS_STORE_NAME = "Tickets";
var DB_NAME = "MSM_LOOPDBv2";

/***/ }),

/***/ 998:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 999:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[1088]);


// WEBPACK FOOTER //
// static/js/app.93e1c0a57f2261187e81.js